<template>
  <div id="player-wrapper" class="without-header">
    <!-- <div id="local-player" class="player"></div> -->
    <!-- <div @click="testPermission">CLICK</div> -->
    <div v-if="displayInviteToStage" class="single-notification">
      <div class="notification-content">
        <!--<span class="notification-close" @click="onHideNotification">x</span>-->
        <!-- <div class="notification-image">
          <img src="../assets/Images/clock1.svg" alt="ni" />
        </div> -->
        <div>
          <p class="notification-text">You are invited to stage</p>
          <div class="notification-btn">
            <v-btn
              width="110px"
              outline
              color="#1ab063"
              class="chat-mouse-pointer mr-2 accept-call"
              dark
              @click="AcceptToEnterStage(true)"
              ><v-icon color="#fff" size="20px">mdi-check</v-icon>
              Accept
            </v-btn>
            <v-btn
              width="110px"
              color="#eb4e37"
              dark
              class="ml-1 chat-mouse-pointer decline-call"
              @click="AcceptToEnterStage(false)"
              ><v-icon color="#fff" size="20px">mdi-close</v-icon>Decline
            </v-btn>
          </div>
        </div>
      </div>
    </div>
    <div
      id="enableModalCenter"
      class="player-modal"
      v-show="showMicCamPermission"
    >
      <div class="custom-modal-wrapper">
        <div class="custom-modal-inner position-relative" role="document">
          <div style="position: absolute; right: 10px; top: 10px; width: 24px">
            <v-icon
              v-show="!isGuestSpeaker && !readyState"
              style="background: #fff; border-radius: 50%; z-index: 5"
              size="24"
              @click="cancelJoin"
              >close</v-icon
            >
          </div>
          <div class="custom-modal-body">
            <div class="custom-modal-content">
              <div
                class="inner-allow-body2"
                :style="
                  showTestStream ? 'background: none' : 'background: none'
                "
              >
                <div class="row">
                  <div class="col-md-7">
                    <div
                      v-if="userVirtualBGEnabled && showVirtualBGConfig"
                      class="background-choose-section"
                    >
                      <div class="background-choose-header">
                        <div
                          class="d-flex justify-content-between align-items-center"
                        >
                          <h4>Choose a Background</h4>
                          <v-btn
                            v-if="!readyState"
                            icon
                            small
                            color="#fff"
                            @click="showVirtualBGConfig = false"
                            ><v-icon color="#333" size="20px"
                              >mdi-close</v-icon
                            ></v-btn
                          >
                        </div>
                        <!-- <p>
                          Supported file format jpeg, jpg and png only, minimum
                          dimension of 800 x 600px
                        </p> -->
                        <!-- - {{userVirtualBGType}}-{{userVirtualBG}} -->
                        <ul class="background-choose-tabs">
                          <li>
                            <v-btn
                              depressed
                              outlined
                              color="#1a73e8"
                              @click="
                                userVirtualBGType = 0;
                                userVirtualBG = '';
                              "
                              :class="{ selected: userVirtualBGType == 0 }"
                              ><v-icon size="22px" color="#1a73e8"
                                >mdi-cancel</v-icon
                              ></v-btn
                            >
                          </li>
                          <li>
                            <v-btn
                              depressed
                              outlined
                              color="#1a73e8"
                              @click="
                                virtualBGConfigInProgress
                                  ? null
                                  : reOpenVirtualBGConfig(
                                      1,
                                      userVirtualBGTab,
                                      ''
                                    )
                              "
                              :class="{ selected: userVirtualBGType == 1 }"
                              ><v-icon size="22px" color="#1a73e8"
                                >mdi-blur</v-icon
                              ></v-btn
                            >
                          </li>
                          <li class="d-none">
                            <v-btn
                              depressed
                              outlined
                              color="#1a73e8"
                              @click="
                                userVirtualBGType = 2;
                                userVirtualBGTab = 2;
                              "
                              :class="{ selected: userVirtualBGType == 2 }"
                              ><v-icon size="22px" color="#1a73e8"
                                >mdi-file-image-outline</v-icon
                              ></v-btn
                            >
                          </li>
                          <li class="d-none">
                            <v-btn
                              depressed
                              outlined
                              color="#1a73e8"
                              @click="
                                userVirtualBGType = 3;
                                userVirtualBGTab = 3;
                              "
                              :class="{ selected: userVirtualBGType == 3 }"
                              ><v-icon size="22px" color="#1a73e8"
                                >mdi-format-color-fill</v-icon
                              ></v-btn
                            >
                          </li>
                        </ul>
                        <div
                          class="background-option-tab"
                          style="height: 227px"
                        >
                          <div
                            v-if="userVirtualBGTab == 2"
                            class="background-showcase-hld mt-2"
                          >
                            <h5>Background Images</h5>
                            <ul>
                              <li class="d-none">
                                <v-icon size="22px" color="#1a73e8"
                                  >mdi-plus-circle-outline</v-icon
                                >
                              </li>
                              <li
                                v-for="(item, index) in userVirtualBGImages"
                                :key="'userVirtualBGImages_' + index"
                                @click="
                                  virtualBGConfigInProgress
                                    ? null
                                    : reOpenVirtualBGConfig(2, 2, item)
                                "
                                :class="{ selected: item == userVirtualBG }"
                              >
                                <img :src="item" />
                                <img
                                  v-if="item == userVirtualBG"
                                  class="selected"
                                  height="20px"
                                  width="20px"
                                  src="../../../assets/Player/images/check-img.svg"
                                />
                                <div
                                  v-show="
                                    showTestStream &&
                                    isVideoOn &&
                                    userVirtualBGType == 2 &&
                                    virtualBGConfigInProgress &&
                                    item == userVirtualBG
                                  "
                                  style="
                                    position: absolute;
                                    height: 100%;
                                    width: 100%;
                                    z-index: 3;
                                    display: flex;
                                    align-items: center;
                                    justify-content: center;
                                  "
                                >
                                  <v-progress-circular
                                    size="30"
                                    indeterminate
                                    color="primary"
                                  ></v-progress-circular>
                                </div>
                              </li>
                            </ul>
                          </div>
                          <div
                            v-if="userVirtualBGTab == 3"
                            class="background-showcase-hld myuploads mt-2"
                          >
                            <h5>Background Colors</h5>
                            <ul>
                              <li class="d-none">
                                <v-icon size="22px" color="#1a73e8"
                                  >mdi-plus-circle-outline</v-icon
                                >
                              </li>
                              <li
                                v-for="(item, index) in userVirtualBGColors"
                                :key="'userVirtualBGColors_' + index"
                                @click="
                                  virtualBGConfigInProgress
                                    ? null
                                    : reOpenVirtualBGConfig(3, 3, item)
                                "
                                :style="'background-color:' + item"
                                :class="{ selected: item == userVirtualBG }"
                              >
                                <img
                                  v-if="item == userVirtualBG"
                                  class="selected"
                                  height="20px"
                                  width="20px"
                                  src="../../../assets/Player/images/check-img.svg"
                                />
                                <div
                                  v-show="
                                    showTestStream &&
                                    isVideoOn &&
                                    userVirtualBGType == 2 &&
                                    virtualBGConfigInProgress &&
                                    item == userVirtualBG
                                  "
                                  style="
                                    position: absolute;
                                    height: 100%;
                                    width: 100%;
                                    z-index: 3;
                                    display: flex;
                                    align-items: center;
                                    justify-content: center;
                                  "
                                >
                                  <v-progress-circular
                                    size="30"
                                    indeterminate
                                    color="primary"
                                  ></v-progress-circular>
                                </div>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div v-if="!showVirtualBGConfig" class="allow-msg-div">
                      <h3>
                        {{ $t("agoracall.abouttojoinsessionas") }}
                        {{ attendeeTypeName }}
                      </h3>
                      <!-- <input type="number" v-model="blurLevel" /> -->
                      <p style="margin-top: 20px">
                        {{ $t("agoracall.whatwillyouneed") }}
                      </p>
                      <div class="validation-check-sec">
                        <ul>
                          <li>
                            <span
                              :class="
                                isSupportedBrowser ? 'active' : 'vitality'
                              "
                              ><img
                                src="@/assets/Player/images/browser.svg"
                                alt="Browser"
                            /></span>
                            {{ $t("agoracall.chromeoredge") }}
                          </li>
                          <li>
                            <span
                              :class="isSupportedDevice ? 'active' : 'vitality'"
                              ><img
                                src="@/assets/Player/images/device.svg"
                                alt="Device"
                            /></span>
                            {{ $t("agoracall.desktoplandscapeview") }}
                          </li>
                          <li>
                            <span
                              :class="
                                IsMicExist &&
                                IsCameraExist &&
                                hasMicAccess &&
                                hasCamAccess
                                  ? 'active'
                                  : !hasMicAccess || !hasCamAccess
                                  ? 'inactive'
                                  : 'vitality'
                              "
                              ><img
                                src="@/assets/Player/images/camera-mic.svg"
                                alt="Camera and Mic"
                            /></span>
                            {{ $t("agoracall.camera") }} &amp;
                            {{ $t("agoracall.micpermission") }}
                          </li>
                        </ul>
                      </div>
                      <div class="validation-button mt-0" style="height: 20px">
                        <div
                          v-show="micAccessChecked && camAccessChecked && false"
                        >
                          <div
                            v-show="IsMicExist || hasMicAccess"
                            class="d-flex pre-call-test-btn"
                          >
                            <div class="px-4" style="display: inline-flex">
                              <i
                                :class="
                                  isMicOn
                                    ? 'ag-icon ag-icon-mic'
                                    : 'ag-icon ag-icon-mic-off'
                                "
                              >
                                <img
                                  v-if="isMicOn"
                                  height="30"
                                  width="30"
                                  src="../../../assets/Images/unmute.svg"
                                />
                                <img
                                  v-else
                                  height="30"
                                  width="30"
                                  src="../../../assets/Images/mute.svg"
                                />
                              </i>
                              <v-switch
                                dense
                                messages=""
                                color="#1a73e8"
                                class="mt-0"
                                v-model="isMicOn"
                              ></v-switch>
                            </div>
                            <div class="px-4" style="display: inline-flex">
                              <i
                                :class="
                                  isVideoOn
                                    ? 'ag-icon ag-icon-camera'
                                    : 'ag-icon ag-icon-camera-off'
                                "
                              >
                                <img
                                  v-if="isVideoOn"
                                  height="30"
                                  width="30"
                                  src="../../../assets/Images/video-camera.svg"
                                />
                                <img
                                  v-else
                                  height="30"
                                  width="30"
                                  src="../../../assets/Images/video-off.svg"
                                />
                              </i>
                              <v-switch
                                dense
                                messages=""
                                color="#1a73e8"
                                class="mt-0"
                                v-model="isVideoOn"
                              ></v-switch>
                            </div>
                            <div class="px-4" style="display: inline-flex">
                              <a
                                href="javascript:(0);"
                                class="join-button"
                                style="
                                  width: 80px;
                                  background-image: none !important;
                                  padding: 6px;
                                  height: 36px;
                                "
                                @click="applyMicCamAccess()"
                              >
                                {{ $t("agoracall.join") }}
                              </a>
                            </div>
                          </div>
                          <!-- <div >
                            <span>Mic</span>
                            <v-switch
                              color="#1a73e8"
                              :disabled="!IsMicExist"
                              v-model="hasMicAccess"
                            ></v-switch>
                          </div> -->
                          <!-- <div>
                            <span>Cam</span>
                            <v-switch
                              color="#1a73e8"
                              :disabled="!IsCameraExist"
                              v-model="hasCamAccess"
                            ></v-switch>
                          </div> -->
                          <!--v-show="IsMicExist && IsCameraExist && hasMicAccess && hasCamAccess"-->
                          <span v-show="!IsMicExist || !hasMicAccess">
                            {{ $t("agoracall.checkmicandcamera") }}
                          </span>
                          <!--<a
                            v-show="!IsMicExist || !hasMicAccess"
                            href="javascript:(0);"
                            class="joinasaud"
                            @click="applyMicCamAccess(false, false)"
                            >{{ $t("agoracall.joinasaudience") }}</a
                          >-->
                          <!--<a
                              href="javascript:(0);"
                              class="enable-button"
                              @click="applyMicCamAccess(true, true)"
                              >Enable camera &amp; mic</a
                            >-->
                          <a
                            v-show="IsMicExist && hasMicAccess && false"
                            href="javascript:(0);"
                            class="without-enable-button"
                            @click="applyMicCamAccess(true, false)"
                            >{{ $t("agoracall.joinwithoutcamera") }}</a
                          >
                          <a
                            v-show="
                              IsMicExist &&
                              IsCameraExist &&
                              hasMicAccess &&
                              hasCamAccess &&
                              false
                            "
                            href="javascript:(0);"
                            class="join-button"
                            @click="applyMicCamAccess(true, true)"
                            >{{ $t("agoracall.joinwithcamera") }}</a
                          >
                          <!-- <a
                            v-show="
                              IsMicExist &&
                              IsCameraExist &&
                              hasMicAccess &&
                              hasCamAccess
                            "
                            href="javascript:(0);"
                            class="join-button"
                            @click="applyMicCamAccess(false, false)"
                            >{{ "Join As Audience" }}</a
                          > -->
                        </div>
                      </div>
                      <p class="caution">
                        <span>*</span>{{ $t("agoracall.pleaseensure") }}
                        <b>{{ $t("agoracall.safarinotrecommended") }}</b>
                      </p>
                    </div>
                  </div>
                  <div class="col-md-5">
                    <div class="pre-call-test-wrap">
                      <div
                        class="justify-content-center align-items-center position-relative"
                        style="
                          display: flex;
                          border-radius: 10px;
                          height: 225px;
                          width: 300px;
                          background: #202124;
                          color: #fff;
                        "
                      >
                        <div
                          v-if="
                            userVirtualBGEnabled &&
                            !showVirtualBGConfig &&
                            hasCamAccess
                          "
                          class="background-choose-button"
                          @click="
                            !showVirtualBGConfig
                              ? (showVirtualBGConfig = true)
                              : null
                          "
                        >
                          <v-btn
                            dark
                            icon
                            elevation="5"
                            color="#ffffff"
                            style="opacity: 0.6"
                            ><v-icon size="25px" color="#5f6368"
                              >auto_awesome</v-icon
                            ></v-btn
                          >
                        </div>
                        <div
                          style="
                            border-radius: 10px;
                            overflow: hidden;
                            height: 225px;
                            width: 300px;
                            position: relative;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                          "
                        >
                          <video
                            v-show="showTestStream && isVideoOn"
                            id="videoTest"
                            autoplay="true"
                            style="height: 100%; width: 100%"
                          ></video>
                          <!-- <div>
                            <b>pre-call-test-wrap</b><br />
                            showTestStream:{{ showTestStream }}<br />
                            isVideoOn:{{ isVideoOn }}<br />
                            userVirtualBGType:{{ userVirtualBGType }}<br />
                            virtualBGConfigInProgress:{{
                              virtualBGConfigInProgress
                            }}
                          </div> -->
                          <!-- <div
                            v-show="
                              showTestStream &&
                              isVideoOn &&
                              userVirtualBGType > 0 &&
                              virtualBGConfigInProgress
                            "
                            style="
                              position: absolute;
                              height: 100%;
                              width: 100%;
                              z-index: 3;
                              display: flex;
                              align-items: center;
                              justify-content: center;
                            "
                          >
                            <v-progress-circular
                              size="30"
                              indeterminate
                              color="primary"
                            ></v-progress-circular>
                          </div> -->
                          <video
                            v-show="showTestStream && isVideoOn && false"
                            id="videoTest11"
                            src="https://mdn.github.io/dom-examples/canvas/chroma-keying/media/video.mp4"
                            autoplay
                            playsinline
                            style="
                              top: 100;
                              left: 100;
                              height: 100%;
                              width: 100%;
                            "
                            crossorigin="anonymous"
                            controls
                            muted
                            loop
                          ></video>
                          <canvas
                            v-show="showTestStream && isVideoOn && false"
                            id="userPreviewCanvas1"
                            height="225"
                            width="300"
                          >
                          </canvas>
                          <canvas
                            v-show="
                              showTestStream &&
                              isVideoOn &&
                              userVirtualBGType > 0
                            "
                            id="userPreviewCanvas2"
                            height="225"
                            width="300"
                          >
                          </canvas>
                          <div
                            v-show="!showTestStream || !isVideoOn"
                            class="position-relative"
                          >
                            <!-- <h1 class="d-none1">Camera Off</h1> -->
                            <div class="ag-profile-image name-initial">
                              <img
                                v-if="profilePictureURL && false"
                                v-bind:src="profilePictureURL"
                              />
                              <h4 v-else-if="nameInitial" class="user-initial">
                                {{ nameInitial }}
                              </h4>
                              <img
                                v-else
                                src="../../../assets/Images/common-avatar.svg"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div v-if="readyState" class="mt-6">
                        <div
                          class="d-flex justify-content-center align-items-center"
                        >
                          <div class="px-2">
                            <v-btn
                              color="#19a883"
                              height="32px"
                              width="60px"
                              class="text-initial"
                              style="color: #fff; font-size: 14px"
                              @click="closeVirtualBGConfig()"
                              :disabled="!IsMicExist || !hasMicAccess"
                            >
                              {{ $t("agoracall.cancel") }}
                            </v-btn>
                          </div>
                          <div class="px-2">
                            <v-btn
                              color="#669c10"
                              height="32px"
                              width="60px"
                              class="text-initial"
                              style="color: #fff; font-size: 14px"
                              @click="setUserVirtualBG()"
                              :disabled="!IsMicExist || !hasMicAccess"
                            >
                              {{ $t("rightpanel.apply") }}
                            </v-btn>
                          </div>
                        </div>
                      </div>
                      <div v-if="!readyState" class="mt-4">
                        <!-- {{IsMicExist}}-{{hasMicAccess}}-
                        {{IsCameraExist}}-{{hasCamAccess}} -->
                        <div v-show="micAccessChecked && camAccessChecked">
                          <div class="d-flex justify-content-between">
                            <div class="px-2" style="display: inline-flex">
                              <i>
                                <img
                                  v-if="isMicOn"
                                  height="30"
                                  width="30"
                                  src="../../../assets/Images/unmute.svg"
                                />
                                <img
                                  v-else
                                  height="30"
                                  width="30"
                                  src="../../../assets/Images/mute.svg"
                                  :class="{ disabled: !hasMicAccess }"
                                />
                              </i>
                              <v-switch
                                dense
                                hide-details
                                messages=""
                                color="#1a73e8"
                                class="mt-0 ml-2"
                                v-model="isMicOn"
                                :disabled="!IsMicExist || !hasMicAccess"
                              ></v-switch>
                            </div>
                            <div class="px-2" style="display: inline-flex">
                              <i>
                                <img
                                  v-if="isVideoOn"
                                  height="30"
                                  width="30"
                                  src="../../../assets/Images/video-camera.svg"
                                />
                                <img
                                  v-else
                                  height="30"
                                  width="30"
                                  src="../../../assets/Images/video-off.svg"
                                  :class="{ disabled: !hasCamAccess }"
                                />
                              </i>
                              <v-switch
                                dense
                                hide-details
                                messages=""
                                color="#1a73e8"
                                class="mt-0 ml-2"
                                v-model="isVideoOn"
                                :disabled="!IsCameraExist || !hasCamAccess"
                              ></v-switch>
                            </div>
                            <div class="px-2" style="display: inline-flex">
                              <v-btn
                                color="#669c10"
                                height="32px"
                                width="60px"
                                class="text-initial"
                                style="color: #fff; font-size: 14px"
                                @click="applyMicCamAccess()"
                                :disabled="!IsMicExist || !hasMicAccess"
                              >
                                {{ $t("agoracall.join") }}
                              </v-btn>
                            </div>
                          </div>
                          <!-- <div >
                            <span>Mic</span>
                            <v-switch
                              color="#1a73e8"
                              :disabled="!IsMicExist"
                              v-model="hasMicAccess"
                            ></v-switch>
                          </div> -->
                          <!-- <div>
                            <span>Cam</span>
                            <v-switch
                              color="#1a73e8"
                              :disabled="!IsCameraExist"
                              v-model="hasCamAccess"
                            ></v-switch>
                          </div> -->
                          <!--v-show="IsMicExist && IsCameraExist && hasMicAccess && hasCamAccess"-->
                          <span v-show="!IsMicExist || !hasMicAccess">
                            {{ $t("agoracall.checkmicandcamera") }}
                          </span>
                          <!--<a
                            v-show="!IsMicExist || !hasMicAccess"
                            href="javascript:(0);"
                            class="joinasaud"
                            @click="applyMicCamAccess(false, false)"
                            >{{ $t("agoracall.joinasaudience") }}</a
                          >-->
                          <!--<a
                              href="javascript:(0);"
                              class="enable-button"
                              @click="applyMicCamAccess(true, true)"
                              >Enable camera &amp; mic</a
                            >-->
                          <a
                            v-show="IsMicExist && hasMicAccess && false"
                            href="javascript:(0);"
                            class="without-enable-button"
                            @click="applyMicCamAccess(true, false)"
                            >{{ $t("agoracall.joinwithoutcamera") }}</a
                          >
                          <a
                            v-show="
                              IsMicExist &&
                              IsCameraExist &&
                              hasMicAccess &&
                              hasCamAccess &&
                              false
                            "
                            href="javascript:(0);"
                            class="join-button"
                            @click="applyMicCamAccess(true, true)"
                            >{{ $t("agoracall.joinwithcamera") }}</a
                          >
                          <!-- <a
                            v-show="
                              IsMicExist &&
                              IsCameraExist &&
                              hasMicAccess &&
                              hasCamAccess
                            "
                            href="javascript:(0);"
                            class="join-button"
                            @click="applyMicCamAccess(false, false)"
                            >{{ "Join As Audience" }}</a
                          > -->
                        </div>
                      </div>
                      <p
                        v-if="!readyState"
                        style="
                          text-align: center;
                          display: block;
                          width: 100%;
                          bottom: -10px;
                        "
                      >
                        <a
                          href="https://precalltest.e2m.live"
                          target="_blank"
                          >{{ $t("agoracall.precalltest") }}</a
                        >
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="allowModalCenter" class="player-modal" style="display: none">
      <div class="custom-modal-wrapper">
        <div class="custom-modal-inner" role="document">
          <div class="custom-modal-body">
            <div class="custom-modal-content">
              <div class="inner-allow-body">
                <div class="row">
                  <div class="col-md-6"></div>
                  <div class="col-md-6">
                    <div class="allow-msg-div">
                      <h3>
                        {{ $t("agoracall.allocaccess") }} &amp;
                        {{ $t("agoracall.microphone") }}
                      </h3>
                      <a
                        @click="applyBrowserPermission"
                        href="javscript: void(0);"
                        class="close-popup"
                        >{{ $t("agoracall.ok") }}</a
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      id="debugWrap"
      v-show="false"
      style="
        position: fixed;
        top: 0;
        left: calc(50% - 250px);
        width: 200px;
        height: calc(100% - 50px);
        overflow-y: auto;
        z-index: 9999999;
        background: #fff;
      "
    >
      <div
        @click="clearDebugPanel"
        style="
          text-align: center;
          background: #dbdbdb;
          padding: 2px 5px;
          position: absolute;
          top: 0px;
        "
      >
        {{ $t("agoracall.clear") }}
      </div>
      <div id="debugPanel"></div>
      <div
        @click="hideDebugPanel"
        style="
          text-align: center;
          background: #dbdbdb;
          padding: 2px 5px;
          position: absolute;
          bottom: 0px;
        "
      >
        {{ $t("agoracall.hide") }}
      </div>
    </div>

    <div id="player-not-ready" class="player-not-ready">
      <!-- <div>
        <b>player-not-ready</b><br />
        showTestStream: {{ showTestStream }}<br />
        isVideoOn: {{ isVideoOn }}<br />
        userVirtualBGType: {{ userVirtualBGType }}<br />
        virtualBGConfigInProgress: {{ virtualBGConfigInProgress }}
      </div> -->
      <div v-if="sessionTypeId == 100" class="lds-spinner-load">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
      <img
        v-else
        src="@/assets/Player/images/sand-clock.svg"
        width="45px"
        class="nb-3"
      />
      <h3 v-if="sessionTypeId != 100" class="msg">{{ playerWaitText }}</h3>
    </div>
    <!-- <div class="player-in-progress">
    </div> -->
    <div id="ag-parent-canvas" class="d-none">
      <section id="ag-left-panel" />
      <section v-if="vueBindingEnabled" id="ag-canvas" class="one">
        <div
          v-for="user in CanvasItems"
          :key="user.uid"
          :id="'ag-user-' + user.uid"
          class="ag-user"
        >
          <section class="ag-item" :id="'ag-item-' + user.uid"></section>
        </div>
      </section>
      <section v-else id="ag-canvas" class="one"></section>
      <section id="ag-right-panel" />
    </div>
    <div
      id="ag-sponsor-panel"
      class="ag-btn-group message-group-wrapper active d-none"
    >
      <div class="sponsor-title">
        <p>{{ $t("agoracall.sessionsponseredby") }}</p>
      </div>
      <div class="sponsors">
        <hooper
          style="height: 80px"
          :vertical="false"
          :itemsToShow="7"
          :itemsToSlide="1"
          :centerMode="true"
          :autoPlay="true"
          :playSpeed="5000"
          :transition="1000"
          :hoverPause="true"
          :pagination="false"
          :infiniteScroll="true"
        >
          <slide class="single-sponsor">
            <img src="../../../assets/Images/spnsr1.png" />
          </slide>
          <slide class="single-sponsor">
            <img src="../../../assets/Images/spnsr1.png" />
          </slide>
          <slide class="single-sponsor">
            <img src="../../../assets/Images/spnsr1.png" />
          </slide>
          <slide class="single-sponsor">
            <img src="../../../assets/Images/spnsr1.png" />
          </slide>
          <slide class="single-sponsor">
            <img src="../../../assets/Images/spnsr1.png" />
          </slide>
          <slide class="single-sponsor">
            <img src="../../../assets/Images/spnsr1.png" />
          </slide>
          <slide class="single-sponsor">
            <img src="../../../assets/Images/spnsr1.png" />
          </slide>
          <slide class="single-sponsor">
            <img src="../../../assets/Images/spnsr1.png" />
          </slide>
          <slide class="single-sponsor">
            <img src="../../../assets/Images/spnsr1.png" />
          </slide>
          <slide class="single-sponsor">
            <img src="../../../assets/Images/spnsr1.png" />
          </slide>
          <slide class="single-sponsor">
            <img src="../../../assets/Images/spnsr1.png" />
          </slide>
          <slide class="single-sponsor">
            <img src="../../../assets/Images/spnsr1.png" />
          </slide>
          <slide class="single-sponsor">
            <img src="../../../assets/Images/spnsr1.png" />
          </slide>
          <slide class="single-sponsor">
            <img src="../../../assets/Images/spnsr1.png" />
          </slide>
          <slide class="single-sponsor">
            <img src="../../../assets/Images/spnsr1.png" />
          </slide>
        </hooper>
      </div>
    </div>
    <div id="ag-button-panel" class="ag-btn-group button-group-wrapper active">
      <div class="btn-group-left-area show-on-call d-none">
        <div v-show="IsLive && sessionTypeId < 5" class="live-signify">
          <span class="blink-dot"></span>
          {{ recordingStarted ? "REC" : $t("livestage.live") }}
        </div>
        <!--<div
          v-show="!IsLive && !IsGoLive"
          class="live-signify back-stage"
          data-toggle="tooltip"
          title="The Backstage is a private video chat that allows Speakers and Organizers rehearse before going live in front of attendees."
        >
          Back Stage
        </div>
        <div
          v-show="IsGoLive"
          class="live-signify go-live"
          @click="GoLive"
          data-toggle="tooltip"
          title="Attendees won&#39;t see you until you go-live"
        >
          Click Here to Go Live
        </div>-->
        <div
          v-show="
            (exPageId == '' || exPageId == 'sn') &&
            !dialogSessionId &&
            sessionTypeId < 4
          "
          @click="displaySessionDetails"
          class="information-wrap fa fa-info"
          data-toggle="tooltip"
          data-placement="top"
          data-original-title="Click to view Session details"
        >
          <!--<img
            src="../../../assets/Images/rounded-info-button.svg"
            style="width: 25px; height: 28px; margin-left: 22px"
          />-->
          <p>Info</p>
        </div>
        <div
          v-show="
            !exStageUrl &&
            DisplayAudienceCounter &&
            sessionTypeId < 4 &&
            IsLive &&
            (userType < 4 || (viewersCountVisible && attendeeEnabled)) &&
            !dialogSessionId
          "
          class="view-count"
          style="display: block"
          data-toggle="tooltip"
          data-placement="top"
          data-original-title="Click or Show/Hide Attendee List"
        >
          <p @click="openAttendeePanel">
            <img src="../../../assets/Images/viewer.png" alt="viewer" />
            <span class="viewer-count">{{ viewersCount }}</span>
          </p>
        </div>
        <div
          v-if="[3, 4].includes(sessionTypeId) && !exStageUrl"
          id="brandLogoBottom"
          class="brand-logo-wrap"
        >
          <!--<p>This Session is Sponsored by</p>-->
          <div class="brand-logo-inner">
            <a v-if="playerLogoLink" :href="playerLogoLink" target="_blank">
              <img :src="playerLogo" />
            </a>
            <img v-else :src="playerLogo" />
          </div>
        </div>
      </div>
      <div
        v-show="
          attendeeMode !== 'audience' &&
          readyState &&
          !inProcess &&
          IsMicExist &&
          hasMicAccess
        "
        class="single-call-handle-butn voice-button-wrap show-on-call d-none"
      >
        <span
          @click="handleMic"
          :class="
            isMicOn ? 'ag-btn audioControlBtn' : 'ag-btn audioControlBtn off'
          "
        >
          <i class="ag-icon ag-icon-mic">
            <img src="../../../assets/Images/unmute.svg" />
          </i>
          <i class="ag-icon ag-icon-mic-off">
            <img src="../../../assets/Images/mute.svg" />
          </i>
        </span>
        <span v-if="!isMicOn" class="icondesc">{{
          $t("agoracall.unmute")
        }}</span>
        <span v-if="isMicOn" class="icondesc">{{ $t("agoracall.mute") }}</span>
        <span
          v-show="true"
          class="button-setting-dropdown"
          @click="toggleAudioSettings"
        >
          <img
            src="../../../assets/Images/down-arrow-settings.svg"
            style="width: 8px; height: 10px"
          />
        </span>
        <div
          v-show="audioSettingsOpened"
          class="voice-settings-wrap"
          @click="playerSettingsOnClick"
        >
          <button
            type="button"
            class="close"
            aria-label="Close"
            @click="toggleAudioSettings"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="18.03"
              height="18.031"
              viewBox="0 0 18.03 18.031"
            >
              <path
                id="close.svg"
                fill="#242432"
                d="M1422.25,525.005l7.51,7.508a0.885,0.885,0,0,1,0,1.243,0.876,0.876,0,0,1-1.24,0l-7.51-7.508-7.51,7.508a0.876,0.876,0,0,1-1.24,0,0.867,0.867,0,0,1,0-1.243l7.51-7.508-7.51-7.507a0.878,0.878,0,0,1,1.24-1.243l7.51,7.508,7.51-7.508a0.874,0.874,0,0,1,1.24,0,0.885,0.885,0,0,1,0,1.243Z"
                transform="translate(-1412 -516)"
              />
            </svg>
          </button>
          <h4>Audio Settings</h4>
          <div>
            <div id="divDDLMicrophone">
              <span class="d-block mt-3 mb-1 text-left">
                {{ $t("rightpanel.microphone") }}
              </span>
              <v-select
                :items="mics"
                item-text="label"
                item-value="deviceId"
                dense
                height="38px"
                return-object
                v-model="currentMic"
                style="-webkit-appearance: menulist"
                class="dropdown"
              ></v-select>
            </div>

            <div>
              <span class="d-block mt-3 mb-1 text-left">
                {{ $t("rightpanel.speakers") }}
              </span>
              <v-select
                :items="playbackDevices"
                item-text="label"
                item-value="deviceId"
                dense
                height="38px"
                return-object
                v-model="currentPlaybackDevice"
                style="-webkit-appearance: menulist"
                class="dropdown"
              ></v-select>
              <!-- <select
                style="-webkit-appearance: menulist"
                v-model="speaker"
                @change="onSpeakerChange"
              >
                <option
                  v-for="(item, index) in speakerOptions"
                  :key="index"
                  :value="item"
                >
                  {{ item.label }}
                </option>
              </select> -->
            </div>
          </div>
        </div>
      </div>
      <div
        v-show="
          attendeeMode === 'video' &&
          readyState &&
          !inProcess &&
          IsCameraExist &&
          hasCamAccess
        "
        class="single-call-handle-butn show-on-call d-none"
      >
        <span
          @click="handleCamera"
          :class="
            isVideoOn ? 'ag-btn videoControlBtn' : 'ag-btn videoControlBtn off'
          "
        >
          <i v-if="isVideoOn" class="ag-icon ag-icon-camera1">
            <img src="../../../assets/Images/video-camera.svg" />
          </i>
          <i v-else class="ag-icon ag-icon-camera-off1">
            <img src="../../../assets/Images/video-off.svg" />
          </i>
        </span>
        <span v-if="!isVideoOn" class="icondesc">{{
          $t("agoracall.startvideo")
        }}</span>
        <span v-if="isVideoOn" class="icondesc">{{
          $t("agoracall.stopvideo")
        }}</span>
        <span class="button-setting-dropdown" @click="toggleVideoSettings">
          <img
            src="../../../assets/Images/down-arrow-settings.svg"
            style="width: 8px; height: 10px"
          />
        </span>
        <div
          v-show="videoSettingsOpened"
          class="video-settings-wrap"
          @click="playerSettingsOnClick"
        >
          <button
            type="button"
            class="close"
            aria-label="Close"
            @click="toggleVideoSettings"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="18.03"
              height="18.031"
              viewBox="0 0 18.03 18.031"
            >
              <path
                id="close.svg"
                fill="#242432"
                d="M1422.25,525.005l7.51,7.508a0.885,0.885,0,0,1,0,1.243,0.876,0.876,0,0,1-1.24,0l-7.51-7.508-7.51,7.508a0.876,0.876,0,0,1-1.24,0,0.867,0.867,0,0,1,0-1.243l7.51-7.508-7.51-7.507a0.878,0.878,0,0,1,1.24-1.243l7.51,7.508,7.51-7.508a0.874,0.874,0,0,1,1.24,0,0.885,0.885,0,0,1,0,1.243Z"
                transform="translate(-1412 -516)"
              />
            </svg>
          </button>
          <h4>Video Settings</h4>
          <div>
            <div>
              <span class="d-block mt-3 mb-1 text-left">
                {{ $t("rightpanel.camera") }}
              </span>
              <v-select
                :items="cams"
                item-text="label"
                item-value="deviceId"
                dense
                height="38px"
                return-object
                v-model="currentCam"
                style="-webkit-appearance: menulist"
                class="dropdown"
              ></v-select>

              <!-- <select
                style="-webkit-appearance: menulist"
                v-model="camera"
                @change="onCameraChange"
              >
                <option
                  v-for="(item, index) in cameraOptions"
                  :key="index"
                  :value="item"
                >
                  {{ item.label }}
                </option>
              </select> -->
            </div>
            <div>
              <span class="d-block mt-3 mb-1 text-left">
                {{ $t("rightpanel.videoquality") }}
              </span>
              <v-select
                :items="videoProfiles"
                item-text="label"
                item-value="value"
                dense
                height="38px"
                return-object
                v-model="currentVideoProfile"
                style="-webkit-appearance: menulist"
                class="dropdown"
              ></v-select>

              <!-- <select
                style="-webkit-appearance: menulist"
                v-model="videoResolution"
                @change="onVideoResolutionChange"
                class="is-clipped"
              >
                <option
                  v-for="(item, index) in videoResolutions"
                  :key="index"
                  :value="index.split(',')[0]"
                >
                  {{ item[4] }}-
                  {{ index.split(",")[0] }}
                </option>
              </select> -->
            </div>
            <div v-if="userVirtualBGEnabled" class="mt-2">
              <span
                class="d-block py-2 text-left cursor-pointer"
                @click="
                  virtualBGConfigInProgress ? null : openVirtualBGConfig()
                "
              >
                <v-icon color="#5f6368" class="mr-3">auto_awesome</v-icon>
                {{ $t("rightpanel.applyvisualeffect") }}
                <!-- -{{readyState}} -->
              </span>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="AllowScreenShare && attendeeMode !== 'audience'"
        class="single-call-handle-butn show-on-call d-none"
      >
        <span
          class="ag-btn disableRemoteBtn1"
          :class="{ 'screen-share-off': shareClient }"
          @click="hideRemote"
        >
          <i class="ag-icon ag-icon-remove-pip">
            <img
              v-if="!readyShareState"
              src="../../../assets/Images/screen-share.svg"
            />
            <v-icon v-if="readyShareState" size="20px" color="#f00"
              >mdi-close</v-icon
            >
          </i>
        </span>
        <span v-if="!readyShareState" class="icondesc">{{
          $t("agoracall.startsharing")
        }}</span>
        <span v-if="readyShareState" class="icondesc">{{
          $t("agoracall.stopsharing")
        }}</span>
      </div>
      <!--<div
        v-if="
          IsLive && AllowRecording && (userType == 1 || isCurrentUserCoHost)
        "
        class="single-call-handle-butn rec-btn-wrap show-on-call d-none"
      >
        <button
          v-show="!recordingStartStopInProcess"
          id="btnRecording"
          @click="togglRecording"
          class="record-session-button recording-btn"
        >
          <span class="record-btn-out">
            <span class="record-btn"></span>
          </span>
        </button>
        <button
          v-show="recordingStartStopInProcess"
          id="btnRecordingLoader"
          class="record-session-button recording-btn"
        >
          <span class="record-btn-out">
            <span
              class="record-btn fa fa-spinner fa-spin fa-circle-o-notch"
            ></span>
          </span>
        </button>
        <span id="lblRecording" class="icondesc record-text">{{
          $t("agoracall.startrecording")
        }}</span>
      </div>-->

      <div
        v-if="AllowRaiseHand && userType >= 4 && !displayInviteToStage && false"
        class="single-call-handle-butn show-on-call"
      >
        <span
          @click="handleRH(!isRHOn)"
          :class="isRHOn ? 'ag-btn rhControlBtn off' : 'ag-btn rhControlBtn'"
        >
          <i v-if="!isRHOn" class="ag-icon ag-icon-rh1">
            <img src="../../../assets/Images/raisehand.svg" />
          </i>
          <i v-if="isRHOn" class="ag-icon ag-icon-rh-off1">
            <img src="../../../assets/Images/lowerhand.svg" />
          </i>
        </span>
        <span v-if="!isRHOn" class="icondesc">{{
          $t("agoracall.raisehand")
        }}</span>
        <span v-if="isRHOn" class="icondesc">{{
          $t("agoracall.lowerhand")
        }}</span>
      </div>

      <div
        v-show="
          [3, 4].includes(sessionTypeId) &&
          readyState &&
          (userType == 1 || isCurrentUserCoHost) &&
          ((IsLive && AllowRecording) ||
            (hostCanMuteSpeaker && streamList.length > 1))
        "
        class="single-call-handle-butn show-on-call d-none"
      >
        <div class="more-option-btn-wrap" @click="toggleHideMoreOption">
          <div class="ag-btn more-option" title="">
            <span></span>
            <span></span>
            <span></span>
          </div>
          <span class="icondesc">More</span>
        </div>
        <div
          v-show="moreOptionVisibility"
          class="more-option-wrap"
          @click="MoreOptionPanelOnClick"
        >
          <div
            class="more-action-notification action-notification hidden"
          ></div>
          <div
            v-if="
              IsLive && AllowRecording && (userType == 1 || isCurrentUserCoHost)
            "
            id="btnRecording"
            class="ag-option"
            @click="togglRecording"
          >
            <span
              v-show="!recordingStarted && !recordingStartStopInProcess"
              class="ag-option-icon ag-start-recording"
            ></span>
            <span
              v-show="recordingStarted && !recordingStartStopInProcess"
              class="ag-option-icon ag-stop-recording"
            ></span>
            <span
              v-show="recordingStartStopInProcess"
              class="ag-option-icon ag-recording-in-process"
            ></span>
            <span v-if="!recordingStarted">Start Recording</span>
            <span v-else>Stop Recording</span>
          </div>
          <div
            v-if="
              IsRTMP &&
              ShowAgoraRTMPButton &&
              (userType == 1 || isCurrentUserCoHost) &&
              (!AgoraRTMPStartedBy || AgoraRTMPStartedBy == uid)
            "
            class="ag-option"
            @click="ToggleAgoraRTMP"
          >
            <span
              v-show="!AgoraRTMPStarted && !AgoraRTMPInProcess"
              class="ag-option-icon ag-start-recording1"
            >
              <img
                style="height: 20px; width: 20px; margin: 3px 5px; opacity: 0.4"
                src="../../../assets/Images/vcall.png"
              />
            </span>
            <span
              v-show="AgoraRTMPStarted && !AgoraRTMPInProcess"
              class="ag-option-icon ag-stop-recording1"
            >
              <img
                style="height: 20px; width: 20px; margin: 3px 5px"
                src="../../../assets/Images/vcall.png"
              />
            </span>
            <span
              v-show="AgoraRTMPInProcess"
              class="ag-option-icon ag-in-process"
            ></span>
            <span v-if="!AgoraRTMPStarted">Start RTMP</span>
            <span v-else>Stop RTMP</span>
          </div>
          <div
            v-if="
              [3, 4].includes(sessionTypeId) &&
              hostCanMuteSpeaker &&
              (userType == 1 || isCurrentUserCoHost) &&
              streamList.length > 1
            "
            class="ag-option ag-option-mute-all"
            @click="onRequestAllSpeakersToMute(0, true)"
          >
            <span class="ag-option-icon ag-mute-all"></span>Mute All
          </div>
          <!--<div class="ag-option">
            <span class="ag-option-icon ag-unhide-speakers"></span>Unhide
            Speakers
          </div>-->
          <!--<div
            v-if="switchTableVisible"
            class="ag-option"
            @click="displayTablesPopup"
          >
            <span class="ag-option-icon ag-switch-rt"></span>Switch Table
          </div>-->
        </div>
        <!--<div
          v-show="attendeeMode !== 'audience' && readyState && !inProcess"
          @click="HiddenSpeakersPanelOnClick"
          class="hide-screen-dropdown"
        >
          <span @click="toggleHideSpeaker">Unhide Speaker </span>
          <div v-show="hiddenSpeakerListVisibility" class="hidden-speaker-list">
            <div class="speaker-list-head">
              <h3>Unhide Speakers</h3>
              <span
                v-show="hiddenSpeakerList.length > 1"
                @click="unhideAllSpeakers"
                :class="hiddenSpeakerList.length > 4 ? '' : 'no-scroll'"
                >Unhide all
                <img src="../../../assets/Player/images/hide-view.svg"
              /></span>
            </div>
            <div class="hidden-speakers-inner-wrap">
              <div
                v-for="hiddenSpeaker in hiddenSpeakerList"
                :key="'hiddenSpeaker_' + hiddenSpeaker.AttendeeId"
                class="single-hidden-speaker"
              >
                <div class="single-speaker-hidden-left">
                  <div class="hidden-speaker-img">
                    <img src="../../../assets/Images/avatar.jpg" />
                  </div>
                  <div class="hidden-speakers-details">
                    <h4>Maureen Rocha</h4>
                    <p>Vice President, Nonprofits</p>
                  </div>
                </div>
                <div
                  @click="unhideSpeaker"
                  :data-val="hiddenSpeaker.AttendeeId"
                  class="un-hide-btn"
                >
                  <img src="../../../assets/Player/images/hide-view.svg" />
                  <span>Unhide</span>
                </div>
              </div>
            </div>
          </div>
        </div>-->
      </div>

      <div class="bottom-right-area">
        <div
          v-show="switchTableVisible"
          class="switch-table-area"
          title="Click to switch Table"
        >
          <span @click="displayTablesPopup"
            ><i><img src="../../../assets/Images/icons/switch-table.svg" /></i
          ></span>
        </div>

        <div
          v-show="
            hostOptionsEnabled &&
            hostCanHideSpeaker &&
            (userType == 1 || isCurrentUserCoHost) &&
            readyState &&
            !inProcess &&
            hiddenSpeakerList.length > 0
          "
          @click="HiddenSpeakersPanelOnClick"
          class="hide-screen-dropdown"
        >
          <span @click="toggleHideSpeaker">Unhide Speaker </span>
          <div v-show="hiddenSpeakerListVisibility" class="hidden-speaker-list">
            <div class="speaker-list-head">
              <h3>Unhide Speakers</h3>
              <span
                v-show="hiddenSpeakerList.length > 1"
                @click="unhideAllSpeakers"
                :class="hiddenSpeakerList.length > 4 ? '' : 'no-scroll'"
                >Unhide all
                <img src="../../../assets/Player/images/hide-view.svg"
              /></span>
            </div>
            <div class="hidden-speakers-inner-wrap">
              <div
                v-for="hiddenSpeaker in hiddenSpeakerList"
                :key="'hiddenSpeaker_' + hiddenSpeaker.AttendeeId"
                class="single-hidden-speaker"
              >
                <div class="single-speaker-hidden-left">
                  <div class="hidden-speaker-img">
                    <img src="../../../assets/Images/avatar.jpg" />
                  </div>
                  <div class="hidden-speakers-details">
                    <h4>Maureen Rocha</h4>
                    <p>Vice President, Nonprofits</p>
                  </div>
                </div>
                <div
                  @click="unhideSpeaker"
                  :data-val="hiddenSpeaker.AttendeeId"
                  class="un-hide-btn"
                >
                  <img src="../../../assets/Player/images/hide-view.svg" />
                  <span>Unhide</span>
                </div>
              </div>
              <!--<div class="single-hidden-speaker">
                <div class="single-speaker-hidden-left">
                  <div class="hidden-speaker-img">
                    <img src="../../../assets/Images/avatar.jpg" />
                  </div>
                  <div class="hidden-speakers-details">
                    <h4>Maureen Rocha</h4>
                    <p>Vice President, Nonprofits</p>
                  </div>
                </div>
                <div class="un-hide-btn">
                  <img src="../../../assets/Player/images/hide-view.svg" />
                  <span>Unhide</span>
                </div>
              </div>
              <div class="single-hidden-speaker">
                <div class="single-speaker-hidden-left">
                  <div class="hidden-speaker-img">
                    <img src="../../../assets/Images/avatar.jpg" />
                  </div>
                  <div class="hidden-speakers-details">
                    <h4>Maureen Rocha</h4>
                    <p>Vice President, Nonprofits</p>
                  </div>
                </div>
                <div class="un-hide-btn">
                  <img src="../../../assets/Player/images/hide-view.svg" />
                  <span>Unhide</span>
                </div>
              </div>
              <div class="single-hidden-speaker">
                <div class="single-speaker-hidden-left">
                  <div class="hidden-speaker-img">
                    <img src="../../../assets/Images/avatar.jpg" />
                  </div>
                  <div class="hidden-speakers-details">
                    <h4>Maureen Rocha</h4>
                    <p>Vice President, Nonprofits</p>
                  </div>
                </div>
                <div class="un-hide-btn">
                  <img src="../../../assets/Player/images/hide-view.svg" />
                  <span>Unhide</span>
                </div>
              </div>
              <div class="single-hidden-speaker">
                <div class="single-speaker-hidden-left">
                  <div class="hidden-speaker-img">
                    <img src="../../../assets/Images/avatar.jpg" />
                  </div>
                  <div class="hidden-speakers-details">
                    <h4>Maureen Rocha</h4>
                    <p>Vice President, Nonprofits</p>
                  </div>
                </div>
                <div class="un-hide-btn">
                  <img src="../../../assets/Player/images/hide-view.svg" />
                  <span>Unhide</span>
                </div>
              </div>
              <div class="single-hidden-speaker">
                <div class="single-speaker-hidden-left">
                  <div class="hidden-speaker-img">
                    <img src="../../../assets/Images/avatar.jpg" />
                  </div>
                  <div class="hidden-speakers-details">
                    <h4>Maureen Rocha</h4>
                    <p>Vice President, Nonprofits</p>
                  </div>
                </div>
                <div class="un-hide-btn">
                  <img src="../../../assets/Player/images/hide-view.svg" />
                  <span>Unhide</span>
                </div>
              </div>
              <div class="single-hidden-speaker">
                <div class="single-speaker-hidden-left">
                  <div class="hidden-speaker-img">
                    <img src="../../../assets/Images/avatar.jpg" />
                  </div>
                  <div class="hidden-speakers-details">
                    <h4>Maureen Rocha</h4>
                    <p>Vice President, Nonprofits</p>
                  </div>
                </div>
                <div class="un-hide-btn">
                  <img src="../../../assets/Player/images/hide-view.svg" />
                  <span>Unhide</span>
                </div>
              </div>
              <div class="single-hidden-speaker">
                <div class="single-speaker-hidden-left">
                  <div class="hidden-speaker-img">
                    <img src="../../../assets/Images/avatar.jpg" />
                  </div>
                  <div class="hidden-speakers-details">
                    <h4>Maureen Rocha</h4>
                    <p>Vice President, Nonprofits</p>
                  </div>
                </div>
                <div class="un-hide-btn">
                  <img src="../../../assets/Player/images/hide-view.svg" />
                  <span>Unhide</span>
                </div>
              </div>
              <div class="single-hidden-speaker">
                <div class="single-speaker-hidden-left">
                  <div class="hidden-speaker-img">
                    <img src="../../../assets/Images/avatar.jpg" />
                  </div>
                  <div class="hidden-speakers-details">
                    <h4>Maureen Rocha</h4>
                    <p>Vice President, Nonprofits</p>
                  </div>
                </div>
                <div class="un-hide-btn">
                  <img src="../../../assets/Player/images/hide-view.svg" />
                  <span>Unhide</span>
                </div>
              </div>
              <div class="single-hidden-speaker">
                <div class="single-speaker-hidden-left">
                  <div class="hidden-speaker-img">
                    <img src="../../../assets/Images/avatar.jpg" />
                  </div>
                  <div class="hidden-speakers-details">
                    <h4>Maureen Rocha</h4>
                    <p>Vice President, Nonprofits</p>
                  </div>
                </div>
                <div class="un-hide-btn">
                  <img src="../../../assets/Player/images/hide-view.svg" />
                  <span>Unhide</span>
                </div>
              </div>-->
            </div>
          </div>
        </div>
        <!-- <div v-if="ShowAgoraRTMPButton && userType == 1 && AgoraRTMPStarted">
          <a @click="StopAgoraRTMP" href="javascript:void(0);"> Stop RTMP </a>
        </div> -->
        <!-- <div v-else-if="ShowAgoraRTMPButton && userType == 1 && !AgoraRTMPStarted">
          <a @click="StartAgoraRTMP" href="javascript:void(0);"> Start RTMP </a>
        </div> -->
        <!-- <div>
          <a @click="JoinAgoraRTMP" href="javascript:void(0);"> Join RTMP </a>
        </div> -->
        <!-- {{ displayMode }}/{{ userCount }} -->
        <div
          v-show="userCount > 1 && displayMode == 'pip'"
          class="single-call-handle-butn1"
          title="Click to switch to Tile View"
        >
          <span
            @click="switchToTileView"
            class="ag-btn displayModeBtn switch-tile"
            :class="{
              disabled: userCount <= 1 || displayMode == 'tile',
            }"
            title="Click to switch to Tile View"
          >
            <i class="ag-icon ag-icon-switch-display">
              <img src="../../../assets/Images/icons/tile-view.svg" />
            </i>
          </span>
        </div>

        <!--<div v-show="timerVisible" class="session-end-countdown">
          <p>
            <span class="ml-2 label">{{ timerLabel }}</span>
            <span :class="endsIn > 60 ? 'ml-2' : 'ml-2 blink'">{{
              timerValue
            }}</span>
          </p>
        </div>-->

        <div id="session-end-countdown" class="session-end-countdown d-none">
          <p>
            <span id="timerLabel" class="ml-2 label">{{ timerLabel }}</span>
            <span id="timerValue">{{ timerValue }}</span>
          </p>
        </div>

        <div
          v-show="!IsLive && !IsGoLive"
          class="back-stage"
          data-toggle="tooltip"
          title="The Backstage is a private video chat that allows Speakers and Organizers rehearse before going live in front of attendees."
        >
          Back Stage
        </div>
        <div
          v-show="IsGoLive"
          class="go-live"
          @click="GoLive"
          data-toggle="tooltip"
          title="Attendees won&#39;t see you until you go-live"
        >
          Enter Live Broadcast
        </div>

        <!--<div class="">
          <div
            v-if="attendeeType < 14 && !callSwitchingInProcess"
            class="single-call-handle-butn End-handle-butn"
          >
            <div
              :class="'ag-btn exitBtn' + (readyState ? '' : ' start-call-btn')"
            >
              <div class="exit-butn-wrap">
                <i
                  v-show="readyState && !inProcess"
                  class="ag-icon ag-icon-leave"
                  @click="onConfirmEndCall"
                  ><img src="../../../assets/Images/leave-call.svg" />
                </i>
                <span v-show="readyState && !inProcess">{{
                  $t("agoracall.leave")
                }}</span>

                <i
                  v-show="!readyState && !inProcess"
                  class="ag-icon ag-icon-leave ag-icon-join"
                  @click="onEndCall"
                  ><img src="../../../assets/Images/join-call.svg" />
                </i>
                <span v-show="!readyState && !inProcess">{{
                  $t("agoracall.join")
                }}</span>
                <i v-show="inProcess" class="ag-icon-dialing"
                  ><img src="../../../assets/Images/dialing.gif"
                /></i>
                <span v-show="inProcess">Joining</span>
              </div>
            </div>
          </div>
        </div>-->

        <div
          v-show="sessionTypeId == 100 && readyState && !inProcess"
          class="single-call-handle-butn ag-pip"
          @click="switchToPIPView"
          style="width: 40px"
        >
          <span>
            <!-- <i class=""></i> -->
            <!-- <v-icon size="20px" color="#ffffff">mdi-plus</v-icon> -->
            <img
              height="30"
              width="30"
              src="../../../assets/Player/images/pip-in.svg"
            />
          </span>
        </div>
        <div
          v-if="attendeeType < 14 && !callSwitchingInProcess"
          class="single-call-handle-butn exit-btn-wrap"
        >
          <span
            :class="'ag-btn exitBtn' + (readyState ? '' : ' start-call-btn')"
          >
            <i
              v-show="readyState && !inProcess"
              class="ag-icon ag-icon-leave"
              @click="onConfirmEndCall"
              >{{ $t("agoracall.leave") }}</i
            >
            <i
              v-show="!readyState && !inProcess"
              class="ag-icon ag-icon-leave"
              @click="onEndCall"
              >{{ $t("agoracall.join") }}</i
            >
            <i v-show="inProcess" class="fa fa-spinner fa-spin"></i>
          </span>
        </div>

        <div
          v-if="
            sessionTypeId == 6 &&
            displayNextMeetingJoinLink &&
            nextMeetingId &&
            !callSwitchingInProcess
          "
          class="single-call-handle-butn exit-btn-wrap"
        >
          <div
            v-show="false"
            style="
              display: flex;
              flex-direction: row;
              align-items: center;
              justify-content: center;
            "
          >
            <img
              v-if="nextMeetingAttendeeProfilePictureURL"
              :src="nextMeetingAttendeeProfilePictureURL"
              style="
                height: 36px;
                width: 36px;
                border-radius: 50%;
                overflow: hidden;
                margin-right: 10px;
              "
              @error="nextMeetingAttendeeProfilePictureURL = ''"
            />
            <span
              v-else
              style="
                height: 36px;
                width: 36px;
                border-radius: 50%;
                overflow: hidden;
                margin-right: 10px;
                font-size: 18px;
                color: #fff;
                border: 2px solid #fff;
                display: flex;
                align-items: center;
                justify-content: center;
              "
            >
              {{ nextMeetingAttendeeInitial }}
            </span>
            <span style="color: #fff">
              {{ nextMeetingAttendeeName }}
            </span>
          </div>
          <span
            :class="'ag-btn exitBtn' + (readyState ? '' : ' start-call-btn')"
            style="
              width: auto !important;
              padding: 0 10px;
              background: #669c10 !important;
            "
          >
            <i
              v-if="enableNextMeetingJoinLink"
              class="ag-icon ag-icon-leave"
              @click="startMeeting(nextMeetingId)"
              >Join Next Meeting</i
            >
            <i v-else class="ag-icon ag-icon-leave disabled"
              >Join Next Meeting</i
            >
            <i v-show="inProcess" class="fa fa-spinner fa-spin"></i>
          </span>
        </div>
      </div>
    </div>
    <div
      id="lp"
      style="
        position: absolute;
        z-index: 1000000;
        top: 0;
        left: 0;
        height: 0px;
        width: 0px;
        display: none;
      "
    >
      <video-player
        id="vpLivePlayer"
        ref="lPlayer"
        class="vjs-custom-skin l-player"
        :options="streamPlayerOptions"
        @volumechange="onLPlayerVolumeChange($event)"
        @play="onLPlayerPlay($event)"
        @ready="onLPlayerReady($event)"
      ></video-player>
    </div>
    <div
      id="popupLeaveConfirm"
      class="modal fade"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-body">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18.03"
                height="18.031"
                viewBox="0 0 18.03 18.031"
              >
                <path
                  id="close.svg"
                  fill="#242432"
                  d="M1422.25,525.005l7.51,7.508a0.885,0.885,0,0,1,0,1.243,0.876,0.876,0,0,1-1.24,0l-7.51-7.508-7.51,7.508a0.876,0.876,0,0,1-1.24,0,0.867,0.867,0,0,1,0-1.243l7.51-7.508-7.51-7.507a0.878,0.878,0,0,1,1.24-1.243l7.51,7.508,7.51-7.508a0.874,0.874,0,0,1,1.24,0,0.885,0.885,0,0,1,0,1.243Z"
                  transform="translate(-1412 -516)"
                />
              </svg>
            </button>
            <div
              v-if="
                (userType == 1 || isCurrentUserCoHost) &&
                [3, 4].includes(sessionTypeId) &&
                endForAllEnabled
              "
              class="session-details p-4"
            >
              <div class="host mx-10">
                <a
                  href="javascript:void(0)"
                  class="button-yes w-100"
                  @click="onEndSession"
                  >END SESSION FOR ALL</a
                >
                <a
                  href="javascript:void(0)"
                  class="button-no w-100"
                  @click="onEndCall"
                  >LEAVE SESSION</a
                >
                <a
                  v-if="breakoutRoomId"
                  href="javascript:void(0)"
                  class="button-no button-return w-100"
                  @click="leaveBreakoutRoom"
                  >LEAVE BREAKOUT ROOM</a
                >
              </div>
            </div>
            <div
              v-else-if="
                !(userType == 1 || isCurrentUserCoHost) &&
                [3, 4].includes(sessionTypeId) &&
                breakoutRoomId
              "
              class="session-details p-4"
            >
              <div class="host mx-10">
                <a
                  href="javascript:void(0)"
                  class="button-yes w-100"
                  @click="onEndCall"
                  >LEAVE SESSION</a
                >
                <a
                  href="javascript:void(0)"
                  class="button-no button-return w-100"
                  @click="leaveBreakoutRoom"
                  >LEAVE BREAKOUT ROOM</a
                >
              </div>
            </div>
            <div v-else class="session-details p-4">
              <p>{{ $t("agoracall.areyousureyouwanttoleave") }}</p>
              <div>
                <a
                  href="javascript:void(0)"
                  class="button-no"
                  @click="onCanceEndCall"
                  >{{ $t("agoracall.cancel") }}</a
                >
                <a
                  href="javascript:void(0)"
                  class="button-yes"
                  @click="onEndCall"
                  >{{ $t("agoracall.leave") }}</a
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      id="popupUnmute"
      class="modal fade"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-body">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18.03"
                height="18.031"
                viewBox="0 0 18.03 18.031"
              >
                <path
                  id="close.svg"
                  fill="#242432"
                  d="M1422.25,525.005l7.51,7.508a0.885,0.885,0,0,1,0,1.243,0.876,0.876,0,0,1-1.24,0l-7.51-7.508-7.51,7.508a0.876,0.876,0,0,1-1.24,0,0.867,0.867,0,0,1,0-1.243l7.51-7.508-7.51-7.507a0.878,0.878,0,0,1,1.24-1.243l7.51,7.508,7.51-7.508a0.874,0.874,0,0,1,1.24,0,0.885,0.885,0,0,1,0,1.243Z"
                  transform="translate(-1412 -516)"
                />
              </svg>
            </button>
            <div class="session-details p-4">
              <p>The Host {{ unmuteRequester }} would like you to unmute</p>
              <div>
                <a
                  href="javascript:void(0)"
                  class="button-no"
                  @click="onUnmute(0)"
                  >Stay Muted</a
                >
                <a
                  href="javascript:void(0)"
                  class="button-yes"
                  @click="onUnmute(1)"
                  >Unmute Myself</a
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--Modal Popups-->
    <!--<div
      id="tempButtons"
      style="position: absolute; z-index: 999; top: 0; left: 0; display: none"
    >
      <button data-toggle="modal" data-target="#allowModalCenter">
        Click 1
      </button>
      <button data-toggle="modal" data-target="#enableModalCenter">
        Click 2
      </button>
    </div>-->
    <!-- Modal -->
  </div>
</template>
<style>
.validation-button {
  /* height: 36px; */
}
.validation-button .pre-call-test-btn span {
  background: none !important;
}
.pre-call-test-btn .ag-icon img {
  width: 30px;
}
.pre-call-test-wrap img.disabled {
  opacity: 0.4;
}
#userPreviewCanvas1 {
  position: absolute;
  z-index: 1;
  top: -100px;
  left: -300px;
  border: 1px solid #000;
}
#userPreviewCanvas2 {
  /* background-image: url("https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT%2FAGORA%2Fvirtual_bg%2Froom.jpg?alt=media"); */
  position: absolute;
  z-index: 2;
  /* top: 150px;
  left: -300px; */
  border: 1px solid #000;
}
.mobile-view .icondesc,
.ipad-view .icondesc {
  display: none !important;
}
.mobile-view span.button-setting-dropdown,
.ipad-view span.button-setting-dropdown {
  top: 100%;
}
.mobile-view .single-call-handle-butn,
.ipad-view .single-call-handle-butn {
  width: 60px;
}
</style>

<script>
import { Hooper, Slide } from "hooper";
import "hooper/dist/hooper.css";
import jQuery from "jquery";
let $ = jQuery;
import * as Cookies from "js-cookie";
import AgoraRTC from "agora-rtc-sdk-ng";
import { RESOLUTION_ARR } from "../utils/Settings";
//import AgoraRTC from "https://cdn.agora.io/sdk/web/AgoraRTCSDK-2.1.0.js";
import db from "../../../components/firebaseInit";
//import { PlayerAPIConfig } from "../player-api-config";
import APIs from "@/components/APIInit";
import VideoPlayer from "@/components/VideoPlayer.vue";
import "../../../assets/player.css";
//import VueCompositionApi from "@vue/composition-api";
import playerLog from "@/views/Player/utils/PlayerLog";
import axios from "axios";
import router from "@/router";
import common from "@/common";
import { bus } from "@/main";
import VirtualBackgroundExtension from "agora-extension-virtual-background";
//applyColorBackground
import {
  changeForegroundType,
  segmentBackground,
  applyBlur,
  applyImageBackground,
  applyVideoBackground,
} from "virtual-bg";

// var clientError = {
//   1003: { code: "SEND_VIDEO_BITRATE_TOO_LOW", msg: "Poor network connection" },
//   3003: {
//     code: "SEND_VIDEO_BITRATE_TOO_LOW_RECOVER",
//     msg: "Connection slow. Retrying...",
//   },
//   1005: { code: "RECV_VIDEO_DECODE_FAILED", msg: "Poor network connection" },
//   3005: {
//     code: "RECV_VIDEO_DECODE_FAILED_RECOVER",
//     msg: "Connection slow. Retrying...",
//   },
// // };
// var streamError = {
//   "isErrorState:true;status:paused": { msg: "Retrying to connect..." },
// };
var avatarImageUrl =
  "https://firebasestorage.googleapis.com/v0/b/e2monair.firebasestorage.app/o/OA_UAT%2FDefaults%2Fimage%2Favatar.jpg?alt=media";

var injectStreamConfig = {
  width: 0,
  height: 0,
  videoGop: 30,
  videoFramerate: 15,
  videoBitrate: 400,
  audioSampleRate: 44100,
  audioChannels: 1,
};
//const constraints = (window.constraints = {
//  audio: true,
//  video: true,
//});
let vm;
let goLiveTimer;
let streamRepairTimer;
let ProfileRepairTimer;
let ReConnectCallTimer;
//const camerasLabels;
var testStream;
export default {
  components: {
    Hooper,
    Slide,
    VideoPlayer,
    //VueCompositionApi,
  },
  props: [
    "transcode",
    "videoProfile",
    "event_collectionName",
    "channel",
    "baseMode",
    "appId",
    "eventName",
    "roomId",
    "dialogSessionId",
    "breakoutRoomId",
    "dialTime",
    "pipMode",
    "memberList",
    "exStageUrl",
    "allAttendees1",
    "uid",
    "firstName",
    "fullName",
    "nameInitial",
    "profilePictureURL",
    "instance",
    "callSwitchingInProcess",
    "askForMicCam",
    "askForBrowserPermission",
    "endForAllEnabled",
    "newDesign",
    "DebugMode",
    "EnableAgoraProxy",
    "rememberSettings",
    "exPageId",
    "autoRecovery",
    "advancedAutoRecovery",
    "displayNetworkError",
    "enableLogUpload",
    "uploadLogLevel",
    "agoraPlayerClientsideLog",
    "showPlayerHeader",
    "hostOptionsEnabled",
    "hostCanMuteSpeaker",
    "hostCanHideSpeaker",
    "hostCanSpotlightSpeaker",
    "hostCanInviteAttendeeToStage",
    "userVirtualBGEnabled",
    "stageUrl",
    "isMobileView",
    "isIPadView",
  ],
  data() {
    return {
      video: null,
      c1: null,
      ctx1: null,
      ctx2: null,
      extension: null,
      processor: null,
      blurLevel: 10,
      blurLevelAgora: 1,
      showVirtualBGConfig: false,
      virtualBGConfigInProgress: false,
      userVirtualBGType: 0,
      userVirtualBGTab: 2,
      userVirtualBG: "",
      userVirtualBGTypeSelected: 0,
      userVirtualBGTabSelected: 2,
      userVirtualBGSelected: "",
      userVirtualBGImages: [
        "https://firebasestorage.googleapis.com/v0/b/uate2monair.appspot.com/o/OA_UAT%2FDefaults%2Fimage%2Fvirtual_background%2F1.jpg?alt=media",
        "https://firebasestorage.googleapis.com/v0/b/uate2monair.appspot.com/o/OA_UAT%2FDefaults%2Fimage%2Fvirtual_background%2F2.jpg?alt=media",
        "https://firebasestorage.googleapis.com/v0/b/uate2monair.appspot.com/o/OA_UAT%2FDefaults%2Fimage%2Fvirtual_background%2F3.jpg?alt=media",
        "https://firebasestorage.googleapis.com/v0/b/uate2monair.appspot.com/o/OA_UAT%2FDefaults%2Fimage%2Fvirtual_background%2F4.jpg?alt=media",
        "https://firebasestorage.googleapis.com/v0/b/uate2monair.appspot.com/o/OA_UAT%2FDefaults%2Fimage%2Fvirtual_background%2F5.jpg?alt=media",
        "https://firebasestorage.googleapis.com/v0/b/uate2monair.appspot.com/o/OA_UAT%2FDefaults%2Fimage%2Fvirtual_background%2F6.jpg?alt=media",
        "https://firebasestorage.googleapis.com/v0/b/uate2monair.appspot.com/o/OA_UAT%2FDefaults%2Fimage%2Fvirtual_background%2F7.jpg?alt=media",
        "https://firebasestorage.googleapis.com/v0/b/uate2monair.appspot.com/o/OA_UAT%2FDefaults%2Fimage%2Fvirtual_background%2F8.jpg?alt=media",
        "https://firebasestorage.googleapis.com/v0/b/uate2monair.appspot.com/o/OA_UAT%2FDefaults%2Fimage%2Fvirtual_background%2F9.jpg?alt=media",
        "https://firebasestorage.googleapis.com/v0/b/uate2monair.appspot.com/o/OA_UAT%2FDefaults%2Fimage%2Fvirtual_background%2F10.jpg?alt=media",
        "https://firebasestorage.googleapis.com/v0/b/uate2monair.appspot.com/o/OA_UAT%2FDefaults%2Fimage%2Fvirtual_background%2F11.jpg?alt=media",
        "https://firebasestorage.googleapis.com/v0/b/uate2monair.appspot.com/o/OA_UAT%2FDefaults%2Fimage%2Fvirtual_background%2F12.jpg?alt=media",
      ],
      userVirtualBGColors: [
        "#f7f1e3",
        "#cc8e35",
        "#cd6133",
        "#dff9fb",
        "#95afc0",
        "#22a6b3",
        "#54a0ff",
        "#808e9b",
        "#10ac84",
        "#535c68",
        "#1e272e",
      ],
      showTestStream: false,
      unmuteRequester: "Host",
      timerVisible: false,
      timerLabel: "",
      timerValue: "",
      endsIn: 0,
      viewersCountVisible: false,
      attendeeEnabled: false,
      viewersCount: 0,
      switchTableVisible: false,
      moreOptionVisibility: false,
      hiddenSpeakerListVisibility: false,
      //hiddenSpeakerList: [],
      hiddenSpeakerList: [
        { AttendeeId: 111 },
        { AttendeeId: 222 },
        { AttendeeId: 333 },
        { AttendeeId: 444 },
        { AttendeeId: 555 },
        { AttendeeId: 666 },
      ],

      minOutgoungBandwidth: 100,
      minIncomingBandwidth: 100,
      outgoungBandwidth: 100,
      incomingBandwidth: 100,
      networkType: "",
      playerLog: playerLog,
      logUserIDs: [],
      logRecipientId: "onairadmin@e2m.live",
      //camerasLabels,
      //microphones,
      //speakers,
      //getDevicesLabels,
      hasConnection: true,
      playerWaitText: "Please wait, stage will be live soon...",
      IsLive: true,
      IsGoLive: false,

      player: this,
      PlayerAPIConfig: null,
      channelName: "",
      isMicOn: true,
      isRHOn: false,
      isVideoOn: true,
      isShareOn: true,
      inProcess: false,
      playerLogo: "",
      playerLogoLink: "",
      OnDemandTypeID: 1,
      LiveStreamTypeID: 2,
      LivePanelTypeID: 3,
      RoundTableTypeID: 4,
      O2OTypeID: 6,
      E2OTypeID: 7,

      microphoneOptions: [],
      microphone: {},
      speakerOptions: [],
      speaker: {},
      cameraOptions: [],
      camera: {},
      videoResolutions: RESOLUTION_ARR,
      videoResolution: "360p_7",

      mics: [],
      currentMic: {},
      cams: [],
      currentCam: {},
      playbackDevices: [],
      currentPlaybackDevice: {},
      currentVideoProfile: {
        label: "Medium",
        detail: "480 X 360, 15fps, 320Kbps",
        value: "360p_7",
      },
      videoProfiles: [
        // {
        //   label: "Lowest",
        //   detail: "160 X 120, 15fps, 65Kbps",
        //   value: "120p_1",
        // },
        {
          label: "Low",
          detail: "320 X 240, 15fps, 200Kbps",
          value: "240p_1",
        },
        {
          label: "Medium",
          detail: "480 X 360, 15fps, 320Kbps",
          value: "360p_7",
        },
        {
          label: "High",
          detail: "640 X 480, 15fps, 500Kbps",
          value: "480p_1",
        },
        // {
        //   label: "HD",
        //   detail: "1280 X 720, 15fps, 1130Kbps",
        //   value: "720p_1",
        // },
        // {
        //   label: "Full HD",
        //   detail: "1920 X 1080, 15fps, 2080Kbps",
        //   value: "1080p_1",
        // },
        // {
        //   label: "Super HD",
        //   detail: "1920 X 1080, 30fps, 3000Kbps",
        //   value: "1080p_2",
        // },
      ],

      playerSettings: {
        cameraOptions: [],
        camera: {},
        cameraOld: {},
        microphoneOptions: [],
        microphone: {},
        speakerOptions: [],
        speaker: {},
        videoProfile: "360p_7",
      },

      autoStartRecording: false,
      enableDeviceAccessibility: false,
      callStep: 0,

      isSupportedDevice: false,
      isSupportedBrowser: false,
      hasBrowserDeviceAccess: false,

      allowMic: false,
      allowCam: false,
      hasMicAccess: false,
      hasCamAccess: false,
      micAccessChecked: false,
      camAccessChecked: false,

      tempValues: null,

      sessionTypeId: 0,
      session: null,
      sessionId: "",
      roundTable: null,
      roundTableId: "",
      o2oMeeting: null,
      meetingId: "",
      meetingHostId: "",
      allAttendees: [],
      allHosts: [],
      allCoHosts: [],
      allSpeakers: [],
      attendeeType: 4, //1:Host, 2,Speaker, 3:Guest, 4:Attendee
      userType: 4, //1:Host, 2,Speaker, 3:Guest, 4:Attendee
      //attendeeMode: "audience", //"video", "share","audio-only"
      clientId: "",
      eventId: "",
      RecResourceId: "",
      RecSid: "",

      client: null,
      localTracks: {
        videoTrack: null,
        audioTrack: null,
      },
      remoteUsers: {},
      oldUserKey: 0,
      newUserKey: 0,
      userCount: 0,
      IsRTMP: false,
      AgoraRTMPStarted: false,
      AgoraRTMPStartedBy: "",
      AgoraRTMPInProcess: false,
      ShowAgoraRTMPButton: true,

      //RTMPStreamURL: "rtmp://global-live.mux.com:5222/app",
      //RTMPStreamKey: "c3644ef8-958c-f8a0-883a-856c67f8d2f5",
      RTMPStreamURL: "",
      RTMPStreamKey: "",
      //RTMPPlaybackURL:"https://stream.mux.com/dwAGZxSlCJU4TAEfvheM69LFP1B02bzAD29rVmAZsQp4.m3u8",
      vueBindingEnabled: false,
      // Agora client options
      options: {
        appid: null,
        channel: null,
        uid: null,
        token: null,
      },
      localStream: null,
      shareClient: null,
      shareStream: null,
      liveClient: null,
      liveStream: null,
      displayMode: "tile",
      streamList: [],
      streamUserList: [],
      readyState: false,
      localStreamVolume: 0,
      manuallyStopped: false,
      recordingStarted: false,
      recordingStartStopInProcess: false,

      testIdStartsAfter: 2000000000,
      testUid: 2000000000,
      shareIdStartsAfter: 1000000000,
      shareUid: 1000000000, //"share",
      latestShareUid: 0,
      screenStartedCount: 0,
      sessionVideoProfile: "",
      shareVideoProfile: "720p_1",
      volumeLevel: 100,
      readyShareState: false,
      readyLiveState: false,
      activeScreenUID: 0,
      pinSelected: false,
      specialTileViewMinTiles: 500,
      specialTileViewMaxTiles: 700,
      settings: {
        maxScrollbarLength: 100,
      },
      ActiveSpeakerFocus: false,
      ActiveSpeakerMinVolume: 10,
      ActiveSpeakerSorting: false,

      //DebugMode: false,
      ShowAudioVolume: false,
      ShowVideoProfile: false,
      DisplayAudienceCounter: true,
      DisplayCompanyAndTitleInVideoTile: true,

      AllowScreenShare: false,
      AllowRecording: false,
      AutoStartRecording: false,
      AllowPinVideoTile: false,
      PinShareScreen: true,
      AllowRaiseHand: true,

      micMuteUnmuteInProcess: false,
      cameraList: [],
      liveVideoApiDetails: {
        AppID: "605f401455444442838e00cb859c037b",
        Certificate: "8f472eef21f64cba97c105eab797522f",
        SpeakerTokenApiUrl:
          "https://onairapi.e2m.live/get-session-token-speaker",
        AttendeeTokenApiUrl:
          "https://onairapi.e2m.live/get-session-token-attendee",
        TokenValidityHours: "72",
      },
      token: "",
      IsCameraExist: false,
      IsMicExist: false,
      IsSpeakerExist: false,

      useE2MInjection: false,
      useAgoraInjection: false,
      streamPlayerOptions: {
        autoplay: true,
        controls: false,
        //controlBar: {
        //  timeDivider: false,
        //  durationDisplay: false,
        //},
        // poster: 'https://surmon-china.github.io/vue-quill-editor/static/images/surmon-5.jpg'
      },
      liveStreamStarted: false,
      hlsInjectionURL: "",
      //hlsInjectionURL:
      //  "https://d190a6h3bsi1px.cloudfront.net/OAUAT/C1591904892446/E1591907102804/198000/Video_Final_mp4.m3u8",
      //rtmpInjectionURL:
      //  "https://d2znwc15337no5.cloudfront.net/OA_UAT/C1591205467009/E1591206650065/1590000/index.m3u8",
      rtmpInjectionURL: "",
      //rtmpInjectionURL:
      //  "https://d3dnabu1axuoxq.cloudfront.net/stream/index.m3u8",
      //rtmpInjectionURL:
      //  "rtmp://x.rtmp.youtube.com/live2",
      //video: {},
      audioSettingsOpened: false,
      videoSettingsOpened: false,

      displayNextMeetingJoinLink: false,
      enableNextMeetingJoinLink: false,
      nextMeetingId: "",
      nextMeetingAttendeeName: "",
      nextMeetingAttendeeInitial: "",
      nextMeetingAttendeeProfilePictureURL: "",
      entryType: 0,
      isInvited: false,
      displayInviteToStage: false,
      enableInviteSessionAttendee: false,
      isGuestSpeaker: false,
      showMicCamPermission: false,
    };
  },

  computed: {
    CanvasItems() {
      var result = [];
      if (vm.newUserKey > vm.oldUserKey) {
        vm.oldUserKey = vm.newUserKey;
        for (var key in vm.remoteUsers) {
          result.push(vm.remoteUsers[key]);
        }
      }
      return result;
    },
    attendeeMode: function () {
      //1:Host, 2,Speaker, 3:Guest, 4:Attendee
      //attendeeMode: "audience", //"video", "share","audio-only"
      if (vm.userType == 1 || vm.userType == 2 || vm.userType == 3) {
        return "video";
      } else {
        return "audience";
      }
    },
    attendeeTypeName: function () {
      let typeName = "Attendee";
      if (vm.sessionTypeId == vm.E2OTypeID) {
        if (vm.attendeeType == 1) {
          typeName = "Booth Representative";
        } else if (vm.attendeeType != 4) {
          typeName = "Visitor";
        }
      } else {
        let coHosts = [];
        if (vm.allCoHosts) {
          //alert("attendeeTypeName:" + vm.allCoHosts.length);
          //alert("uid:" + vm.uid);
          coHosts = vm.allCoHosts.filter(function (item) {
            //alert(" item.AttendeeId:" + item.AttendeeId);
            return item.AttendeeId == vm.uid;
          });
          //alert("coHosts:" + coHosts.length);
        }
        if (vm.attendeeType == 1) {
          if (
            location.host == "campus.edulife.sg" ||
            vm.LocalhostDomain() == "campus.edulife.sg"
          ) {
            typeName = "Teacher";
          } else {
            typeName = "Host";
          }
        } else if (coHosts.length > 0) {
          typeName = "Co-Host";
        } else if (vm.attendeeType == 2) {
          if (
            location.host == "campus.edulife.sg" ||
            vm.LocalhostDomain() == "campus.edulife.sg"
          ) {
            typeName = "Student";
          } else {
            typeName = "Speaker";
          }
        } else if (vm.attendeeType == 3) {
          if (
            location.host == "campus.edulife.sg" ||
            vm.LocalhostDomain() == "campus.edulife.sg"
          ) {
            typeName = "Student";
          } else {
            typeName = "Guest";
          }
        }
      }
      return typeName;
    },
    //isCallStarted: function () {

    //},
    lPlayer() {
      return vm.$refs.lPlayer.player;
    },
    //video() {
    //  return vm.$refs.video;
    //},
    isCurrentUserCoHost: function () {
      let result = false;
      if (vm.uid) {
        result = vm.isUserCoHost(vm.uid);
      }
      return result;
    },
  },

  watch: {
    // nameInitial(val) {
    //   alert(val);
    // },
    isVideoOn(val) {
      if (val) {
        vm.openMicCamAccessPopup(true);
      } else {
        vm.showTestStream = false;
        if (testStream) {
          testStream.getTracks().forEach(function (track) {
            track.stop();
          });
        }
        testStream = null;
      }
    },
    currentMic(val) {
      //alert("watch");
      if (val) {
        vm.switchMicrophone(val.deviceId);
      }
    },
    currentCam(val) {
      //alert("watch");
      if (val) {
        vm.switchCamera(val.deviceId);
      }
    },
    currentVideoProfile(val) {
      //alert("watch");
      if (val) {
        vm.switchVideoProfile(val.value);
      }
    },
    currentPlaybackDevice(val) {
      //alert("watch");
      if (val) {
        vm.switchPlaybackDevice(val.deviceId);
      }
    },

    hasConnection: function (val) {
      if (val) {
        if (vm.sessionTypeId < 5) {
          vm.playerWaitText = "Please wait, stage will be live soon...";
        } else {
          vm.playerWaitText = "";
        }
      } else {
        vm.playerWaitText = "Weak or No Internet. Trying to Reconnect...";
        //vm.onEndCall();
      }
    },
    outgoungBandwidth: function () {
      //if (vm.userType < 4) {
      //  if (val < vm.minOutgoungBandwidth) {
      //    $("#player-network-error-" + vm.uid).html("Slow Network Detected");
      //    $("#player-network-error-" + vm.uid).removeClass("d-none");
      //  } else {
      //    $("#player-network-error-" + vm.uid).addClass("d-none");
      //  }
      //}
    },
    incomingBandwidth: function () {
      //if (val < vm.minIncomingBandwidth) {
      //  $("#player-network-error-" + vm.uid).html("Poor Network Detected");
      //  $("#player-network-error-" + vm.uid).removeClass("d-none");
      //} else {
      //  $("#player-network-error-" + vm.uid).addClass("d-none");
      //}
    },
    //userType: function () {
    //  //attendeeMode: "audience","video", "share","audio-only"
    //  if (vm.userType == 1 || vm.userType == 2 || vm.userType == 3) {
    //    vm.attendeeMode = "video";
    //  } else {
    //    vm.attendeeMode = "audience";
    //  }
    //  //alert(vm.attendeeMode);
    //},
    streamList: function () {
      vm.showHideVideoPanel();
    },
    //localStream: function () {
    //  vm.showHideVideoPanel();
    //},
    newUserKey: function () {
      let speakerIdList = [];
      for (var key in vm.remoteUsers) {
        speakerIdList.push(vm.remoteUsers[key].uid);
      }
      vm.userCount = speakerIdList.length;
      vm.$emit("SpeakerPanelOnUpdate", speakerIdList);
    },
    recordingStarted: function (val) {
      vm.$emit("recordingStatusChanged", vm.recordingStarted);
      if (val) {
        let shareScreenCount = vm.shareScreenCount();
        if (vm.shareClient) {
          if (shareScreenCount == 1) {
            //alert(shareScreenCount);
            vm.updateRecordingLayout(true);
          } else if (shareScreenCount > 1) {
            //alert(shareScreenCount);
            let shareId = $("#ag-canvas").attr("shareid");
            if (shareId && !isNaN(shareId)) {
              shareId = parseInt(shareId);
              if (shareId == vm.shareUid) {
                vm.updateRecordingLayout(true);
              }
            }
          }
        }
      }
    },
    DebugMode(val) {
      vm.ShowAudioVolume = val;
      vm.ShowVideoProfile = val;
    },
  },

  created() {
    vm = this;
    bus.$on("onCloseVideoChat", (doNotAsk) => {
      if (doNotAsk) {
        vm.onEndCall();
      } else {
        vm.onConfirmEndCall();
      }
    });
    bus.$on("switchToTileView", () => {
      if (vm.userCount > 1 && vm.displayMode == "pip") {
        vm.hidePopup();
        vm.switchToTileView();
      }
    });
    vm.DetectBrowser();
    //vm.shareUid = vm.shareUid + "_" + vm.uid.toString();
    vm.shareUid = vm.shareIdStartsAfter + parseInt(vm.uid);
    vm.PlayerAPIConfig = APIs.PlayerAPIConfig;
    for (let i = 0; i < vm.userVirtualBGImages.length; i++) {
      vm.userVirtualBGImages[i] = vm.getCDNUrl(vm.userVirtualBGImages[i]);
    }
    vm.setFirebaseLivePanelAppsettings();
    vm.readAllAttendees();

    //alert("created");
    //vm.StartCall();
    //alert("window-height:" + $(window).height());
    //alert("window-width:" + $(window).width());

    //alert("document-height:" + $(document).height());
    //alert("document-width:" + $(document).width());

    //alert("window.screen-height:" + window.screen.height);
    //alert("window.screen-width:" + window.screen.width);
    if (window.screen.height > 1000) {
      vm.specialTileViewMinTiles = 500;
      vm.specialTileViewMaxTiles = 900;
    }
    //alert(window.screen.width);
    if (window.screen.width >= 1024) {
      vm.isSupportedDevice = true;
    }
  },

  mounted() {
    vm.validateDevices();
    vm.detectMicPrivacyChangeListener();
    vm.detectCamPrivacyChangeListener();
    vm.detectDeviceChange();
    $('[data-toggle="tooltip"]').tooltip();
    this.$nextTick(() => {
      // add listener to control btn group
      let canvas = document.querySelector("#ag-canvas");
      //let sponsorPanel = document.querySelector("#ag-sponsor-panel");
      //let btnGroup = document.querySelector("#ag-button-panel");
      canvas.addEventListener("mousemove", () => {
        if (global._toolbarToggle) {
          clearTimeout(global._toolbarToggle);
        }
        //sponsorPanel.classList.remove("active");
        //btnGroup.classList.add("active");
        global._toolbarToggle = setTimeout(function () {
          //sponsorPanel.classList.add("active");
          //btnGroup.classList.remove("active");
        }, 10000);
      });
    });
  },

  beforeUpdate() {
    //alert("beforeUpdate")
    if (vm.streamList.length == 1) {
      $("#ag-canvas").addClass("one");
    } else {
      $("#ag-canvas").removeClass("one");
    }
    let speakerIdList = [];
    vm.streamList.forEach((element) => {
      let id = element.getId();
      //if (id.indexOf("share" > -1)) {
      if (id < vm.shareIdStartsAfter) {
        speakerIdList.push(id);
      }
    });
    //alert(speakerIdList.length);
    //vm.$emit("SpeakerPanelOnUpdate", speakerIdList);
  },

  beforeDestroy() {
    this.client && this.client.unpublish(this.localStream);
    this.localStream && this.localStream.close();
    if (vm.client && vm.EnableAgoraProxy) {
      vm.client.stopProxyServer();
    }
    this.client &&
      this.client.leave(
        () => {
          console.log("Client succeed to leave.");
        },
        () => {
          console.log("Client failed to leave.");
        }
      );

    if (goLiveTimer) {
      clearInterval(goLiveTimer);
    }
    if (streamRepairTimer) {
      clearInterval(streamRepairTimer);
    }
    if (ProfileRepairTimer) {
      clearInterval(ProfileRepairTimer);
    }
    if (ReConnectCallTimer) {
      clearInterval(ReConnectCallTimer);
    }
    vm.showTestStream = false;
    if (testStream) {
      testStream.getTracks().forEach(function (track) {
        track.stop();
      });
    }
    testStream = null;
  },

  destroyed() {
    bus.$off("onCloseVideoChat");
    bus.$off("switchToTileView");
  },

  methods: {
    testPermission() {
      $("#enableModalCenter").show();
      $("#player-not-ready").hide();
    },
    detectMicPrivacyChangeListener() {
      navigator.permissions
        .query(
          { name: "microphone" }
          // { name: 'geolocation' }
          // { name: 'notifications' }
          // { name: 'midi', sysex: false }
          // { name: 'midi', sysex: true }
          // { name: 'push', userVisibleOnly: true }
          // { name: 'push' } // without userVisibleOnly isn't supported in chrome M45, yet
        )
        .then(function (permissionStatus) {
          //alert("Microphone State: " + permissionStatus.state); // granted, denied, prompt
          permissionStatus.onchange = function () {
            //alert("Microphone Permission changed to " + this.state);
            if (this.state == "granted") {
              vm.hasMicAccess = true;
            } else if (this.state == "denied") {
              vm.hasMicAccess = false;
              vm.micAccessChecked = false;
              vm.isMicOn = false;
            } else if (this.state == "prompt") {
              vm.promptToAllowMicAccess();
            }
          };
        });
    },
    detectCamPrivacyChangeListener() {
      navigator.permissions
        .query(
          { name: "camera" }
          // { name: 'geolocation' }
          // { name: 'notifications' }
          // { name: 'midi', sysex: false }
          // { name: 'midi', sysex: true }
          // { name: 'push', userVisibleOnly: true }
          // { name: 'push' } // without userVisibleOnly isn't supported in chrome M45, yet
        )
        .then(function (permissionStatus) {
          //alert("Camera State: " + permissionStatus.state); // granted, denied, prompt
          permissionStatus.onchange = function () {
            debugger;
            //alert("Camera Permission changed to " + this.state);
            if (this.state == "granted") {
              vm.hasCamAccess = true;
            } else if (this.state == "denied") {
              vm.hasCamAccess = false;
              vm.camAccessChecked = false;
              vm.isVideoOn = false;
              if ($("#profileImage_" + vm.uid)) {
                $("#profileImage_" + vm.uid).removeClass("d-none");
              }
              if (vm.remoteUsers[vm.uid].stream.videoTrack) {
                vm.remoteUsers[vm.uid].stream.videoTrack.setEnabled(false);
              }
            } else if (this.state == "prompt") {
              vm.promptToAllowCamAccess();
            }
          };
        });
    },
    promptToAllowMicAccess() {
      var constraints = (window.constraints = {
        audio: true,
      });
      if (vm.currentMic && vm.currentMic.deviceId) {
        //alert("currentMic : "+vm.currentMic.deviceId)
        constraints.audio = { deviceId: vm.currentMic.deviceId };
      }
      //var errorElement = document.querySelector("#errorMsg");
      navigator.mediaDevices
        .getUserMedia(constraints)
        .then(function () {
          //alert("hasMicAccess");
          vm.hasMicAccess = true;
          vm.micAccessChecked = true;
          if (vm.hasMicAccess && $("#enableModalCenter").hasClass("show")) {
            vm.isMicOn = true;
          }
        })
        .catch(function (error) {
          // alert("error hasMicAccess: " + error);
          vm.hasMicAccess = false;
          vm.micAccessChecked = true;
          console.log(error);
        });
    },
    promptToAllowCamAccess() {
      var constraints = (window.constraints = {
        video: true,
      });
      if (vm.currentCam && vm.currentCam.deviceId) {
        //alert("currentCam : "+vm.currentCam.deviceId)
        constraints.video = {
          deviceId: vm.currentCam.deviceId,
        };
      }
      //var errorElement = document.querySelector("#errorMsg");
      var video = document.querySelector("#videoTest");
      navigator.mediaDevices
        .getUserMedia(constraints)
        .then(async (stream) => {
          vm.hasCamAccess = true;
          vm.camAccessChecked = true;
          debugger;
          //await vm.showCameraPreview();

          // alert("hasCamAccess", vm.hasCamAccess);
          if (vm.hasCamAccess && $("#enableModalCenter").hasClass("show")) {
            vm.isVideoOn = true;
            testStream = stream;
            // alert("showTestStream", vm.showTestStream);
            vm.showTestStream = true;
            video.srcObject = stream;
          }
          //alert(vm.hasCamAccess)
        })
        .catch(function (error) {
          vm.virtualBGConfigInProgress = false;
          // alert("error hasCamAccess: " + error);
          vm.hasCamAccess = false;
          vm.camAccessChecked = true;
          console.log(error);
          //alert(vm.hasCamAccess)
        });
    },
    detectDeviceChange() {
      AgoraRTC.onMicrophoneChanged = (info) => {
        // alert("Microphone changed!: " + info.state);
        // alert("Microphone changed!: " + info.device.deviceId);
        debugger;
        var apply = false;
        if (
          info.state == "INACTIVE" &&
          info.device.deviceId == vm.currentMic.deviceId
        ) {
          apply = true;
          vm.currentMic = {};
        } else if (info.state == "ACTIVE" && !vm.currentMic.deviceId) {
          apply = true;
        }
        vm.getMicrophones(apply);
        if (
          info.device.label &&
          info.device.label.toLowerCase().includes("cam")
        ) {
          vm.getCameras(apply);
        }
      };
      AgoraRTC.onCameraChanged = (info) => {
        debugger;
        // alert("Camera changed!: " + info.state);
        // alert("Camera changed!: " + info.device.deviceId);
        debugger;
        var apply = false;
        if (
          info.state == "INACTIVE" &&
          info.device.deviceId == vm.currentCam.deviceId
        ) {
          apply = true;
          vm.currentCam = {};
        } else if (
          info.state == "ACTIVE" &&
          (!vm.currentCam.deviceId ||
            info.device.deviceId == vm.currentCam.deviceId)
        ) {
          apply = true;
        }
        vm.getCameras(apply);
      };
      AgoraRTC.onPlaybackDeviceChanged = (info) => {
        // alert("PlaybackDevice changed!: " + info.state);
        // alert("PlaybackDevice changed!: " + info.device.deviceId);
        debugger;
        var apply = false;
        if (
          info.state == "INACTIVE" &&
          info.device.deviceId == vm.currentPlaybackDevice.deviceId
        ) {
          apply = true;
          //vm.currentPlaybackDevice = {};
        } else if (
          info.state == "ACTIVE" &&
          !vm.currentPlaybackDevice.deviceId
        ) {
          apply = true;
        }
        vm.getPlaybackDevices(apply);
      };
    },
    //New Design START
    isUserInCall: function (id) {
      let result = false;
      if (id && vm.remoteUsers[id]) {
        result = true;
      }
      return result;
    },
    cancelJoin() {
      // alert("cancelJoin");
      $("#enableModalCenter").modal("hide");
      vm.showMicCamPermission = false;
      vm.showTestStream = false;
      if (testStream) {
        testStream.getTracks().forEach(function (track) {
          track.stop();
        });
      }
      testStream = null;
      if (vm.entryType == 1) {
        vm.AcceptToEnterStage(false);
        return;
      } else if (vm.entryType == 2) {
        vm.handleRH(false);
        return;
      }
      vm.$emit("livePanelOnEnd", null, true);
    },
    displayTimer(isVisible, label, value, endsIn) {
      //console.log(isVisible, label, value, endsIn);
      //vm.timerVisible = isVisible;
      //vm.timerLabel = label + ":";
      //vm.timerValue = value;
      //vm.endsIn = endsIn;
      if (isVisible) {
        $("#session-end-countdown").removeClass("d-none");
      } else {
        $("#session-end-countdown").addClass("d-none");
      }
      $("#timerLabel").html(label);
      $("#timerValue").html(value);
      if (endsIn > 60 || !vm.IsLive) {
        $("#timerValue").attr("class", "ml-2");
      } else {
        $("#timerValue").attr("class", "ml-2 blink");
      }
    },
    AttendeeEnabled(val) {
      vm.attendeeEnabled = val;
    },
    displayViewersCount(isVisible, value) {
      if (value) {
        vm.viewersCount = value;
      }
      if (vm.DisplayAudienceCounter) {
        let coHosts = [];
        if (vm.allCoHosts) {
          coHosts = vm.allCoHosts.filter(function (item) {
            return item.AttendeeId == vm.uid;
          });
        }
        if (vm.attendeeType < 3 || coHosts.length > 0) {
          vm.viewersCountVisible = true;
        } else {
          if (
            vm.session &&
            vm.session.SessionTypeDetails &&
            vm.session.SessionTypeDetails.ShowAttendeeList
          ) {
            vm.viewersCountVisible = isVisible;
          }
        }
      } else {
        vm.viewersCountVisible = false;
      }
    },
    displaySwitchTable(isVisible) {
      vm.switchTableVisible = isVisible;
    },
    displayTablesPopup() {
      vm.$emit("displayTablesPopup");
    },
    hidePopup() {
      if (vm.audioSettingsOpened) {
        vm.toggleAudioSettings();
      }
      if (vm.videoSettingsOpened) {
        vm.toggleVideoSettings();
      }
      if (vm.hiddenSpeakerListVisibility) {
        vm.toggleHideSpeaker();
      }
      vm.moreOptionVisibility = false;

      $(".ag-option-group").addClass("hidden");
    },
    toggleAudioSettings: function (e) {
      if (!vm.audioSettingsOpened) {
        vm.hidePopup();
      }
      vm.audioSettingsOpened = !vm.audioSettingsOpened;
      if (vm.audioSettingsOpened) {
        vm.getAudioSettings();
        if (vm.videoSettingsOpened) {
          vm.toggleVideoSettings();
        }
      }
      if (e) {
        e.stopPropagation();
      }
    },
    toggleVideoSettings: function (e) {
      if (!vm.videoSettingsOpened) {
        vm.hidePopup();
      }
      vm.videoSettingsOpened = !vm.videoSettingsOpened;
      if (vm.videoSettingsOpened) {
        vm.getVideoSettings();
        if (vm.audioSettingsOpened) {
          vm.toggleAudioSettings();
        }
      }
      if (e) {
        e.stopPropagation();
      }
    },
    playerSettingsOnClick(e) {
      e.stopPropagation();
    },
    HiddenSpeakersPanelOnClick(e) {
      e.stopPropagation();
    },
    MoreOptionPanelOnClick(e) {
      e.stopPropagation();
    },
    displaySessionDetails() {
      vm.$emit("displaySessionDetails");
    },
    showNextMeetingJoinLink(display, enabled) {
      if (vm.nextMeetingId) {
        vm.displayNextMeetingJoinLink = display;
        vm.enableNextMeetingJoinLink = enabled;
      } else {
        vm.nextMeetingId = "";
        vm.displayNextMeetingJoinLink = false;
        vm.enableNextMeetingJoinLink = false;
      }
    },
    setNextMeetingData(meetingId, meeting) {
      if (meetingId && meeting && meeting.MeetingId) {
        vm.nextMeetingId = meetingId;
        //console.log("showNextMeetingJoinLink----------------" + meetingId);
        if (vm.uid == meeting.SenderId) {
          vm.nextMeetingAttendeeName = meeting.Name;
          vm.nextMeetingAttendeeProfilePictureURL = meeting.Image;
          vm.nextMeetingAttendeeInitial = common.getInitials(
            vm.nextMeetingAttendeeName
          );
        } else if (vm.uid == meeting.ReceiverId) {
          vm.nextMeetingAttendeeName = meeting.Organizername;
          vm.nextMeetingAttendeeProfilePictureURL = meeting.Organizerprofilepic;
          vm.nextMeetingAttendeeInitial = common.getInitials(
            vm.nextMeetingAttendeeName
          );
        }
      } else {
        vm.nextMeetingId = "";
        vm.displayNextMeetingJoinLink = false;
        vm.enableNextMeetingJoinLink = false;
      }
    },
    //New Design END
    shareScreenCount() {
      let result = 0;
      let shareScreens = vm.streamList.filter(function (item) {
        return item.getId() > vm.shareIdStartsAfter;
      });
      result = shareScreens.length;

      if (result == 0) {
        for (var key in vm.remoteUsers) {
          var user = vm.remoteUsers[key];
          if (user.uid > vm.shareIdStartsAfter) {
            result++;
          }
        }
      }
      return result;
    },
    // shareScreenCount() {
    //   let shareScreens = vm.streamList.filter(function (item) {
    //     return item.getId() > vm.shareIdStartsAfter;
    //   });
    //   return shareScreens.length;
    // },
    canStopshareScreen() {
      let shareScreens = vm.streamList.filter(function (item) {
        return item.getId() > vm.shareIdStartsAfter;
      });
      return shareScreens.length;
    },
    updateSessionSpeakers(session) {
      if (session) {
        if (session.SessionTypeDetails) {
          vm.viewersCountVisible = session.SessionTypeDetails.ShowAttendeeList
            ? session.SessionTypeDetails.ShowAttendeeList
            : false;
        }
        let speakers = session.MappedSpeakers;
        let speakersToUpdate = [];
        speakers.map(function (item) {
          let spkrs = vm.allSpeakers.filter(function (val) {
            return item.AttendeeId == val.AttendeeId;
          });
          if (spkrs.length > 0) {
            speakersToUpdate.push(item.AttendeeId);
            spkrs[0].FirstName = item.FirstName;
            spkrs[0].LastName = item.LastName;
            spkrs[0].Name = item.Name;
            spkrs[0].Company = item.Company;
            spkrs[0].Designation = item.Designation;
            spkrs[0].ProfilePictureURL = item.ProfilePictureURL;
          } else {
            speakersToUpdate.push(item.AttendeeId);
            vm.allSpeakers.push(item);
          }
        });

        speakers.map(function (item) {
          if (speakersToUpdate.includes(item.AttendeeId)) {
            $("#profile-" + item.AttendeeId + " .ag-profile-name").html(
              item.Name
            );
            $("#profile-" + item.AttendeeId + " .ag-profile-title").html(
              item.Designation
            );
            $("#profile-" + item.AttendeeId + " .ag-profile-company").html(
              item.Company
            );
            let profileImage = item.ProfilePictureURL;
            if (profileImage == avatarImageUrl) {
              profileImage = "";
            }
            if (profileImage == "") {
              let nameInitial = common.getInitials(item.Name);
              $("#profileImage_" + item.AttendeeId + ".ag-profile-image").html(
                "<h4>" + nameInitial + "</h4>"
              );
            } else {
              $("#profileImage_" + item.AttendeeId + ".ag-profile-image").html(
                "<img src='" + profileImage + "' height='132px' width='132px'/>"
              );
            }
            //$("#profileImage_" + item.AttendeeId + ".ag-profile-image img").attr(
            //  "src",
            //  profileImage
            //);
          }
        });
      }
    },
    UpdateRTGuests(allGuests) {
      //alert(allGuests.length);
      allGuests.map(function (item) {
        let speakers = vm.allSpeakers.filter(function (speaker) {
          return item.AttendeeId == speaker.AttendeeId;
        });
        if (speakers.length == 0) {
          vm.allSpeakers.push(item);
        }
      });
      //vm.allSpeakers = allGuests;
    },
    changeConnectionState: function (val) {
      vm.hasConnection = val;
    },
    DetectBrowser() {
      //var docRefGeneralSettings = db
      //  .collection("OA_UAT")
      //  .doc("GeneralSettings");
      //docRefGeneralSettings.get().then(function (doc) {
      //  if (doc.exists) {
      //    if (doc.data().IsBrowserCheck !== undefined) {
      //      if (doc.data().IsBrowserCheck === true) {
      if (vm.$browserDetect.isChrome) {
        vm.isSupportedBrowser = true;
      } else if (vm.$browserDetect.isEdge) {
        vm.isSupportedBrowser = true;
      } else if (vm.$browserDetect.isChromeIOS) {
        vm.isSupportedBrowser = true;
      } else if (vm.$browserDetect.meta.name === "Edge") {
        vm.isSupportedBrowser = true;
      }
      //      } else {
      //        vm.IsBrowserCheck = false;
      //      }
      //    } else {
      //      vm.IsBrowserCheck = false;
      //    }
      //  } else {
      //    vm.IsBrowserCheck = false;
      //  }
      //});
    },

    closeModal() {
      $(".modal").modal("hide");
    },
    onLPlayerVolumeChange(player) {
      console.log("player play!", player);
      //////let volumeLevel = parseFloat(player.techGet_("volume"));
      //////volumeLevel = isNaN(volumeLevel) ? 1 : volumeLevel;
      //////vm.volumeLevel = parseInt(volumeLevel * 100);
      //////vm.muted = player.muted();
      //if (player.muted()) {
      //  vm.volumeLevel = 0;
      //}
      //alert(vm.volumeLevel);
    },
    onLPlayerPlay(player) {
      //////player.muted(vm.muted);
      console.log("player play!", player);
      //player.usingNativeControls_ = false;
      //player.removeTechControlsListeners_();
      //this.removeClass("vjs-using-native-controls");
    },
    onLPlayerReady(player) {
      //alert("aa");
      //alert($(window).findControl("vjs_video_3"));
      //alert($(window).querySelector("#ag-canvas"));
      console.log("player ready!", player);
      //vm.player.usingNativeControls_ = false;
      //vm.player.removeTechControlsListeners_();
      //vm.player.removeTechControlsListeners_();
      //vm.player.removeClass("vjs-using-native-controls");
      //vm.player.techCall_("setPlaysinline", false);
      //if (vm.player.tech_) {
      //  vm.player.techCall_("setAutoplay", false);
      //}
      //controls autoplay muted aspectRatio allow="autoplay; fullscreen"
      //setTimeout(() => {
      //  //alert();
      //  //vm.player.autoplay(true);
      //  //vm.player.trigger("loadstart");
      //  //vm.player.trigger("firstplay");
      //  //vm.player.manualAutoplay_(vm.player.autoplay());
      //  //vm.player.options_.autoplay = true;
      //  //let promise;
      //  // if muted defaults to true
      //  // the only thing we can do is call play
      //  //promise = vm.player.play();
      //  //promise.catch(false);
      //  vm.player.play();
      //}, 5000);
      //alert("bb");
      //player.play();
    },
    playStream: function (source) {
      const video = {
        //autoplay: true,
        //controls: true,
        //techOrder: ["flash", "html5"],
        //sourceOrder: true,
        //Promise: vm.player.options_.Promise,
        withCredentials: false,
        type: "application/x-mpegurl",
        src: source,
        //sources: [
        //  {
        //    type: "rtmp/mp4",
        //    src: "application/x-mpegurl",
        //  },
        //],
      };
      vm.lPlayer.reset(); // in IE11 (mode IE10) direct usage of src() when <src> is already set, generated errors,
      vm.lPlayer.src(video);
      // vm.player.load()
      //vm.player.trigger("usingnativecontrols");
      //vm.player.trigger("usingcustomcontrols");
      //vm.player.usingNativeControls_ = false;
      //vm.player.autoplay(true);

      //////vm.streamPlayer.muted(vm.muted);
      //////vm.streamPlayer.volume(vm.volumeLevel / 100);
      //vm.streamPlayer.currentTime(timeElapsed);
      //vm.streamPlayer.play();
      //alert(timeElapsed);
    },
    startLStream() {
      //alert("startLStream");
      if (vm.hlsInjectionURL && vm.hlsInjectionURL != "") {
        vm.streamPlayerOptions.controls == false;
        vm.playStream(vm.hlsInjectionURL);
      }
    },
    stopLStream: function () {
      vm.lPlayer.reset();
    },
    injectStream() {
      if (vm.useE2MInjection) {
        alert("useE2MInjection");
        vm.startLStream();
      } else if (vm.useAgoraInjection) {
        if (vm.uid == "221000") {
          alert("useAgoraInjection");
          if (vm.rtmpInjectionURL && vm.rtmpInjectionURL != "") {
            vm.client.addInjectStreamUrl(
              vm.rtmpInjectionURL,
              injectStreamConfig
            );
          }
        }
      }
    },

    async validateDevices() {
      await AgoraRTC.getDevices(true).then(function (devices) {
        //vm.IsCameraExist = false;
        //vm.IsMicExist = false;
        //vm.IsSpeakerExist = false;
        devices.forEach(function (item) {
          //alert("deviceId:" + item.deviceId);
          //alert("groupId:" + item.groupId);
          if (item.kind == "audioinput") {
            vm.IsMicExist = true;
            //alert("MicExist");
          } else if (item.kind == "audiooutput") {
            vm.IsSpeakerExist = true;
            //alert("SpeakerExist");
          } else if (item.kind == "videoinput") {
            //if(item.label!="OBS Virtual Camera"){
            vm.IsCameraExist = true;
            //alert("CameraExist");
            //}
          }
        });
      });
    },
    setRecResourceId: function (recResourceId) {
      vm.RecResourceId = recResourceId;
    },
    setRecSid: function (recSid) {
      vm.RecSid = recSid;
    },
    enableDisableButtonRecording: function (value) {
      if (value == 1) {
        $("#btnRecording").addClass("start-record");
        $("#btnRecording1").addClass("start-record");
        $("#lblRecording").text(vm.$t("agoracall.stoprecording"));
        //$("#recordingIndicator").show();
        vm.recordingStarted = true;
      } else {
        $("#btnRecording").removeClass("start-record");
        $("#btnRecording1").removeClass("start-record");
        $("#lblRecording").text(vm.$t("agoracall.startrecording"));
        //$("#recordingIndicator").hide();
        vm.recordingStarted = false;
      }
    },
    getRecordingParamFromFirebase: function () {
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      let recCollection = "Session";
      let SessionIdForRec = vm.sessionId;
      if (vm.sessionTypeId == vm.RoundTableTypeID) {
        recCollection = "RoundTable";
        SessionIdForRec = vm.roundTableId;
      } else if (vm.sessionTypeId == vm.O2OTypeID) {
        recCollection = "OneToOneMeeting";
        SessionIdForRec = vm.exMeetingId;
      } else if (vm.sessionTypeId == vm.E2OTypeID) {
        recCollection = "ExhibitorMeeting";
        SessionIdForRec = vm.exMeetingId;
      } else if (vm.sessionTypeId == 100) {
        recCollection = "ChatRoom";
        SessionIdForRec = vm.roomId;
      }
      if (obj) {
        db.collection(vm.event_collectionName)
          .doc("UserVideoActivity")
          .collection(recCollection)
          .doc(SessionIdForRec)
          .onSnapshot(function (doc) {
            if (doc.exists) {
              if (doc.data() != undefined) {
                if (
                  typeof doc.data().recording != undefined &&
                  typeof doc.data().recResourceId != undefined &&
                  typeof doc.data().recSid != undefined
                ) {
                  vm.enableDisableButtonRecording(doc.data().recording);
                  vm.setRecResourceId(doc.data().recResourceId);
                  vm.setRecSid(doc.data().recSid);
                }
              }
            }
          });
      }
    },
    setRecordingParamToFirebase: function (value) {
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      let recCollection = "Session";
      let SessionIdForRec = vm.sessionId;
      if (vm.sessionTypeId == vm.RoundTableTypeID) {
        recCollection = "RoundTable";
        SessionIdForRec = vm.roundTableId;
      } else if (vm.sessionTypeId == vm.O2OTypeID) {
        recCollection = "OneToOneMeeting";
        SessionIdForRec = vm.exMeetingId;
      } else if (vm.sessionTypeId == vm.E2OTypeID) {
        recCollection = "ExhibitorMeeting";
        SessionIdForRec = vm.exMeetingId;
      } else if (vm.sessionTypeId == 100) {
        recCollection = "ChatRoom";
        SessionIdForRec = vm.roomId;
      }
      if (obj && vm.RecResourceId && vm.RecSid) {
        var docRef = db
          .collection(vm.event_collectionName)
          .doc("UserVideoActivity")
          .collection(recCollection)
          .doc(SessionIdForRec);
        docRef.get().then(function (doc) {
          if (!doc.exists) {
            var settingsObject = new Object();
            settingsObject.recording = value;
            settingsObject.recResourceId = vm.RecResourceId;
            settingsObject.recSid = vm.RecSid;
            docRef.set(settingsObject);
          } else {
            var option = new Object();
            option["recording"] = value;
            option["recResourceId"] = vm.RecResourceId;
            option["recSid"] = vm.RecSid;
            docRef.get().then((querySnapshot) => {
              querySnapshot.ref.update(option);
            });
          }
        });
      }
    },
    setFirebaseLivePanelAppsettings: function () {
      //alert("setFirebaseLivePanelAppsettings");
      var docRef = db.collection("OA_UAT").doc("OnAirAppSettings");
      docRef
        .get()
        .then(function (doc) {
          if (doc.exists) {
            let data = doc.data();
            vm.liveVideoApiDetails.AppID = data.AppIDRTC;
            vm.liveVideoApiDetails.Certificate = data.CertificateRTC;
            vm.liveVideoApiDetails.SpeakerTokenApiUrl = data.SpeakerTokenURL;
            vm.liveVideoApiDetails.AttendeeTokenApiUrl = data.AttendeeTokenURL;
            vm.liveVideoApiDetails.TokenValidityHours = data.TokenValidityHours;
            vm.appId = data.AppIDRTC;
            vm.enableDeviceAccessibility = data.EnableDeviceAccessibility
              ? true
              : false;
            vm.autoStartRecording = data.AutoStartRecording ? true : false;
            //alert(vm.enableDeviceAccessibility);
            vm.enableDeviceAccessibility = true;
          }
        })
        .catch(function (error) {
          alert(error);
          //alert("Failure");
        });
    },
    showHideVideoPanel() {
      // alert("userType: ", vm.userType);
      //alert(vm.localStream);
      //alert(vm.streamList.length);
      debugger;
      if (vm.userType == 4 && Object.keys(vm.remoteUsers).length == 0) {
        // alert("player-not-ready22222222222");
        $("#player-not-ready").removeClass("d-none");
        $("#ag-parent-canvas").addClass("d-none");
        $(".show-on-call").addClass("d-none");
        vm.$emit("livePanelOnEnd", vm.roundTableId, false);
      } else if (vm.userType != 4 && !vm.remoteUsers[vm.uid]) {
        // alert("player-not-ready33333333333333");
        $("#player-not-ready").removeClass("d-none");
        $("#ag-parent-canvas").addClass("d-none");
        $(".show-on-call").addClass("d-none");
        vm.$emit("livePanelOnEnd", vm.roundTableId, false);
      } else {
        // alert("player-not-ready4444444444444444");
        $("#player-not-ready").addClass("d-none");
        $("#ag-parent-canvas").removeClass("d-none");
        $(".show-on-call").removeClass("d-none");
        vm.$emit("livePanelOnStart", vm.roundTableId);
      }
    },
    showLog(text) {
      if (location.origin.startsWith("http://localhost")) {
        //vm.DebugMode = true;
        if ($("#debugPanel")) {
          $("#debugPanel").append("<div>" + text + "</dib>");
        }
      } else {
        vm.hideDebugPanel();
      }
    },
    clearDebugPanel() {
      $("#debugPanel").html("");
    },
    hideDebugPanel() {
      $("#debugWrap").hide();
    },

    async changePlayerVolume(volumeLevel) {
      vm.volumeLevel = parseInt(volumeLevel);
      for (var key in vm.remoteUsers) {
        var user = vm.remoteUsers[key];
        if (user && user.stream) {
          if (user.uid != vm.shareUid) {
            if (user.stream.audioTrack) {
              user.stream.audioTrack.setVolume(vm.volumeLevel);
            }
          }
        }
      }
      let audio = document.querySelector("#ringAudio");
      if (audio) {
        if (vm.volumeLevel == 0) {
          $(audio).prop("muted", true);
        } else {
          $(audio).prop("muted", false);
          audio.volume = vm.volumeLevel / 100;
        }
      }
    },

    initPlayerSettings(playerSettings) {
      //alert("initPlayerSettings");
      //alert(playerSettings.ActiveSpeakerFocus);
      //alert("initPlayerSettings: " + playerSettings.videoProfile);
      if (playerSettings.videoProfile && playerSettings.videoProfile != "") {
        vm.sessionVideoProfile = playerSettings.videoProfile;
      }
      vm.ActiveSpeakerFocus = playerSettings.ActiveSpeakerFocus;
      vm.ActiveSpeakerMinVolume = playerSettings.ActiveSpeakerMinVolume;
      vm.ActiveSpeakerSorting = playerSettings.ActiveSpeakerSorting;
      //vm.DebugMode = playerSettings.DebugMode;
      //vm.ShowAudioVolume = playerSettings.DebugMode;
      //vm.ShowVideoProfile = playerSettings.DebugMode;
      vm.DisplayAudienceCounter = playerSettings.DisplayAudienceCounter;
      vm.DisplayCompanyAndTitleInVideoTile =
        playerSettings.DisplayCompanyAndTitleInVideoTile;
      if (vm.DisplayAudienceCounter) {
        if (vm.sessionTypeId < 4) {
          $("#viewCountWrap").show();
          //vm.viewersCountVisible = true;
          vm.displayViewersCount(true);
        } else {
          $("#viewCountWrap").hide();
          vm.viewersCountVisible = false;
          vm.displayViewersCount(false);
        }
      } else {
        $("#viewCountWrap").hide();
        vm.viewersCountVisible = false;
        vm.displayViewersCount(false);
      }
    },

    setCanvasRowColumn() {
      //let rowCount = 1;
      let colCount = 1;
      let canvas = document.querySelector("#ag-canvas");
      let parentPanel = document.querySelector("#ag-parent-canvas");
      let canvasItemCount = canvas.childNodes.length;
      //alert(canvasItemCount);
      if (vm.displayMode === "tile") {
        if (canvasItemCount == 1) {
          colCount = 1;
        } else if (canvasItemCount == 2 || canvasItemCount == 4) {
          colCount = 2;
        } else if (
          canvasItemCount == 3 ||
          canvasItemCount == 5 ||
          canvasItemCount == 6
        ) {
          colCount = 3;
        } else if (
          canvasItemCount == 7 ||
          canvasItemCount == 8 ||
          canvasItemCount == 9 ||
          canvasItemCount == 10 ||
          canvasItemCount == 11 ||
          canvasItemCount == 12
        ) {
          colCount = 4;
        } //if (canvasItemCount > 12)
        else {
          colCount = 5;
        }
      } else if (vm.displayMode === "pip") {
        if (canvasItemCount == 2 || canvasItemCount == 4) {
          colCount = 2;
        } else if (canvasItemCount == 3) {
          colCount = 3;
        }
        if (parentPanel) {
          if (vm.userCount > 1) {
            parentPanel.setAttribute("class", "ag-2col");
          }
        }
      }
      $(":root").css("--canvas-cols", colCount);
    },

    setLeftCanvasRowColumn() {
      let canvas = document.querySelector("#ag-left-panel");
      let canvasItemCount = canvas.childNodes.length;

      $(":root").css("--left-canvas-rows", canvasItemCount);
    },

    setRightCanvasRowColumn() {
      let canvas = document.querySelector("#ag-left-panel");
      let canvasItemCount = canvas.childNodes.length;

      $(":root").css("--right-canvas-rows", canvasItemCount);
    },

    async openMicCamAccessPopup(isCamTest, isVirtualBGPreview) {
      //alert("openMicCamAccessPopup");
      debugger;
      const canvas = document.querySelector("#userPreviewCanvas2");
      if (canvas) {
        const context = canvas.getContext("2d");
        if (context) {
          context.clearRect(0, 0, canvas.width, canvas.height);
        }
      }
      debugger;
      if (!vm.readyState || vm.isInvited || isVirtualBGPreview) {
        // alert("if (!vm.readyState || vm.isInvited || isVirtualBGPreview)");
        $("#enableModalCenter").modal("show");
        vm.showMicCamPermission = true;
        // return;
      } else {
        // return;
      }
      var constraints = (window.constraints = {
        audio: true,
      });
      if (!isCamTest) {
        if (vm.currentMic && vm.currentMic.deviceId) {
          //alert("currentMic : "+vm.currentMic.deviceId)
          constraints.audio = { deviceId: vm.currentMic.deviceId };
        }
        //var errorElement = document.querySelector("#errorMsg");
        navigator.mediaDevices
          .getUserMedia(constraints)
          .then(function () {
            //alert("hasMicAccess");
            vm.hasMicAccess = true;
            vm.micAccessChecked = true;
            if (vm.hasMicAccess && !isCamTest) {
              vm.isMicOn = true;
            }
            //if (vm.DebugMode) {
            //  alert("hasMicAccess:" + vm.hasMicAccess);
            //}
          })
          .catch(function (error) {
            //alert("error hasMicAccess: " + error);
            vm.hasMicAccess = false;
            vm.micAccessChecked = true;
            console.log(error);
            //if (vm.DebugMode) {
            //  alert("hasMicAccess: " + vm.hasMicAccess);
            //  alert("hasMicAccess error:" + error);
            //}
          });
      }
      constraints = window.constraints = {
        video: true,
      };
      if (vm.currentCam && vm.currentCam.deviceId) {
        //alert("currentCam : "+vm.currentCam.deviceId)
        constraints.video = {
          deviceId: vm.currentCam.deviceId,
          // width: { exact: 300 },
          // height: { exact: 300 },
        };
      }
      //var errorElement = document.querySelector("#errorMsg");
      var video = document.querySelector("#videoTest");
      await navigator.mediaDevices
        .getUserMedia(constraints)
        .then(async (stream) => {
          testStream = stream;
          // alert("showTestStream");
          vm.showTestStream = true;
          video.srcObject = stream;

          await vm.showCameraPreview();

          //alert("hasCamAccess");
          vm.hasCamAccess = true;
          vm.camAccessChecked = true;
          if (vm.hasCamAccess) {
            vm.isVideoOn = true;
          }
          //if (vm.DebugMode) {
          //  alert("hasCamAccess:" + vm.hasCamAccess);
          //}
        })
        .catch(function (error) {
          vm.virtualBGConfigInProgress = false;
          //alert("error hasCamAccess: " + error);
          vm.hasCamAccess = false;
          vm.camAccessChecked = true;
          console.log(error);
          //if (vm.DebugMode) {
          //  alert("hasCamAccess: " + vm.hasCamAccess);
          //  alert("hasCamAccess error:" + error);
          //}
        });
    },

    async showCameraPreview() {
      if (vm.userVirtualBGType > 0) {
        //alert("vm.userVirtualBGType: " + vm.userVirtualBGType);
        const inputVideoElement = document.querySelector("#videoTest");
        const outputCanvasElement = document.querySelector(
          "#userPreviewCanvas2"
        );
        // console.log("inputVideoElement???????????"+inputVideoElement);
        // console.log("outputCanvasElement???????????"+outputCanvasElement);
        // let flag = false;
        //changeForegroundType("normal");
        // if (flag) {
        if (vm.userVirtualBGType == 5) {
          await changeForegroundType("presenter");
        } else {
          await changeForegroundType("normal");
        }
        // }
        //if (flag) {
        await segmentBackground(inputVideoElement, outputCanvasElement);
        //}
      }
      if (vm.userVirtualBGType == 1) {
        setTimeout(async () => {
          await applyBlur(vm.blurLevel);
        }, 1000);
      } else if (vm.userVirtualBGType == 2) {
        let virtualBGImage = document.createElement("img");
        virtualBGImage.src = vm.userVirtualBG;
        virtualBGImage.height = 225;
        virtualBGImage.width = 300;
        //"https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT%2FBooth%20Images%2FT1.png?alt=media";
        await applyImageBackground(virtualBGImage);
      } else if (vm.userVirtualBGType == 3) {
        //COLOR
        //applyColorBackground(vm.userVirtualBG);
      } else if (vm.userVirtualBGType == 4) {
        let virtualBGVideo = document.createElement("video");
        virtualBGVideo.src =
          "https://mdn.github.io/dom-examples/canvas/chroma-keying/media/video.mp4";
        await applyVideoBackground(virtualBGVideo);
      } else if (vm.userVirtualBGType == 5) {
        // Present
      }
      setTimeout(() => {
        vm.virtualBGConfigInProgress = false;
      }, 1000);
    },

    openBrowserPermissionPopup() {
      // alert("openBrowserPermissionPopup");
      //$("#allowModalCenter").modal("show");
      $("#allowModalCenter").show();
    },
    errorMsg(msg, error) {
      //alert(msg + ":" + error);
      //errorElement.innerHTML += '<p>' + msg + '</p>';
      if (typeof error !== "undefined") {
        console.error(error);
      }
    },
    async applyMicCamAccess(allowMic, allowCam) {
      vm.showTestStream = false;
      if (testStream) {
        testStream.getTracks().forEach(function (track) {
          track.stop();
        });
      }
      testStream = null;
      // var flag = false;
      // if(!flag) {
      //   return;
      // }
      //$(".audioControlBtn").removeClass("off");
      // if (allowMic) {
      //   $(".audioControlBtn").removeClass("off");
      // } else {
      //   $(".audioControlBtn").addClass("off");
      // }
      if (allowMic != undefined) {
        vm.allowMic = allowMic;
        vm.isMicOn = allowMic;
      }

      //$(".videoControlBtn").removeClass("off");
      // if (allowCam) {
      //   $(".videoControlBtn").removeClass("off");
      // } else {
      //   $(".videoControlBtn").addClass("off");
      // }
      if (allowCam != undefined) {
        vm.allowCam = allowCam;
        vm.isVideoOn = allowCam;
      }
      // alert("applyMicCamAccess hide");
      $("#enableModalCenter").modal("hide");
      vm.showMicCamPermission = false;
      if (vm.isInvited) {
        vm.EnterStage();
      } else {
        await vm.StartCall(
          vm.tempValues.clientId,
          vm.tempValues.eventId,
          vm.tempValues.channelName,
          vm.tempValues.sessionTypeId,
          vm.tempValues.session,
          vm.tempValues.roundTable,
          vm.tempValues.o2oMeeting,
          vm.tempValues.attendeeType,
          vm.tempValues.callSettings,
          vm.tempValues.exMeetingId,
          vm.tempValues.meetingHostId,
          1
        );
      }
    },
    async applyBrowserPermission() {
      //$("#allowModalCenter").modal("hide");
      $("#allowModalCenter").hide();
      await vm.StartCall(
        vm.tempValues.clientId,
        vm.tempValues.eventId,
        vm.tempValues.channelName,
        vm.tempValues.sessionTypeId,
        vm.tempValues.session,
        vm.tempValues.roundTable,
        vm.tempValues.o2oMeeting,
        vm.tempValues.attendeeType,
        vm.tempValues.callSettings,
        vm.tempValues.exMeetingId,
        vm.tempValues.meetingHostId,
        2
      );
    },
    AcceptToEnterStage(accepted) {
      vm.displayInviteToStage = false;
      if (accepted) {
        vm.readyState = false;
        vm.openMicCamAccessPopup();
      } else {
        if (vm.entryType == 1) {
          vm.$emit("inviteAttendeeToStage", vm.uid, false, true);
        }
      }
    },
    RequestToEnterStage(entryType, inviteRequestStatus) {
      // alert("entryType: " + entryType);
      // alert("inviteRequestStatus: " + inviteRequestStatus);
      vm.entryType = entryType;
      vm.isInvited = inviteRequestStatus;
      if (vm.entryType == 1) {
        if (inviteRequestStatus) {
          if (!vm.remoteUsers[vm.uid]) {
            vm.displayInviteToStage = true;
          }
        } else {
          if (vm.remoteUsers[vm.uid]) {
            vm.LeaveStage();
          }
        }
      } else if (vm.entryType == 2) {
        if (inviteRequestStatus) {
          if (!vm.remoteUsers[vm.uid]) {
            vm.readyState = false;
            vm.openMicCamAccessPopup();
          }
        } else {
          vm.isRHOn = false;
          if (vm.remoteUsers[vm.uid]) {
            vm.LeaveStage();
          }
        }
      }
    },
    async EnterStage() {
      if (vm.entryType == 1) {
        vm.$emit("inviteAttendeeToStage", vm.uid, true, true);
      } else if (vm.entryType == 2) {
        vm.$emit("applyRaiseHandAction", vm.uid, true, true);
      }

      vm.client.setClientRole(
        "host",
        function () {
          //console.log('Client role set to audience');
        },
        function (e) {
          console.log("setClientRole failed", e);
        }
      );
      vm.readyState = false;
      vm.inProcess = true;
      vm.attendeeType = 2;
      vm.userType = 2;

      var localTracks = {};
      if (vm.isMicOn) {
        var micConfig = {};
        if (vm.currentMic && vm.currentMic.deviceId) {
          micConfig = { microphoneId: vm.currentMic.deviceId };
        }
        localTracks.audioTrack = await AgoraRTC.createMicrophoneAudioTrack(
          micConfig
        );
      }
      if (vm.isVideoOn) {
        var camConfig = {};
        if (vm.currentCam && vm.currentCam.deviceId) {
          camConfig = { cameraId: vm.currentCam.deviceId };
        }
        localTracks.videoTrack = await AgoraRTC.createCameraVideoTrack(
          camConfig
        );
      }

      await vm.addUser(vm.uid, localTracks);
      await vm.bindUser(vm.uid);

      if (vm.isMicOn || vm.isVideoOn) {
        await vm.client.publish(Object.values(vm.remoteUsers[vm.uid].stream));
      }
      if (!vm.isMicOn) {
        $("#audio-indicator-" + vm.uid)
          .removeClass("sound-unmuted")
          .removeClass("sound-talking")
          .addClass("sound-muted");
      }

      if (vm.isVideoOn) {
        $("#profileImage_" + vm.uid).addClass("d-none");
        vm.playVideo(vm.uid, vm.remoteUsers[vm.uid].stream);
        //await vm.handleVideoNG(vm.uid, vm.isVideoOn);
      } else {
        $("#profileImage_" + vm.uid).removeClass("d-none");
      }

      vm.readyState = true;
      vm.inProcess = false;
      vm.changePlayerStatus(1);

      if (vm.isMicOn) {
        await vm.handleAudioNG(vm.uid, true);
      }
      if (vm.isVideoOn) {
        await vm.handleVideoNG(vm.uid, true);
      }
    },
    async LeaveStage() {
      vm.attendeeType = 4;
      vm.userType = 4;
      if (vm.remoteUsers[vm.uid].stream.videoTrack) {
        vm.isVideoOn = false;
        await vm.remoteUsers[vm.uid].stream.videoTrack.setEnabled(false);
        $("#profileImage_" + vm.uid).removeClass("d-none");
      }
      if (vm.remoteUsers[vm.uid].stream.audioTrack) {
        await vm.remoteUsers[vm.uid].stream.audioTrack.setEnabled(false);
        vm.isMicOn = false;
        $("#audio-indicator-" + vm.uid)
          .removeClass("sound-unmuted")
          .removeClass("sound-talking")
          .addClass("sound-muted");
      }
      vm.client.setClientRole(
        "audience",
        function () {
          //console.log('Client role set to audience');
        },
        function (e) {
          console.log("setClientRole failed", e);
        }
      );
      vm.manageUserLeft(vm.uid);
      //delete vm.remoteUsers[vm.uid]
    },
    async InviteAttendeeToStage(attendeeId) {
      // alert("vm.entryType: " + vm.entryType);
      // alert("InviteAttendeeToStage: "+attendeeId);
      vm.$emit("inviteAttendeeToStage", attendeeId, false);
      vm.$emit("applyRaiseHandAction", attendeeId, false);
      // if (vm.entryType == 1) {
      //   vm.$emit("inviteAttendeeToStage", attendeeId, false);
      // } else if (vm.entryType == 2) {
      //   vm.$emit("applyRaiseHandAction", attendeeId, false);
      // }
    },
    async StartCall(
      clientId,
      eventId,
      channelName,
      sessionTypeId,
      session,
      roundTable,
      o2oMeeting,
      attendeeType,
      callSettings,
      exMeetingId,
      meetingHostId,
      callStep
    ) {
      vm.displayNextMeetingJoinLink = false;
      vm.enableNextMeetingJoinLink = false;
      vm.nextMeetingId = "";
      vm.nextMeetingAttendeeName = "";
      vm.nextMeetingAttendeeInitial = "";
      vm.nextMeetingAttendeeProfilePictureURL = "";
      //if (!callStep) {
      //  vm.IsLive = true;
      //  vm.IsGoLive = false;
      //  vm.inProcess = false;
      //  vm.readyState = true;
      //  vm.changePlayerStatus(1);
      //  vm.$emit("livePanelOnStart");
      //  return;
      //}
      //alert("StartCall:"+callStep);
      $('[data-toggle="tooltip"]').tooltip();
      vm.sessionTypeId = sessionTypeId;
      vm.attendeeType = attendeeType;
      vm.userType = attendeeType;
      vm.outgoungBandwidth = vm.minOutgoungBandwidth;
      vm.incomingBandwidth = vm.minIncomingBandwidth;
      // alert(vm.enableDeviceAccessibility);
      // alert(attendeeType);
      // alert(callStep);
      // callStep = 1;
      // vm.hasMicAccess = true;
      // vm.micAccessChecked = true;
      // vm.hasCamAccess = true;
      // vm.camAccessChecked = true;
      if (!callStep) {
        callStep = 0;
      }
      if (callStep == 0) {
        vm.switchTableVisible = false;
        vm.entryType = 0;
        vm.micAccessChecked = false;
        vm.camAccessChecked = false;
        vm.isVideoOn = false;
        vm.isMicOn = false;
        vm.IsRTMP = false;
        vm.isInvited = false;
        vm.AllowRaiseHand = false;
        vm.isGuestSpeaker = false;
        vm.pinSelected = false;
        vm.showVirtualBGConfig = false;
        vm.userVirtualBGType = 0;
        vm.displayMode = "tile";
        $(":root").css("--canvas-cols", 1);
        $(":root").css("--canvas-rows", 1);
        $(":root").css("--left-canvas-rows", 1);
        $(":root").css("--right-canvas-rows", 1);

        if (vm.sessionTypeId < 5) {
          vm.playerWaitText = "Please wait, stage will be live soon...";
        } else {
          vm.playerWaitText = "";
        }
        if (attendeeType < 4) {
          //alert("1");
          await vm.validateDevices();
          //alert("2");
          vm.getMicrophones();
          vm.getCameras();
          vm.getVideoProfile();
        }
        vm.getPlaybackDevices();

        vm.allHosts = [];
        vm.allCoHosts = [];
        vm.allSpeakers = [];
        vm.recordingStarted = false;
        vm.AgoraRTMPInProcess = false;
        if (sessionTypeId == 3) {
          if (session) {
            vm.sessionId = session.SessionId;
            vm.allHosts = session.MappedHosts;
            vm.allCoHosts = session.MappedCoHosts;
            vm.allSpeakers = session.MappedSpeakers;
            if (
              vm.allHosts.filter(function (item) {
                return item.AttendeeId == vm.uid;
              }).length == 0 &&
              vm.allCoHosts.filter(function (item) {
                return item.AttendeeId == vm.uid;
              }).length == 0 &&
              vm.allSpeakers.filter(function (item) {
                return item.AttendeeId == vm.uid;
              }).length == 0
            ) {
              vm.isGuestSpeaker = true;
            }
            vm.AgoraRTMPStartedBy = session.RTMPStartedBy;
            vm.AgoraRTMPStarted = session.RTMPStarted;
          }
        } else if (sessionTypeId == 4) {
          if (roundTable) {
            vm.allHosts = roundTable.Host;
            vm.allCoHosts = roundTable.CoHost ? [roundTable.CoHost] : [];
          }
        }

        if (goLiveTimer) {
          clearInterval(goLiveTimer);
        }
        vm.IsLive = true;
        vm.IsGoLive = false;
        if (channelName.includes("_gr")) {
          vm.IsLive = false;
          //alert("Back Stage");
          vm.startGoLiveTimer();
        }
        vm.tempValues = {
          clientId: clientId,
          eventId: eventId,
          channelName: channelName,
          sessionTypeId: sessionTypeId,
          session: session,
          roundTable: roundTable,
          o2oMeeting: o2oMeeting,
          attendeeType: attendeeType,
          callSettings: callSettings,
          exMeetingId: exMeetingId,
          meetingHostId: meetingHostId,
        };
      }
      if (callSettings && callSettings.breakoutRoomName) {
        vm.playerWaitText = "Joining room " + callSettings.breakoutRoomName;
      }
      //alert(attendeeType)
      if (vm.enableDeviceAccessibility && attendeeType < 4) {
        if (callStep == 0) {
          setTimeout(() => {
            vm.openMicCamAccessPopup();
          }, 1000);
          return;
        } else if (callStep == 1) {
          if (
            (vm.IsCameraExist && vm.allowCam && !vm.hasCamAccess) ||
            (vm.IsMicExist && vm.allowMic && !vm.hasMicAccess)
          ) {
            vm.tempValues = {
              clientId: clientId,
              eventId: eventId,
              channelName: channelName,
              sessionTypeId: sessionTypeId,
              session: session,
              roundTable: roundTable,
              o2oMeeting: o2oMeeting,
              attendeeType: attendeeType,
              callSettings: callSettings,
              exMeetingId: exMeetingId,
              meetingHostId: meetingHostId,
            };
            vm.openBrowserPermissionPopup();
            return;
          }
        }
      }
      if (streamRepairTimer) {
        clearInterval(streamRepairTimer);
      }
      if (ProfileRepairTimer) {
        clearInterval(ProfileRepairTimer);
      }
      if (ReConnectCallTimer) {
        clearInterval(ReConnectCallTimer);
      }

      //alert("channelName:" + channelName);
      //vm.init();
      let waitTime = 1;
      let flag = false;
      if (vm.readyState && vm.sessionId != "") {
        if (session) {
          if (vm.sessionId != session.SessionId) {
            flag = true;
            //alert("End And Start");
          } else {
            //if (vm.sessionTypeId == vm.LivePanelTypeID) {
            //  flag = true;
            //} else
            if (vm.sessionTypeId == vm.RoundTableTypeID) {
              if (vm.roundTableId != "") {
                if (roundTable && vm.roundTableId != roundTable.TableId) {
                  flag = true;
                  //alert("End And Start");
                } else {
                  return;
                }
              }
            }
          }
        }
      }
      if (flag) {
        //alert("onEndCall");
        waitTime = 2000;
        vm.$emit("livePanelOnBeforeStart");
        await vm.onEndCall();
      }
      vm.inProcess = true;
      //alert(waitTime);
      //var a = new Promise(
      setTimeout(async () => {
        try {
          if (vm.processor) {
            vm.processor = null;
          }
        } catch {
          //alert(ex);
        }
        //"42001",Dipesh
        //"221000",Debashis
        //"221001",Kuntal
        //"191000",Aditi
        //"191001",Anirban
        //"422037",Rajeshwar
        //"422048",Sayak
        //"191010",Somnath
        //"421030",Pankaj
        //"191002",Debottam
        //"42012",Victor
        //"1556000",Pravakar
        //"99901500",Dipesh

        //MOVE IT TO LOG START LISTENER
        //vm.logUserIDs = ["42001", "221000", "221001", "191000", "99901500"];
        //vm.logUserIDs = [
        //  "221000",
        //  "191000",
        //  "191001",
        //  "422037",
        //  "422048",
        //  "191010",
        //];
        //vm.playerLog.initRTM(channelName, vm.uid, vm.logRecipientId);

        vm.RTMPStreamURL = "";
        vm.RTMPStreamKey = "";

        vm.playerLogo = "";
        vm.playerLogoLink = "";
        if (callSettings) {
          vm.playerLogo = callSettings.playerLogo
            ? callSettings.playerLogo
            : "";
          vm.playerLogoLink = callSettings.playerLogoLink
            ? callSettings.playerLogoLink
            : "";
        }
        if (vm.sessionTypeId == 4) {
          $("#viewCountWrap").hide();
          vm.viewersCountVisible = false;
          vm.displayViewersCount(false);
        }
        console.log(channelName);
        //alert(channelName);
        //vm.userType = attendeeType;
        vm.clientId = clientId;
        vm.eventId = eventId;
        vm.channelName = channelName;
        vm.sessionTypeId = sessionTypeId;
        vm.localStreamVolume = 0;
        vm.session = session == undefined ? null : session;
        vm.roundTable = roundTable == undefined ? null : roundTable;
        vm.o2oMeeting = o2oMeeting == undefined ? null : o2oMeeting;
        vm.exMeetingId = exMeetingId;

        vm.AllowScreenShare = false;
        vm.AllowRecording = false;
        vm.AutoStartRecording = false;
        vm.AllowPinVideoTile = true;
        vm.enableInviteSessionAttendee = false;
        //if (vm.sessionVideoProfile != "") {
        //  vm.videoProfile = vm.sessionVideoProfile;
        //}
        if (vm.sessionTypeId == vm.LivePanelTypeID) {
          //vm.sessionId = session.SessionId;
          //vm.allHosts = session.MappedHosts;
          //vm.allCoHosts = session.MappedCoHosts;
          //vm.allSpeakers = session.MappedSpeakers;
          if (
            session &&
            session.SessionTypeDetails &&
            session.SessionTypeDetails.EnableRaiseHand
          ) {
            vm.AllowRaiseHand = true;
          }
          let hosts = vm.allHosts.filter(function (item) {
            return item.AttendeeId == vm.uid;
          });
          if (hosts.length > 0) {
            vm.userType = 1;
          } else {
            let speakers = vm.allSpeakers.filter(function (item) {
              return item.AttendeeId == vm.uid;
            });
            if (speakers.length > 0) {
              vm.userType = 2;
            }
          }
          //alert(vm.userType);
          // if (vm.userType == 4 && attendeeType == 3) {
          //   vm.userType = 3;
          // }
          vm.AllowScreenShare = true;
          vm.AllowRecording = true;
          //vm.AutoStartRecording = true;
          if (callSettings) {
            //vm.AllowScreenShare = callSettings.AllowScreenShare;
            //vm.AllowRecording = callSettings.AllowRecording;
            vm.AutoStartRecording = callSettings.AutoStartRecording;
          }
          if (vm.session && vm.session.IsRTMP) {
            if (vm.session.IsRTMP) {
              vm.IsRTMP = vm.session.IsRTMP;
            }
            if (
              vm.session.SessionTypeDetails &&
              vm.session.SessionTypeDetails.EnableInviteSessionAttendee
            ) {
              vm.enableInviteSessionAttendee =
                vm.session.SessionTypeDetails.EnableInviteSessionAttendee;
            }
          }
          if (
            vm.session &&
            vm.session.RTMPMUX_detail &&
            vm.session.RTMPMUX_detail.data &&
            vm.session.RTMPMUX_detail.data.rtmpPushEndpoint
          ) {
            if (vm.session.RTMPMUX_detail.data.rtmpPushEndpoint.url) {
              vm.RTMPStreamURL =
                vm.session.RTMPMUX_detail.data.rtmpPushEndpoint.url;
            }
            if (vm.session.RTMPMUX_detail.data.rtmpPushEndpoint.streamKey) {
              vm.RTMPStreamKey =
                vm.session.RTMPMUX_detail.data.rtmpPushEndpoint.streamKey;
            }
          }
        } else if (vm.sessionTypeId == vm.RoundTableTypeID) {
          //vm.videoProfile = "360p_1";
          //vm.AllowPinVideoTile = false;
          if (session) {
            vm.sessionId = session.SessionId;
          }
          vm.roundTableId = roundTable.TableId;
          vm.allHosts = roundTable.Host;
          vm.allCoHosts = roundTable.CoHost ? [roundTable.CoHost] : [];
          vm.allSpeakers = roundTable.MappedAttendees;
          let hosts = vm.allHosts.filter(function (item) {
            return item.AttendeeId == vm.uid;
          });
          if (hosts.length > 0) {
            vm.userType = 1;
          } else {
            let speakers = vm.allSpeakers.filter(function (item) {
              return item.AttendeeId == vm.uid;
            });
            if (speakers.length > 0) {
              vm.userType = 3;
            }
          }
          if (vm.userType == 4 && vm.roundTable.AvailSeatType == 3) {
            vm.userType = 3;
          }
          if (session) {
            $("#pHeaderSessionName").html(
              session.Name + " (" + roundTable.Name + ")"
            );
            $("#pHeaderSessionName").attr(
              "title",
              session.Name + " (" + roundTable.Name + ")"
            );
            if (callSettings.breakoutRoomName) {
              $("#menuSessionInfo p").html(
                session.Name +
                  " (" +
                  roundTable.Name +
                  ") - " +
                  callSettings.breakoutRoomName
              );
            } else {
              $("#menuSessionInfo p").html(
                session.Name + " (" + roundTable.Name + ")"
              );
            }
          } else {
            $("#pHeaderSessionName").html(roundTable.Name);
            $("#pHeaderSessionName").attr("title", roundTable.Name);
            if (callSettings.breakoutRoomName) {
              $("#menuSessionInfo p").html(
                roundTable.Name + " - " + callSettings.breakoutRoomName
              );
            } else {
              $("#menuSessionInfo p").html(roundTable.Name);
            }
          }
          //$('[data-toggle="tooltip"]').tooltip();
          if (callSettings) {
            vm.AllowScreenShare = callSettings.AllowScreenShare;
            vm.AllowRecording = callSettings.AllowRecording;
            vm.AutoStartRecording = callSettings.AutoStartRecording;
          }
        } else if (vm.sessionTypeId == vm.O2OTypeID) {
          vm.AllowScreenShare = true;
        } else if (vm.sessionTypeId == vm.E2OTypeID) {
          vm.AllowScreenShare = true;
          vm.meetingHostId = meetingHostId;
          //alert(vm.userType);
          //vm.userType = 1;
        } else {
          vm.userType = 4;
        }
        if (vm.roomId) {
          vm.userType = 1;
          //vm.AllowScreenShare = true;
        }
        //alert("vm.userType : " + vm.userType);
        //if (vm.userType == 1 || vm.userType == 2 || vm.userType == 3) {
        //  vm.attendeeMode = "video";
        //} else {
        //  vm.attendeeMode = "audience";
        //}
        //alert("vm.attendeeMode : " + vm.attendeeMode);
        let justSkip = true;
        if (justSkip) {
          //return;
        }
        var obj = JSON.parse(window.localStorage.getItem("my-app"));
        if (obj != undefined && obj != null) {
          if (location.origin.startsWith("http://localhost")) {
            //vm.uid = Math.random().toString().substring(3, 12); //this.getUrlParameter("uid");
          }
          //vm.uid = 2147483647; //"debashis_" + Math.random().toString().substring(3, 12); //this.getUrlParameter("uid");
          vm.activeScreenUID = vm.uid;
          //alert("activeScreenUID:" + vm.activeScreenUID);
          //alert(vm.uid);
          //if (vm.uid == "221000") {
          //  vm.attendeeMode = "audience";
          //}

          if (vm.event_collectionName) {
            Cookies.set("id", vm.uid);
            Cookies.set("baseMode", "avc");
            Cookies.set("transcode", "interop");
            Cookies.set("attendeeMode", "video");
            //Cookies.set("videoProfile", "480p_1");
            //Cookies.set("videoProfile", "480p_1");

            //Cookies.set("id", vm.uid);
            //Cookies.set("channel", "channel");
            //Cookies.set("baseMode", "avc");
            //Cookies.set("transcode", "interop");
            //Cookies.set("attendeeMode", "video");
            //Cookies.set("videoProfile", "480p_1");
            //alert("vm.enableLogUpload:" + vm.enableLogUpload);
            //alert("vm.uploadLogLevel:" + vm.uploadLogLevel);
            if (vm.enableLogUpload) {
              AgoraRTC.enableLogUpload();
              if (vm.uploadLogLevel == "DEBUG") {
                AgoraRTC.setLogLevel(0); //DEBUG
              } else if (vm.uploadLogLevel == "INFO") {
                AgoraRTC.setLogLevel(1); //INFO
              } else if (vm.uploadLogLevel == "WARNING") {
                AgoraRTC.setLogLevel(2); //WARNING
              } else if (vm.uploadLogLevel == "ERROR") {
                AgoraRTC.setLogLevel(3); //ERROR
              } else if (vm.uploadLogLevel == "NONE") {
                AgoraRTC.setLogLevel(4); //NONE
              } else {
                AgoraRTC.setLogLevel(3); //ERROR
              }
            }

            //vm.channelName = "debashis";
            var token = "";
            //Video Token generation
            let headers = {
              "Content-Type": "application/json",
              Authorization: "Bearer " + vm.getSessionToken(),
            };
            var requestData = {
              app: {
                id: vm.liveVideoApiDetails.AppID.toString(),
                certificate: vm.liveVideoApiDetails.Certificate.toString(),
              },
              channelName: vm.channelName.toString(),
              userId: 0,
              validityHours: parseInt(
                vm.liveVideoApiDetails.TokenValidityHours
              ),
            };
            //if (!vm.IsMicExist || !vm.hasMicAccess) {
            //  vm.attendeeMode == "audience";
            //  vm.userType = 4;
            //}
            axios
              .post(vm.liveVideoApiDetails.SpeakerTokenApiUrl, requestData, {
                headers: headers,
              })
              .then(async (responseData) => {
                let data = responseData.data;
                console.log(data);
                if (typeof data != "undefined") {
                  //self.hideLoader();
                  let lStatusCode = 0;
                  lStatusCode = data.status;
                  if (lStatusCode == 0) {
                    token = data.token;
                    console.log("token>>>>>>>>>>>>>>>>>>>" + token);
                    console.log(
                      "channelName>>>>>>>>>>>>>>>>>>>" + vm.channelName
                    );
                    vm.token = token;
                    vm.client = AgoraRTC.createClient({
                      mode: vm.transcode,
                      codec: "h264",
                      //codec: "vp8",
                    });

                    if (vm.EnableAgoraProxy) {
                      //vm.client.startProxyServer(3);
                    }

                    vm.options.appid = vm.liveVideoApiDetails.AppID;
                    vm.options.token = token;
                    vm.options.channel = vm.channelName;

                    //await join();
                    // add event listener to play remote tracks when remote user publishs.
                    vm.client.on("user-joined", vm.handleUserJoined);
                    vm.client.on("user-left", vm.handleUserLeft);
                    vm.client.on("user-published", vm.handleUserPublished);
                    vm.client.on("user-unpublished", vm.handleUserUnpublished);
                    //vm.client.on("connection-state-change", vm.handleConnectionStateChange);
                    // vm.client.on("published-user-list", vm.handlePublishedUserList);

                    vm.client.setLowStreamParameter({
                      width: 160,
                      height: 120,
                      framerate: 15,
                      bitrate: 120,
                    });
                    vm.client.enableDualStream();
                    // vm.client.init(
                    //   vm.liveVideoApiDetails.AppID,
                    //   () => {
                    //vm.client.init(vm.appId, () => {
                    //vm.getPlayerSettings();
                    console.log("AgoraRTC client initialized");

                    vm.client.enableAudioVolumeIndicator();
                    vm.client.on("volume-indicator", vm.handleVolumeIndicator);

                    //vm.subscribeStreamEvents();

                    //alert(vm.attendeeMode);
                    if (vm.attendeeMode == "audience") {
                      vm.client.setClientRole(
                        "audience",
                        function () {
                          //console.log('Client role set to audience');
                        },
                        function (e) {
                          console.log("setClientRole failed", e);
                        }
                      );
                    } else {
                      vm.client.setClientRole(
                        "host",
                        function () {
                          //console.log('Client role set to audience');
                        },
                        function (e) {
                          console.log("setClientRole failed", e);
                        }
                      );
                    }

                    //await vm.setSomeUserHQStream();
                    var localTracks = {};
                    let id = parseInt(vm.uid);

                    await vm.client.join(
                      vm.liveVideoApiDetails.AppID,
                      vm.channelName,
                      vm.token || null,
                      id || null
                    );
                    if (attendeeType < 4) {
                      if (vm.isMicOn) {
                        var micConfig = {};
                        if (vm.currentMic && vm.currentMic.deviceId) {
                          micConfig = { microphoneId: vm.currentMic.deviceId };
                        }
                        localTracks.audioTrack =
                          await AgoraRTC.createMicrophoneAudioTrack(micConfig);
                      }
                      if (vm.isVideoOn) {
                        var camConfig = {};
                        if (vm.currentCam && vm.currentCam.deviceId) {
                          camConfig = { cameraId: vm.currentCam.deviceId };
                        }
                        localTracks.videoTrack =
                          await AgoraRTC.createCameraVideoTrack(camConfig);
                      }
                    }

                    if (vm.attendeeMode !== "audience") {
                      await vm.addUser(vm.uid, localTracks);
                      await vm.bindUser(vm.uid);

                      if (
                        vm.userVirtualBGEnabled &&
                        vm.userVirtualBGType != 0
                      ) {
                        setTimeout(async () => {
                          await vm.setUserVirtualBG();
                        }, 100);
                      }
                      // setTimeout(() => {
                      //   // Create a VirtualBackgroundExtension instance
                      //   const extension = new VirtualBackgroundExtension();
                      //   // Register the extension
                      //   debugger;
                      //   if (extension) {
                      //     AgoraRTC.registerExtensions([extension]);
                      //   }
                      //   //processor.setOptions({type: 'color', color: '#00ff00'});

                      //   var virtualBG = document.createElement("img");
                      //   // virtualBG.setAttribute("src", "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT%2FBooth%20Images%2FT1.png?alt=media&token=30f7a170-420e-4032-85e4-05123e9bd95a")

                      //   // virtualBG.setAttribute("height", "600px");
                      //   // virtualBG.setAttribute("width", "900px");
                      //   //https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT%2FBooth%20Images%2FT1.png?alt=media&token=30f7a170-420e-4032-85e4-05123e9bd95a

                      //   virtualBG.src = "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT%2FBooth%20Images%2FT1.png?alt=media&token=30f7a170-420e-4032-85e4-05123e9bd95a";
                      //   //virtualBG.src = "https://webdemo.agora.io/dynamic-background/assets/images/room.jpg";
                      //   //virtualBG.setAttribute("src", "https://webdemo.agora.io/dynamic-background/assets/images/room.jpg");
                      //   //virtualBG.setAttribute("src", "http://localhost:8080/img/expo-back.e7767c5b.jpg");
                      //   //virtualBG.setAttribute("src", "https://firebasestorage.googleapis.com/v0/b/uate2monair.appspot.com/o/OA_UAT%2FExpoTemplate%2FType%201.png?alt=media&token=d4b78746-8d2c-4348-ae11-60d9f9065df8");
                      //   virtualBG.setAttribute("src", "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT%2FAGORA%2Fvirtual_bg%2Froom.jpg?alt=media");
                      //   //virtualBG.setAttribute("src", "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT%2FAGORA%2Fvirtual_bg%2Fe2m-virtual-bg.png?alt=media");
                      //   //virtualBG.setAttribute("src", "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT%2FUserProfile%2Fmyprofile.jpg?alt=media");
                      //   virtualBG.crossOrigin = "Anonymous";
                      //   virtualBG.onload = async() => {
                      //     let processor = extension.createProcessor();
                      //     try {
                      //       await processor.init("./assets/wasms");
                      //       //await processor.init("https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT%2FAGORA%2Fagora-extension-virtual-background%2Fwasms%2Fagora-wasm.wasm?alt=media&token=fb83a267-a9bf-430d-9021-ede64f42a4b2");
                      //     } catch(e) {
                      //       console.log("Fail to load WASM resource!");return null;
                      //     }
                      //     vm.remoteUsers[vm.uid].stream.videoTrack.pipe(processor).pipe(vm.remoteUsers[vm.uid].stream.videoTrack.processorDestination);

                      //     try{
                      //       processor.setOptions({type: 'img', source: virtualBG});
                      //       //processor.setOptions({type: 'color', color: '#00ff00'});
                      //       await processor.enable();
                      //     } finally {
                      //       document.getElementById("loading").style.display = "none";
                      //     }
                      //   }
                      //   //virtualBG.src = "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT%2FUserProfile%2F1625000.jpg?alt=media";
                      // }, 1000);

                      if (vm.isMicOn || vm.isVideoOn) {
                        await vm.client.publish(
                          Object.values(vm.remoteUsers[vm.uid].stream)
                        );
                      }
                      if (vm.isMicOn) {
                        //   await vm.handleAudioNG(vm.uid, vm.isMicOn);
                        //vm.playAudio(vm.remoteUsers[vm.uid].stream);
                      } else {
                        $("#audio-indicator-" + vm.uid)
                          .removeClass("sound-unmuted")
                          .removeClass("sound-talking")
                          .addClass("sound-muted");
                      }

                      if (vm.isVideoOn) {
                        $("#profileImage_" + vm.uid).addClass("d-none");
                        vm.playVideo(vm.uid, vm.remoteUsers[vm.uid].stream);
                        //await vm.handleVideoNG(vm.uid, vm.isVideoOn);
                      } else {
                        $("#profileImage_" + vm.uid).removeClass("d-none");
                      }
                    }
                    vm.readyState = true;
                    vm.inProcess = false;
                    vm.changePlayerStatus(1);
                    vm.$emit("livePanelOnStart");
                    vm.getRecordingParamFromFirebase();
                    // alert(vm.attendeeType);
                    // alert(vm.AllowRecording);
                    // alert(vm.AutoStartRecording);

                    if (
                      vm.attendeeType == 1 &&
                      vm.AllowRecording &&
                      vm.AutoStartRecording
                    ) {
                      setTimeout(() => {
                        vm.tryAutoStartRecording();
                      }, 1000);
                    }

                    //if (vm.attendeeType == 1 && vm.session.AgoraRTMPStartedBy == vm.uid) {
                    if (
                      vm.session &&
                      vm.session.RTMPStarted &&
                      (vm.attendeeType == 1 || vm.isUserCoHost())
                    ) {
                      vm.StartAgoraRTMP();
                    }
                    //alert(vm.attendeeType)
                    // if(vm.attendeeType == 4 ){
                    //   if (vm.sessionId == 99904353 && vm.uid == 1562000) {
                    //     alert("temp");
                    //     vm.isInvited = true;
                    //     vm.EnterStage();
                    //   }
                    // }

                    console.log("Get Encrypt URL API Call Success");
                  } else {
                    //self.hideLoader();
                    alert("Error initiating video call. Please retry. ");
                  }
                } else {
                  //self.hideLoader();
                  alert("Error initiating video call. Please retry. ");
                }
              })
              .catch(function (error) {
                console.error("Error on Get Token: ", error);
                //alert("Error initiating video call. Please retry. ");
              });
          }
        }
      }, waitTime);
      //);
    },
    openVirtualBGConfig() {
      vm.virtualBGConfigInProgress = true;
      vm.showVirtualBGConfig = true;
      vm.userVirtualBGType = vm.userVirtualBGTypeSelected;
      vm.userVirtualBGTab = vm.userVirtualBGTabSelected;
      vm.userVirtualBG = vm.userVirtualBGSelected;
      vm.openMicCamAccessPopup(true, true);
    },
    reOpenVirtualBGConfig(BGType, BGTab, BG) {
      vm.virtualBGConfigInProgress = true;
      vm.showVirtualBGConfig = true;
      vm.userVirtualBGType = BGType;
      vm.userVirtualBGTab = BGTab;
      vm.userVirtualBG = BG;
      vm.openMicCamAccessPopup(true, true);
    },
    closeVirtualBGConfig() {
      // alert("closeVirtualBGConfig");
      $("#enableModalCenter").modal("hide");
      vm.showMicCamPermission = false;
      vm.showVirtualBGConfig = false;
    },
    async setUserVirtualBG() {
      vm.userVirtualBGTypeSelected = vm.userVirtualBGType;
      vm.userVirtualBGTabSelected = vm.userVirtualBGTab;
      vm.userVirtualBGSelected = vm.userVirtualBG;
      if (!vm.remoteUsers[vm.uid].stream.videoTrack) {
        await vm.handleVideoNG(vm.uid, true);
      }
      if (vm.userVirtualBGType == 0) {
        if (vm.processor) {
          //await vm.processor.disable();
          //vm.processor = null;
          if (
            vm.remoteUsers[vm.uid].stream.videoTrack &&
            vm.remoteUsers[vm.uid].stream.videoTrack.processor &&
            vm.remoteUsers[vm.uid].stream.videoTrack.processor._enabled
          ) {
            //vm.remoteUsers[vm.uid].stream.videoTrack.unpipe();
            //vm.remoteUsers[vm.uid].stream.videoTrack.unpipe(vm.remoteUsers[vm.uid].stream.videoTrack.processorDestination).unpipe(vm.processor);
            //alert("1")
            try {
              await vm.processor.disable();
            } catch {
              //alert(ex);
            }
          }
        }
      } else {
        if (vm.remoteUsers[vm.uid].stream.videoTrack) {
          vm.registerVirtualBackgroundExtension();
          if (vm.userVirtualBGType == 1) {
            await vm.createProcessorInstance();
            try {
              vm.processor.setOptions({
                type: "blur",
                blurDegree: vm.blurLevelAgora,
              });
              await vm.processor.enable();
            } catch (ex) {
              await vm.processor.disable();
              //alert(ex);
            } finally {
              //document.getElementById("loading").style.display = "none";
            }
          } else if (vm.userVirtualBGType == 2) {
            //alert("2")
            var virtualBG = document.createElement("img");
            virtualBG.src = vm.userVirtualBG;
            // virtualBG.src =
            //   "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT%2FBooth%20Images%2FT1.png?alt=media";
            // virtualBG.src =
            //   "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT%2FAGORA%2Fvirtual_bg%2Froom.jpg?alt=media";
            // virtualBG.src =
            //   "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT%2FAGORA%2Fvirtual_bg%2Fe2m-virtual-bg.png?alt=media";
            virtualBG.crossOrigin = "Anonymous";
            virtualBG.onload = async () => {
              await vm.createProcessorInstance();
              //alert("3")
              try {
                vm.processor.setOptions({ type: "img", source: virtualBG });
                await vm.processor.enable();
              } catch (ex) {
                await vm.processor.disable();
                //alert(ex);
              } finally {
                //document.getElementById("loading").style.display = "none";
              }
            };
          } else if (vm.userVirtualBGType == 3) {
            await vm.createProcessorInstance();
            try {
              vm.processor.setOptions({
                type: "color",
                color: vm.userVirtualBG,
              });
              await vm.processor.enable();
            } catch (ex) {
              await vm.processor.disable();
              //alert(ex);
            } finally {
              //document.getElementById("loading").style.display = "none";
            }
          }
        }
      }
      vm.closeVirtualBGConfig();
    },

    async registerVirtualBackgroundExtension() {
      if (!vm.extension) {
        vm.extension = new VirtualBackgroundExtension();
        if (vm.extension) {
          AgoraRTC.registerExtensions([vm.extension]);
        }
      }
    },

    async createProcessorInstance() {
      if (!vm.processor && vm.remoteUsers[vm.uid].stream.videoTrack) {
        // Create a VirtualBackgroundProcessor instance
        vm.processor = vm.extension.createProcessor();
        try {
          // Initialize the extension and pass in the URL of the Wasm file
          await vm.processor.init("./assets/wasms");
        } catch (e) {
          console.log("Fail to load WASM resource!");
          return null;
        }
        // Inject the extension into the video processing pipeline in the SDK
        vm.remoteUsers[vm.uid].stream.videoTrack
          .pipe(vm.processor)
          .pipe(vm.remoteUsers[vm.uid].stream.videoTrack.processorDestination);
      }
    },

    handleVolumeIndicator(volumes) {
      if (!vm.micMuteUnmuteInProcess) {
        volumes = volumes.filter(function (volume) {
          return volume.level > vm.ActiveSpeakerMinVolume;
        });
        // volumes.forEach((volume, index) => {
        //   alert(vm.uid+
        //     " volume-indicator:uid=" + volume.uid + "; level=" + volume.level
        //   );
        // });
        vm.setVolumeIndicator(volumes);
      }
    },

    async sleep(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    },

    async bindUser(id) {
      if (!id || vm.vueBindingEnabled) {
        return;
      }
      let canvas = document.querySelector("#ag-canvas");
      let leftPanel = document.querySelector("#ag-left-panel");
      let el = document.querySelector("#ag-user-" + id);
      if (!el) {
        el = document.createElement("div");
        el.setAttribute("id", "ag-user-" + id);
        el.setAttribute("class", "ag-user");
        if (vm.pinSelected) {
          if (id > vm.shareIdStartsAfter && vm.PinShareScreen) {
            if (vm.activeScreenUID > 0) {
              $("#ag-user-" + vm.activeScreenUID)
                .detach()
                .appendTo("#ag-left-panel");
            }
            canvas.appendChild(el);
            vm.activeScreenUID = id;
          } else {
            leftPanel.appendChild(el);
          }
        } else {
          if (id > vm.shareIdStartsAfter && vm.PinShareScreen) {
            //alert("PinShareScreen: "+id);
            leftPanel.appendChild(el);

            vm.activeScreenUID = id;
            vm.displayMode = "pip";
            vm.pinSelected = true;
            vm.pinVideoTile(id);
          } else {
            //alert(id);
            canvas.appendChild(el);
          }
        }
      }
      let dom = document.querySelector("#ag-item-" + id);
      if (el && !dom) {
        dom = document.createElement("section");
        dom.setAttribute("id", "ag-item-" + id);
        dom.setAttribute("class", "ag-item");
        el.appendChild(dom);
      }
      let playerDom = document.querySelector("#player_" + id);
      if (!playerDom) {
        vm.addUserProfileNG(id);
      }
      $("#waiting_" + id + ".ag-waiting").remove();
      vm.setCanvasRowColumn();
      vm.setLeftCanvasRowColumn();

      // if (user.uid > vm.shareIdStartsAfter) {
      //   //alert("stream-added:" + id);
      //   if (vm.PinShareScreen) {
      //     vm.activeScreenUID = user.uid;
      //     vm.displayMode = "pip";
      //     vm.pinSelected = true;
      //     vm.pinVideoTile(user.uid);
      //   }
      // }
      if ([6, 100].includes(vm.sessionTypeId)) {
        vm.bindAbsentUser(true);
      }
    },

    bindAbsentUser(ring) {
      var id = "";
      var attendee2Id = vm.memberList.filter(function (item) {
        return item != vm.uid;
      });
      if (attendee2Id.length > 0 && !vm.remoteUsers[attendee2Id[0]]) {
        id = attendee2Id[0];
      }
      if (id) {
        if (!id || vm.vueBindingEnabled) {
          return;
        }
        let canvas = document.querySelector("#ag-canvas");
        let leftPanel = document.querySelector("#ag-left-panel");
        let el = document.querySelector("#ag-user-" + id);
        if (!el) {
          el = document.createElement("div");
          el.setAttribute("id", "ag-user-" + id);
          el.setAttribute("class", "ag-user");
          if (vm.pinSelected) {
            if (id > vm.shareIdStartsAfter && vm.PinShareScreen) {
              if (vm.activeScreenUID > 0) {
                $("#ag-user-" + vm.activeScreenUID)
                  .detach()
                  .appendTo("#ag-left-panel");
              }
              canvas.appendChild(el);
            } else {
              leftPanel.appendChild(el);
            }
          } else {
            if (id > vm.shareIdStartsAfter && vm.PinShareScreen) {
              leftPanel.appendChild(el);
              vm.activeScreenUID = id;
              vm.displayMode = "pip";
              vm.pinSelected = true;
              vm.pinVideoTile(id);
            } else {
              canvas.appendChild(el);
            }
          }
        }
        let dom = document.querySelector("#ag-item-" + id);
        if (el && !dom) {
          dom = document.createElement("section");
          dom.setAttribute("id", "ag-item-" + id);
          dom.setAttribute("class", "ag-item");
          el.appendChild(dom);
        }
        let playerDom = document.querySelector("#player_" + id);
        if (!playerDom) {
          vm.addUserProfileNG(id, true, ring);
        }
        vm.setCanvasRowColumn();
        vm.setLeftCanvasRowColumn();
      }
    },

    playAudio(user) {
      if (user.audioTrack) {
        user.audioTrack.play();
      }
    },

    playVideo(id, user) {
      let dom = document.querySelector("#ag-item-" + id);
      if (dom && user.videoTrack) {
        if (id == vm.uid) {
          if (vm.currentVideoProfile && vm.currentVideoProfile.value) {
            vm.switchVideoProfile(vm.currentVideoProfile.value);
          }
        }
        //setTimeout(async () => {
        //alert("playVideo")
        user.videoTrack.play("ag-item-" + id);
        //}, 100);
      }
    },

    async handleUserJoined(user) {
      //alert("handleUserJoined: "+user.uid);
      if (vm.uid == 221000) {
        //debugger;
        //alert("handleUserJoined: "+user.uid);
      }
      // if (vm.uid == 1324000) {
      //   debugger;
      //   alert("handleUserJoined: "+user.uid);
      // }
      if (user.uid == vm.shareUid) {
        return;
      }
      await vm.addUser(user.uid, user);
      await vm.bindUser(user.uid);
      if (vm.uid == 221000) {
        //debugger;
      }
      $("#audio-indicator-" + user.uid)
        .removeClass("sound-unmuted")
        .removeClass("sound-talking")
        .addClass("sound-muted");
      if (vm.AgoraRTMPStarted && vm.AgoraRTMPStartedBy == vm.uid) {
        //if (vm.AgoraRTMPStarted && (vm.userType == 1 || vm.isCurrentUserCoHost)) {
        //alert("handleUserJoined: "+user.uid);
        //vm.RestartAgoraRTMP();
        if (
          vm.AgoraRTMPStartedBy != user.uid &&
          !vm.isUserHost(vm.uid) &&
          !vm.isUserCoHost(vm.uid) &&
          (vm.isUserHost(user.uid) || vm.isUserCoHost(user.uid))
        ) {
          vm.StopAgoraRTMP(user.uid);
          //vm.$emit("StopRTMPStreaming", vm.sessionId, user.uid);
        } else {
          vm.RestartAgoraRTMP();
        }
      }
      vm.changePlayerStatus(1);
    },

    async handleUserLeft(user) {
      // if(vm.uid == "1324000"){
      // if(vm.uid == 221000){
      //   debugger;
      //   alert("handleUserLeft: "+user.uid);
      // }
      // if(vm.uid == 1324000){
      //   debugger;
      //   alert("handleUserLeft: "+user.uid);
      // }
      vm.manageUserLeft(user.uid);
      if (vm.sessionTypeId == 100 && user.uid != vm.uid) {
        setTimeout(() => {
          var name = "";
          var leftUser = vm.allAttendees.filter(function (item) {
            return item.AttendeeId == user.uid;
          });
          if (leftUser.length > 0) {
            name = leftUser[0].Name;
          }
          if (name) {
            vm.showSnackbar(name + " has ended the video call", "info", "top");
          }
          vm.onEndCall();
        }, 1000);
      }
    },

    manageUserLeft(id) {
      // if(vm.uid == 1324000){
      //   //|| id == vm.uid+vm.shareIdStartsAfter
      //   alert("manageUserLeft: "+id);
      //   debugger;
      // }
      delete vm.remoteUsers[id];
      $("#ag-user-" + id).remove();
      vm.newUserKey++;
      vm.setCanvasRowColumn();
      vm.setLeftCanvasRowColumn();
      //debugger;
      //else {
      let leftPanel = document.querySelector("#ag-left-panel");
      //debugger;
      if (id == vm.activeScreenUID || leftPanel.childNodes.length == 0) {
        var shareUid = 0;
        if (id == vm.activeScreenUID) {
          vm.activeScreenUID = 0;
          for (var key in vm.remoteUsers) {
            if (key > vm.shareIdStartsAfter) {
              shareUid = key;
              break;
            }
          }
        }
        //debugger;
        if (vm.remoteUsers[shareUid] && vm.PinShareScreen) {
          vm.activeScreenUID = shareUid;
          if (vm.pinSelected) {
            $("#ag-user-" + vm.activeScreenUID)
              .detach()
              .appendTo("#ag-canvas");
          } else {
            vm.pinVideoTile(vm.activeScreenUID);
          }
        } else {
          let parentPanel = document.querySelector("#ag-parent-canvas");
          if (parentPanel) {
            parentPanel.setAttribute("class", "");
            //alert("removed")
          }
          vm.switchToTileView();
          vm.setCanvasRowColumn();
          vm.setLeftCanvasRowColumn();
        }
      }
      // else {
      //   if (vm.uid == 221000) {
      //     alert("manageUserLeft: " + id);
      //     debugger;
      //   }
      // }
      //}
      if (Object.keys(vm.remoteUsers).length == 0) {
        vm.changePlayerStatus(0);
      } else {
        vm.changePlayerStatus(1);
      }
      if ([6, 100].includes(vm.sessionTypeId)) {
        vm.bindAbsentUser();
      }

      if (vm.AgoraRTMPStarted) {
        if (vm.AgoraRTMPStartedBy == vm.uid) {
          vm.RestartAgoraRTMP();
        } else if (vm.AgoraRTMPStartedBy == id) {
          //Stop RTMP and Assign Temp Host
          var tempHost = "";
          var speakerIdList = [];
          for (let uid in vm.remoteUsers) {
            if (vm.AgoraRTMPStartedBy != uid) {
              speakerIdList.push(uid);
              if (vm.isUserHost(uid)) {
                tempHost = uid;
                break;
              }
            }
          }
          if (!tempHost) {
            for (let i = 0; i < speakerIdList.length; i++) {
              if (vm.isUserCoHost(speakerIdList[i])) {
                tempHost = speakerIdList[i];
                break;
              }
            }
          }
          if (!tempHost) {
            speakerIdList.sort(function (a, b) {
              return a - b;
            });
            tempHost = speakerIdList[0];
          }
          if (vm.uid == tempHost) {
            vm.$emit("StopRTMPStreaming", vm.sessionId, tempHost);
          }
        }
      }
    },

    async handleUserPublished(user, mediaType) {
      //alert("handleUserPublished: "+user.uid);
      // alert("handleUserPublished: "+mediaType);
      if (user.uid == vm.shareUid) {
        //await vm.addUser(user.uid, user);
        return;
      }
      if (mediaType == "audio") {
        vm.remoteUsers[user.uid].audioSubscribed = true;
        if (user.uid == vm.shareUid) {
          //await vm.shareClient.subscribe(user, mediaType);
        } else {
          await vm.client.subscribe(user, mediaType);
        }
        if (user.audioTrack) {
          if (user.uid != vm.shareUid) {
            vm.remoteUsers[user.uid].stream.audioTrack.setVolume(
              vm.volumeLevel
            );
            vm.playAudio(vm.remoteUsers[user.uid].stream);
          }
        }
        $("#audio-indicator-" + user.uid)
          .removeClass("sound-muted")
          .removeClass("sound-talking")
          .addClass("sound-unmuted");

        $("#ag-option-mute-" + user.uid + " .ag-option-icon")
          .removeClass("ag-unmute")
          .addClass("ag-mute");
        $("#ag-option-mute-" + user.uid + " .ag-option-label").html("Mute");
      }
      if (mediaType == "video") {
        vm.remoteUsers[user.uid].videoSubscribed = true;
        if (user.uid == vm.shareUid) {
          //await vm.shareClient.subscribe(user, mediaType);
        } else {
          await vm.client.subscribe(user, mediaType);
        }
        if (user.videoTrack) {
          if (user.uid != vm.shareUid) {
            vm.playVideo(user.uid, vm.remoteUsers[user.uid].stream);
          }
          $("#profileImage_" + user.uid).addClass("d-none");
        } else {
          $("#profileImage_" + user.uid).removeClass("d-none");
        }
      }
      // if (vm.AgoraRTMPStarted && vm.AgoraRTMPStartedBy == vm.uid) {
      //   vm.RestartAgoraRTMP();
      // }
    },

    async handleUserUnpublished(user, mediaType) {
      //alert("handleUserUnpublished: "+user.uid);
      if (user.uid == vm.shareUid) {
        //await vm.shareClient.unsubscribe(user, mediaType);
      } else {
        await vm.client.unsubscribe(user, mediaType);
      }
      if (mediaType == "audio") {
        $("#audio-indicator-" + user.uid)
          .removeClass("sound-unmuted")
          .removeClass("sound-talking")
          .addClass("sound-muted");

        $("#ag-option-mute-" + user.uid + " .ag-option-icon")
          .removeClass("ag-mute")
          .addClass("ag-unmute");
        $("#ag-option-mute-" + user.uid + " .ag-option-label").html(
          "Request to unmute"
        );
      }
      if (mediaType == "video") {
        $("#profileImage_" + user.uid).removeClass("d-none");
      }
      // if (vm.AgoraRTMPStarted && vm.AgoraRTMPStartedBy == vm.uid) {
      //   vm.RestartAgoraRTMP();
      // }
    },

    async setSomeUserHQStream(HQStreamUserList = []) {
      // get a list of all remote users
      const allUserList = [...Object.keys(vm.remoteUsers)].map(Number);
      // set default HQStreamUserList
      if (
        !HQStreamUserList ||
        (Array.isArray(HQStreamUserList) && HQStreamUserList.length === 0)
      ) {
        if (allUserList.length) {
          HQStreamUserList = [allUserList[0]];
        }
      }
      // All other elements are the elements of the LQStreamUserList
      const LQStreamUserList = allUserList.filter(
        (user) => !HQStreamUserList.includes(user)
      );
      const handlePromiseList = [];
      // Get a queue
      // The queue settings for all streams
      LQStreamUserList.forEach(
        (user) =>
          void handlePromiseList.push(async () => {
            console.log(`set user: ${user} to LQ Stream`);
            const result = await vm.client.setRemoteVideoStreamType(user, 1);
            return result;
          })
      );
      HQStreamUserList.forEach(
        (user) =>
          void handlePromiseList.push(async () => {
            console.log(`set user: ${user} to HQ Stream`);
            const result = await vm.client.setRemoteVideoStreamType(user, 0);
            return result;
          })
      );
      // return a promise.all
      // promise.all requires an array of promises.
      return Promise.all(handlePromiseList.map((m) => m()));
    },
    async handleConnectionStateChange(curState, revState, reason) {
      //alert("Connection State Change");
      //if (curState && revState && reason) {
      //if ([221000, 1324000,1562000,42001,99901500].includes(vm.uid)) {
      vm.saveConnectionStateChangeLog(curState, revState, reason);
      //}
      //}
    },
    async handlePublishedUserList(users) {
      console.log("users>>>>>>>>>>>>>>>> " + users);
      // if ([221000, 1324000,1562000,42001,99901500].includes(vm.uid)) {
      //   vm.saveConnectionStateChangeLog(curState, revState, reason)
      // }
    },
    saveConnectionStateChangeLog(curState, revState, reason) {
      let logId = new Date().getTime().toString();
      let logObj = new Object({
        sessionId: vm.sessionId,
        roundTableId: vm.roundTableId,
        clientUserId: vm.uid,
        curState: curState ? curState : "",
        revState: revState ? revState : "",
        reason: reason ? reason : "",
        CreatedDate: new Date(),
      });

      db.collection(vm.event_collectionName)
        .doc("UserVideoActivity")
        .collection("PlayerConnectionStateChangeLog")
        .doc(logId)
        .set(logObj)
        .then(function () {
          //alert("Success");
        })
        .catch(function (error) {
          console.log(error);
          //alert("Failure");
        });
    },
    saveCallSettings(key, value) {
      if (key && value) {
        Cookies.set(key, value);
      }
    },
    getCallSettings(key) {
      let result = "";
      if (key) {
        if (Cookies.get(key)) {
          result = Cookies.get(key);
        }
      }
      return result;
    },

    startGoLiveTimer() {
      if (goLiveTimer) {
        clearInterval(goLiveTimer);
      }
      goLiveTimer = setInterval(function () {
        if (vm.session) {
          if (
            vm.session.SessionStartTime <= parseInt(new Date().getTime() / 1000)
          ) {
            if (goLiveTimer) {
              clearInterval(goLiveTimer);
              vm.IsGoLive = true;
            }
          }
        }
      }, 1000);
    },

    GoLive() {
      //location.reload();
      vm.$emit("goLive", vm.sessionId);
    },

    takeActionOnDeviceError(err) {
      if (err.type == "error") {
        //alert(err.msg);
        // alert("Media Error: (" + err.msg + " : " + err.info + ")");
        switch (err.msg) {
          case "NotAllowedError":
            //alert("Camera not allowed");
            //alert("Please allow your camera and try again");
            break;
          case "MEDIA_NOT_SUPPORT":
            //alert("Media not supported");
            break;
          case "NotFoundError":
            //alert("Media not found");
            break;
          default:
            break;
        }
      }
    },

    AttendeeCount() {
      return vm.allAttendees.length;
    },

    ShowAlertMessage(msg) {
      if (location.origin.startsWith("http://localhost")) {
        //alert(msg);
      }
      console.log(msg);
    },

    SendLogMessage(msg) {
      console.log(msg);
      //vm.playerLog.sendP2PMessage(msg);
    },

    saveAgoraLog(actiontype, actionLabel, agoraUserId) {
      //alert(
      //  "actiontype:" +
      //    actiontype +
      //    "; actionLabel:" +
      //    actionLabel +
      //    "; agoraUserId:" +
      //    agoraUserId
      //);
      let errorType = "AUDIO";
      if (actionLabel.includes("VIDEO")) {
        errorType = "VIDEO";
      }
      let headers = {
        "content-type": "application/json",
      };
      let requestData = {
        instanceId: "OA_UAT",
        clientId: vm.clientId,
        eventId: vm.eventId,
        sessionId: vm.sessionId,
        agoraChannelId: vm.channelName,
        agoraUserId: agoraUserId,
        errorType: errorType, //"Audio/Video", //-- Audio/Video
        streamStatus: actiontype,
        errorReason: "clientUserId:" + vm.uid + ":" + actionLabel,
      };

      //{
      //        instanceId: "OA_UAT",
      //        clientId: vm.clientId,
      //        eventId: vm.eventId,
      //        origin: "Responsive", //-- CMS/Responsive/MobileApp
      //        userId: vm.uid,
      //        userName: vm.name,
      //        userEmail: "",
      //        action: action,
      //        actionLabel: actionLabel,
      //        actionType: actiontype,
      //        pageName: "Player_" + vm.channelName,
      //        eventName: vm.eventName,
      //      };
      axios
        .post(APIs.AgoraErrorLog, requestData, {
          headers: headers,
        })
        .then((responseData) => {
          //alert("Success");
          console.log(responseData);
        })
        .catch((error) => {
          //alert("AgoraErrorLog:" + error);
          console.log("AgoraErrorLog: " + error);
        });
    },

    setVolumeIndicator(users) {
      //if (vm.localStreamVolume > 0) {
      //  users.push({
      //    uid: vm.localStream.getId(),
      //    level: vm.localStreamVolume,
      //  });
      //}
      $(".ag-user").attr("asrank", "0");
      if (vm.ShowAudioVolume) {
        $(".ag-user .ag-asr").html("0");
      }
      $(".sound-talking")
        .removeClass("sound-talking")
        .addClass("sound-unmuted");

      if (users.length > 0) {
        users.forEach(function (user) {
          //alert(user.uid + " : " + user.level);
          if ($("#debugPanel")) {
            vm.showLog("v:" + user.uid + "=" + user.level);
          }
          $("#ag-user-" + user.uid).attr("asrank", user.level);
          if (vm.ShowAudioVolume) {
            $("#ag-user-" + user.uid + " .ag-asr").html(user.level);
          }
          $("#audio-indicator-" + user.uid).addClass("sound-talking");
        });
        users.sort(function (a, b) {
          if (a.level > b.level) {
            return -1;
          }
          if (a.level < b.level) {
            return 1;
          }
          return 0;
        });
        //alert(vm.activeScreenUID);
        if (!vm.pinSelected) {
          if (vm.ActiveSpeakerFocus) {
            //vm.pinVideoTile(users[0].uid);
            vm.activeScreenUID = users[0].uid;
            //alert(users[0].uid);
            //vm.arrangeVideoFrame();
            //vm.setActiveVideoFrame();
          }
        } else {
          if (vm.ActiveSpeakerSorting) {
            vm.sortByActiveSpeaker();
          } else {
            if (
              vm.shareClient != null ||
              (vm.activeScreenUID > vm.shareIdStartsAfter &&
                vm.activeScreenUID != vm.shareUid)
            ) {
              //alert(vm.shareUid);
              //alert(vm.activeScreenUID);
              vm.sortByActiveSpeaker();
            }
          }
        }
      }
    },

    isUserHost(id) {
      let result = false;
      if (!id) {
        id = vm.uid;
      }
      vm.allHosts.forEach(function (item) {
        if (id == item.AttendeeId) {
          result = true;
        }
      });
      return result;
    },
    isUserCoHost(id) {
      let result = false;
      if (!id) {
        id = vm.uid;
      }
      vm.allCoHosts.forEach(function (item) {
        if (id == item.AttendeeId) {
          result = true;
        }
      });
      return result;
    },

    setActiveVideoFrame() {
      // alert("setActiveVideoFrame");
      vm.showLog("setActiveVideoFrame");
      if (vm.activeScreenUID != 0 && vm.streamList.length > 0) {
        let canvas = document.querySelector("#ag-canvas");
        //let parentPanel = document.querySelector("#ag-parent-canvas");
        //let leftPanel = document.querySelector("#ag-left-panel");
        //let rightPanel = document.querySelector("#ag-right-panel");
        let dom = document.querySelector("#ag-user-" + vm.activeScreenUID);
        if (dom) {
          //alert(dom.getAttribute("class"));
          if (canvas.childNodes.length == 1) {
            let position = 0;

            if (dom.parentNode.getAttribute("id") == "ag-left-panel") {
              position = 1;
            }
            if (dom.parentNode.getAttribute("id") == "ag-right-panel") {
              position = 2;
            }

            let id = canvas.childNodes[0].getAttribute("id");
            if (position == 1) {
              $(id).detach().appendTo("#ag-left-panel");
            } else if (position == 2) {
              $(id).detach().appendTo("#ag-right-panel");
            }
            if (position == 1 || position == 2) {
              $("#ag-canvas").html("");
              $("#ag-user-" + vm.activeScreenUID)
                .detach()
                .appendTo("#ag-canvas");
            }
            vm.setCanvasRowColumn();
            vm.setLeftCanvasRowColumn();
            vm.setRightCanvasRowColumn();
          }
        }
      }
    },

    sortByActiveSpeaker() {
      var sortOption = "0";
      //if ($("#ddlQNASort") != undefined) {
      //  sortOption = $("#ddlQNASort").val();
      //}
      var list, i, switching, b, shouldSwitch;
      list = document.getElementById("ag-left-panel");
      switching = true;
      /* Make a loop that will continue until no switching has been done: */
      while (switching) {
        // Start by saying: no switching is done:
        switching = false;
        b = list.getElementsByClassName("ag-user");
        // Loop through all list items:
        //alert("b.length:" + b.length);
        for (i = 0; i < b.length - 1; i++) {
          // Start by saying there should be no switching:
          shouldSwitch = false;
          /* Check if the next item should
            switch place with the current item: */
          if (sortOption == "1") {
            var firstName1 = $(b[i]).attr("firstName");
            var firstName2 = $(b[i + 1]).attr("firstName");
            if (firstName2 > firstName1) {
              /* If next item is alphabetically lower than current item,
                    mark as a switch and break the loop: */
              shouldSwitch = true;
              break;
            }
          } else if (sortOption == "0") {
            //alert("sortOption:" + sortOption);
            var activeSpeakerRank1 = parseInt($(b[i]).attr("asrank"));
            var activeSpeakerRank2 = parseInt($(b[i + 1]).attr("asrank"));

            if (activeSpeakerRank2 > activeSpeakerRank1) {
              /* If next item is alphabetically lower than current item,
                    mark as a switch and break the loop: */
              //alert(
              //  "activeSpeakerRank1: " +
              //    activeSpeakerRank1 +
              //    " activeSpeakerRank2: " +
              //    activeSpeakerRank2
              //);
              shouldSwitch = true;
              break;
            } else {
              //alert(
              //  "activeSpeakerRank1: " +
              //    activeSpeakerRank1 +
              //    " activeSpeakerRank2: " +
              //    activeSpeakerRank2
              //);
            }
          }
        }
        if (shouldSwitch) {
          /* If a switch has been marked, make the switch
            and mark the switch as done: */
          b[i].parentNode.insertBefore(b[i + 1], b[i]);
          switching = true;
        }
      }
    },

    checkMyVolumeIndicator() {
      if (vm.localStream == null) {
        //if (vm.streamList.length) {
        //  alert(vm.streamList.length);
        //}
        let users = [];
        vm.streamList.forEach(function (item) {
          let uid = item.getId();
          let volumeLevel = item.getAudioLevel();
          volumeLevel = parseInt(volumeLevel * 100);
          if (volumeLevel > 0) {
            //alert("checkMyVolumeIndicator:" + volumeLevel);
            users.push({
              uid: uid,
              level: volumeLevel,
            });
          }
        });
        vm.setVolumeIndicator(users);
      } else {
        //vm.localStreamVolume = parseInt(vm.localStream.getAudioLevel() * 100);
        ////alert(audioLevel);
        ////audioLevel *= 100;
        ////alert(audioLevel);
        //$(".ag-item-" + vm.uid).attr("asrank", "0");
        //if (vm.ShowAudioVolume) {
        //  $(".ag-item-" + vm.uid + " .ag-asr").html("0");
        //}
        //$("#audio-indicator-" + vm.uid)
        //  .removeClass("sound-talking")
        //  .addClass("sound-unmuted");
        //$("#ag-item-" + vm.uid).attr("asrank", audioLevel);
        //if (vm.ShowAudioVolume) {
        //  $("#ag-item-" + vm.uid + " .ag-asr").html(audioLevel);
        //}
        //$("#audio-indicator-" + vm.uid).addClass("sound-talking");
        ////if (!vm.pinSelected) {
        ////  if (vm.ActiveSpeakerFocus) {
        ////    //vm.pinVideoTile(users[0].uid);
        ////    vm.activeScreenUID = vm.uid;
        ////    //vm.setActiveFrameInCenter();
        ////    //vm.arrangeVideoFrame();
        ////  }
        ////} else {
        ////  if (vm.ActiveSpeakerSorting) {
        ////    vm.sortByActiveSpeaker();
        ////  }
        ////}
        //////var audioLevel = localStream.getAudioLevel() * 100;
        ////////console.log('audioLevel',audioLevel);
        //////if (!$("#player_" + uid).hasClass("active-speaker")) {
        //////  $("#player_" + uid).addClass("active-speaker");
        //////}
        //////if (audioLevel > 10) {
        //////  $("#player_" + uid + " span.speaker-wave > img").attr(
        //////    "src",
        //////    "images/volume-indicator.gif"
        //////  );
        //////} else {
        //////  //$("#player_"+volume.uid).removeClass('active-speaker');
        //////  $("#player_" + uid + " span.speaker-wave > img").attr(
        //////    "src",
        //////    "images/volume-indicator-pause.png"
        //////  );
        //////}
      }
    },

    changePlayerStatus(status) {
      debugger;
      if (status == 1) {
        if (
          vm.remoteUsers[vm.uid] &&
          vm.remoteUsers[vm.uid].stream &&
          (vm.remoteUsers[vm.uid].stream.audioTrack ||
            vm.remoteUsers[vm.uid].stream.videoTrack)
        ) {
          // alert("player-not-ready555555555555555555");
          $("#player-not-ready").addClass("d-none");
          $("#ag-parent-canvas").removeClass("d-none");
          //$("#ag-sponsor-panel").removeClass("d-none");
          //$("#ag-button-panel").removeClass("d-none");
          //$(".view-count").removeClass("d-none");
          $(".show-on-call").removeClass("d-none");
          return;
        }
        if (vm.userType != 4 || Object.keys(vm.remoteUsers).length > 0) {
          // alert("player-not-ready666666666666666666");
          $("#player-not-ready").addClass("d-none");
          $("#ag-parent-canvas").removeClass("d-none");
          //$("#ag-sponsor-panel").removeClass("d-none");
          //$("#ag-button-panel").removeClass("d-none");
          //$(".view-count").removeClass("d-none");
          $(".show-on-call").removeClass("d-none");
        }
        //}
      } else {
        // alert("player-not-ready11111");

        $("#player-not-ready").removeClass("d-none");
        $("#ag-parent-canvas").addClass("d-none");
        //$("#ag-sponsor-panel").addClass("d-none");
        //$(".view-count").addClass("d-none");
        $(".show-on-call").addClass("d-none");
        //alert($("#ag-canvas").html());
        $("#ag-canvas").html("");
        //alert($("#ag-canvas").html());
        $("#ag-left-panel").html("");
        $("#ag-right-panel").html("");

        if (testStream) {
          testStream.getTracks().forEach(function (track) {
            track.stop();
            console.log("track>>>>>>>>>>>>>>>>>>");
          });
          console.log("testStream>>>>>>>>>>>>>>>>>>");
        }
        testStream = null;
      }
    },

    addStream(stream, push = false) {
      //vm.addStreamUserList(stream.getId());
      let repeatition = vm.streamList.some((item) => {
        return item.getId() === stream.getId();
      });
      if (repeatition) {
        return;
      }
      if (push) {
        vm.streamList = vm.streamList.concat([stream]);
      } else {
        vm.streamList = [stream].concat(vm.streamList);
      }
    },

    async addUser(id, stream) {
      id = parseInt(id);
      if (!stream) {
        stream = {};
      }
      if (vm.remoteUsers[id]) {
        vm.remoteUsers[id].stream = stream;
      } else {
        vm.remoteUsers[id] = { uid: id, stream: stream };
      }
      vm.newUserKey++;
      //setTimeout(async () => {
      vm.setCanvasRowColumn();
      //}, 100);
    },

    removeStream(uid) {
      //alert("removeStream");
      //if (uid == 666) {
      //  return;
      //}
      //vm.removeStreamUserList(uid);

      vm.streamList.map((item, index) => {
        if (item.getId() === uid) {
          item.close();
          let element = document.querySelector("#ag-user-" + uid);
          if (element) {
            element.parentNode.removeChild(element);
          }
          let tempList = [...this.streamList];
          tempList.splice(index, 1);
          vm.streamList = tempList;
        }
      });
      if (vm.streamList.length > 0 && vm.activeScreenUID == uid) {
        vm.activeScreenUID = vm.streamList[0].getId();
      }
      //let canvas = document.querySelector("#ag-canvas");
      //let leftPanel = document.querySelector("#ag-left-panel");
      //let rightPanel = document.querySelector("#ag-right-panel");
      //canvas.childNodes.clear();
      //leftPanel.childNodes.clear();
      //rightPanel.childNodes.clear();
      vm.setCanvasRowColumn();
      vm.setLeftCanvasRowColumn();
      vm.setRightCanvasRowColumn();
      if (vm.streamList.length == 0) {
        vm.changePlayerStatus(0);
      }
    },

    removeStreamNG(uid) {
      //alert("removeStream");
      //if (uid == 666) {
      //  return;
      //}
      //vm.removeStreamUserList(uid);

      vm.streamList.map((item, index) => {
        if (item.getId() === uid) {
          item.close();
          let element = document.querySelector("#ag-user-" + uid);
          if (element) {
            element.parentNode.removeChild(element);
          }
          let tempList = [...this.streamList];
          tempList.splice(index, 1);
          vm.streamList = tempList;
        }
      });
      if (vm.streamList.length > 0 && vm.activeScreenUID == uid) {
        vm.activeScreenUID = vm.streamList[0].getId();
      }
      //let canvas = document.querySelector("#ag-canvas");
      //let leftPanel = document.querySelector("#ag-left-panel");
      //let rightPanel = document.querySelector("#ag-right-panel");
      //canvas.childNodes.clear();
      //leftPanel.childNodes.clear();
      //rightPanel.childNodes.clear();
      vm.setCanvasRowColumn();
      vm.setLeftCanvasRowColumn();
      vm.setRightCanvasRowColumn();
      if (vm.streamList.length == 0) {
        vm.changePlayerStatus(0);
      }
    },

    addStreamUserList(uid) {
      let streamUsers = vm.streamUserList.filter((item) => {
        return item.uid == uid;
      });
      if (streamUsers.length == 0) {
        vm.streamUserList.push({ uid: uid, IsLocal: uid == vm.uid });
      }
    },
    removeStreamUserList(uid) {
      vm.streamUserList = vm.streamUserList.filter((item) => {
        return item.uid != uid;
      });
    },
    updateRTMPStatus(val, userId) {
      if (vm.userType < 4) {
        // alert("readyState: "+vm.readyState);
        // alert("AgoraRTMPStarted: "+val);
        // alert("UserType : "+vm.userType + "; "+vm.uid+" received userId: "+userId);

        vm.AgoraRTMPStartedBy = userId;
        //if (vm.AgoraRTMPStartedBy == vm.uid) {
        vm.AgoraRTMPStarted = val;
        // } else {
        //   vm.AgoraRTMPStarted = false;
        // }
        // if (!val && vm.AgoraRTMPStartedBy == "") {
        //   vm.userType = 1;
        //   vm.StartAgoraRTMP();
        // }
      }
    },
    async StartAgoraRTMP() {
      //alert("inside StartAgoraRTMP")
      //debugger;
      // if (isTempHost && !vm.isUserCoHost()) {
      //   vm.userType = 1;
      // }
      // if(vm.uid == "99905207"){
      // alert("StartAgoraRTMP")
      // }
      vm.AgoraRTMPInProcess = true;
      // const LiveTranscoding = {
      //   // Width of the video (px). The default value is 640.
      //   width: 640,
      //   // Height of the video (px). The default value is 360.
      //   height: 360,
      //   // Bitrate of the video (Kbps). The default value is 400.
      //   videoBitrate: 400,
      //   // Frame rate of the video (fps). The default value is 15.
      //   videoFramerate: 15,
      //   audioSampleRate: AgoraRTC.AUDIO_SAMPLE_RATE_48000,
      //   audioBitrate: 48,
      //   audioChannels: 1,
      //   videoGop: 30,
      //   // Video codec profile. Choose to set as Baseline (66), Main (77), or High (100). If you set this parameter to other values, Agora adjusts it to the default value of 100.
      //   videoCodecProfile: AgoraRTC.VIDEO_CODEC_PROFILE_HIGH,
      //   userCount: 1,
      //   userConfigExtraInfo: "",
      //   backgroundColor: 0x000000,
      //   // Add an online PNG watermark image to the video. You can add only one watermark.
      //   watermark: {
      //           url: "http://www.com/watermark.png",
      //           x: 0,
      //           y: 0,
      //           width: 160,
      //           height: 160,
      //       },
      //   // Set the layout for each user.
      //   transcodingUsers: [{
      //           x: 0,
      //           y: 0,
      //           // If you don't want to show a user's video, set both the width and height to 1 to make the user's viewport a dot.
      //           // Do not set the width and height to 0 at the same time. If you do so, the SDK throws an error.
      //           width: 640,
      //           height: 360,
      //           zOrder: 0,
      //           alpha: 1.0,
      //           // The uid must be identical to the uid used in AgoraRTCClient.join.
      //           uid: 221000,
      //         }],
      // };
      // alert("AgoraRTC.AUDIO_SAMPLE_RATE_48000: "+AgoraRTC.AUDIO_SAMPLE_RATE_48000);
      // alert("AgoraRTC.VIDEO_CODEC_PROFILE_HIGH: "+AgoraRTC.VIDEO_CODEC_PROFILE_HIGH);
      //const transcodingUsers = [options.uid, ...Object.keys(vm.remoteUsers)].map((user, index)=>{
      //const transcodingUsers = vm.remoteUsers.values.map(
      //   (user, index) => {
      //     // Set the size according to your idea
      //     const width = 600;
      //     const height = 700;
      //     return {
      //       // Set the location coordinates according to your ideas
      //       x: 30 * (index % 2) + index * width + 10,
      //       y: 10,
      //       width,
      //       height,
      //       zOrder: 0,
      //       alpha: 1.0,
      //       // The uid below should be consistent with the uid entered in AgoraRTCClient.join
      //       // uid must be an integer number
      //       uid: user.uid, //Number(uid),
      //     };
      //   }
      // );

      var rtmpWidth = 1280;
      var rtmpHeight = 720;
      var transcodingUsers = [];
      var width = 0;
      var height = 0;
      var userCount = Object.keys(vm.remoteUsers).length;
      //var rowCount = 1;
      var colCount = 1;
      //alert("Total User: " + userCount);
      var shareScreemId = "";
      for (var key in vm.remoteUsers) {
        if (key > vm.shareIdStartsAfter) {
          shareScreemId = key;
        }
      }
      var screenWidth = 0;
      var screenHeight = 0;
      console.log(screenWidth);
      console.log(screenHeight);
      let user;
      if (shareScreemId) {
        user = vm.remoteUsers[shareScreemId];
        if (userCount - 1 <= 6) {
          colCount = 1;
          width = 210;
          height = 120;
          screenWidth = rtmpWidth - width;
          if (user && user.stream && user.stream.videoTrack) {
            //alert("Hi");
            //debugger;
            if (
              user.stream.videoTrack._videoHeight &&
              user.stream.videoTrack._videoWidth
            ) {
              screenHeight = parseInt(
                (user.stream.videoTrack._videoHeight /
                  user.stream.videoTrack._videoWidth) *
                  screenWidth
              );
              //alert("1 screenHeight: "+screenHeight+"; screenWidth: "+screenWidth);
            } else {
              screenHeight = parseInt((rtmpHeight / rtmpWidth) * screenWidth);
              //alert("2 screenHeight: "+screenHeight+"; screenWidth: "+screenWidth);
            }
          } else {
            //screenHeight = rtmpHeight - height;
            screenHeight = parseInt((rtmpHeight / rtmpWidth) * screenWidth);
            //alert("3 screenHeight: "+screenHeight+"; screenWidth: "+screenWidth);
          }
        } else {
          colCount = 2;
          width = 105;
          height = 60;
          screenWidth = rtmpWidth - width * 2;
          if (user && user.stream && user.stream.videoTrack) {
            if (
              user.stream.videoTrack._videoHeight &&
              user.stream.videoTrack._videoWidth
            ) {
              screenHeight = parseInt(
                (user.stream.videoTrack._videoHeight /
                  user.stream.videoTrack._videoWidth) *
                  screenWidth
              );
            } else {
              screenHeight = parseInt((rtmpHeight / rtmpWidth) * screenWidth);
            }
          } else {
            //screenHeight = rtmpHeight - height;
            screenHeight = parseInt((rtmpHeight / rtmpWidth) * screenWidth);
          }
        }
      } else {
        if (userCount == 1) {
          //rowCount = 1;
          colCount = 1;
          width = rtmpWidth;
          height = rtmpHeight;
        } else if (userCount == 2) {
          //rowCount = 1;
          colCount = 2;
          width = parseInt(rtmpWidth / 2);
          height = rtmpHeight;
        } else if (userCount <= 4) {
          //rowCount = 2;
          colCount = 2;
          width = parseInt(rtmpWidth / 2);
          height = parseInt(rtmpHeight / 2);
        } else if (userCount <= 6) {
          //rowCount = 2;
          colCount = 3;
          width = parseInt(rtmpWidth / 3);
          height = parseInt(rtmpHeight / 2);
        } else if (userCount <= 8) {
          //rowCount = 2;
          colCount = 4;
          width = parseInt(rtmpWidth / 4);
          height = parseInt(rtmpHeight / 2);
        } else if (userCount <= 12) {
          //rowCount = 3;
          colCount = 4;
          width = parseInt(rtmpWidth / 4);
          height = parseInt(rtmpHeight / 3);
        } else if (userCount <= 16) {
          //rowCount = 4;
          colCount = 4;
          width = parseInt(rtmpWidth / 4);
          height = parseInt(rtmpHeight / 4);
        } else {
          colCount = 4;
          width = parseInt(rtmpWidth / 4);
          height = parseInt(rtmpHeight / 4);
        }
      }
      if (userCount > 1) {
        width = width - 10;
        height = height - 10;
      }
      var index = 0;
      if (shareScreemId) {
        var currentRow = 0;
        transcodingUsers.push({
          // Set the location coordinates according to your ideas
          x: 0,
          y: parseInt((rtmpHeight - screenHeight) / 2),
          width: screenWidth,
          height: screenHeight,
          zOrder: 0,
          alpha: 1.0,
          // The uid below should be consistent with the uid entered in AgoraRTCClient.join
          // uid must be an integer number
          uid: Number(user.uid), //Number(uid),
        });
        for (let key in vm.remoteUsers) {
          if (key != shareScreemId) {
            currentRow = parseInt(index / colCount);
            user = vm.remoteUsers[key];
            transcodingUsers.push({
              // Set the location coordinates according to your ideas
              x:
                10 * (index % colCount) +
                (index % colCount) * width +
                screenWidth +
                10,
              y: 10 * currentRow + currentRow * height + 10,
              width: width,
              height: height,
              zOrder: index + 1,
              alpha: 1.0,
              // The uid below should be consistent with the uid entered in AgoraRTCClient.join
              // uid must be an integer number
              uid: Number(user.uid), //Number(uid),
              // defaultPlaceholderImageUrl:
              //   "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT%2FAGORA%2Fvirtual_bg%2Froom.jpg?alt=media",
            });
            index++;
          }
        }
        //alert(transcodingUsers.length);
      } else {
        for (let key in vm.remoteUsers) {
          let currentRow = parseInt(index / colCount);
          let user = vm.remoteUsers[key];
          transcodingUsers.push({
            // Set the location coordinates according to your ideas
            x: 10 * (index % colCount) + (index % colCount) * width,
            y: 10 * currentRow + currentRow * height,
            width: width,
            height: height,
            zOrder: index,
            alpha: 1.0,
            // The uid below should be consistent with the uid entered in AgoraRTCClient.join
            // uid must be an integer number
            uid: Number(user.uid), //Number(uid),
            // profileImage: {
            //   url: "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT%2FAGORA%2Fvirtual_bg%2Froom.jpg?alt=media",
            //   x: 0,
            //   y: 0,
            //   width: 1280,
            //   height: 720,
            // },
            // profileImageUrl:
            //   "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT%2FAGORA%2Fvirtual_bg%2Froom.jpg?alt=media",
            // imageUrl:
            //   "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT%2FAGORA%2Fvirtual_bg%2Froom.jpg?alt=media",
            // fillMode: "fill",
            // placeholderImageUrl:
            //   "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT%2FAGORA%2Fvirtual_bg%2Froom.jpg?alt=media",
            // //defaultPlaceholderImageUrl:"https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT%2FAGORA%2Fvirtual_bg%2Froom.jpg?alt=media",
          });
          index++;
        }
      }
      // transcodingUsers.push({
      //   // Set the location coordinates according to your ideas
      //   x: 30 * (1 % 2) + 1 * width + 10,
      //   y: 10,
      //   width,
      //   height,
      //   zOrder: 0,
      //   alpha: 1.0,
      //   // The uid below should be consistent with the uid entered in AgoraRTCClient.join
      //   // uid must be an integer number
      //   uid: 42001, //Number(uid),
      // });

      const LiveTranscoding = {
        // Width of the video (px). The default value is 640.
        width: 1280,
        // Height of the video (px). The default value is 360.
        height: 720,
        // Bitrate of the video (Kbps). The default value is 400.
        videoBitrate: 400,
        // Frame rate of the video (fps). The default value is 15.
        videoFramerate: 15,
        audioSampleRate: 32000, //AgoraRTC.AUDIO_SAMPLE_RATE_48000,
        audioBitrate: 48,
        audioChannels: 1,
        videoGop: 30,
        // Video codec profile. Choose to set as Baseline (66), Main (77), or High (100). If you set this parameter to other values, Agora adjusts it to the default value of 100.
        videoCodecProfile: 100, //AgoraRTC.VIDEO_CODEC_PROFILE_HIGH,
        userCount: userCount,
        userConfigExtraInfo: "",
        backgroundColor: 0x000000,
        // backgroundImage: {
        //   url: "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT%2FAGORA%2Fvirtual_bg%2Fe2m-virtual-bg.png?alt=media",
        //   x: 0,
        //   y: 0,
        //   width: 1280,
        //   height: 720,
        // },
        // backgroundImage: {
        //         url: "https://agoraio-community.github.io/AgoraWebSDK-NG/img/sd_rtn.jpg",
        //         x: 100,
        //         y: 100,
        //         width: 1080,
        //         height: 520,
        // },
        //defaultPlaceholderImageUrl: "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT%2FAGORA%2Fvirtual_bg%2Froom.jpg?alt=media",
        watermark: {
          //url: "https://agoraio-community.github.io/AgoraWebSDK-NG/img/logo.png",
          url: "https://firebasestorage.googleapis.com/v0/b/uate2monair.appspot.com/o/OA_UAT%2FDefaults%2Fimage%2Fe2m-watermark-logo.png?alt=media",
          x: 1000,
          y: 580,
          width: 260,
          height: 58,
        },
        // Add an online PNG watermark image to the video. You can add only one watermark.
        // watermark: {
        //   url: "https://firebasestorage.googleapis.com/v0/b/uate2monair.appspot.com/o/OA_UAT%2FDefaults%2Fimage%2Fe2m-on-air-white.png?alt=media",
        //   x: 0,
        //   y: 0,
        //   width: 160,
        //   height: 160,
        // },
        // Set the layout for each user.
        // transcodingUsers: [
        //   {
        //     x: 0,
        //     y: 0,
        //     // If you don't want to show a user's video, set both the width and height to 1 to make the user's viewport a dot.
        //     // Do not set the width and height to 0 at the same time. If you do so, the SDK throws an error.
        //     width: 640,
        //     height: 360,
        //     zOrder: 0,
        //     alpha: 1.0,
        //     // The uid must be identical to the uid used in AgoraRTCClient.join.
        //     uid: 221000,
        //   },
        //],
        transcodingUsers,
      };
      vm.client.on("live-streaming-error", function (url, err) {
        console.log("live-streaming-error: " + url);
        console.log("live-streaming-error: " + err);
      });
      vm.client.on("live-streaming-warning", function (url, err) {
        console.log("live-streaming-warning: " + url);
        console.log("live-streaming-warning: " + err);
      });

      //https://firebasestorage.googleapis.com/v0/b/uate2monair.appspot.com/o/OA_UAT%2FDefaults%2Fimage%2Fe2m-on-air-white.png?alt=media
      // if (vm.AgoraRTMPStarted) {
      //   alert("updateRtmpTranscoding");
      //   await vm.client
      //     .updateRtmpTranscoding(LiveTranscoding)
      //     .then(() => {
      //       vm.AgoraRTMPInProcess = false;
      //       alert("updateRtmpTranscoding success");
      //     })
      //     .catch(function (error) {
      //       vm.AgoraRTMPInProcess = false;
      //       alert("updateRtmpTranscoding Error : " + error);
      //     });
      // } else {
      await vm.client
        .setLiveTranscoding(LiveTranscoding)
        .then(() => {
          //alert("set live transcoding success");
        })
        .catch(function (error) {
          console.log("setLiveTranscoding Error : " + error);
        });
      // }
      // alert(vm.session.RTMPMUX_detail.data.rtmpPushEndpoint.url);
      // alert(vm.session.RTMPMUX_detail.data.rtmpPushEndpoint.streamKey);
      // if (
      //   vm.session &&
      //   vm.session.RTMPMUX_detail &&
      //   vm.session.RTMPMUX_detail.data &&
      //   vm.session.RTMPMUX_detail.data.rtmpPushEndpoint
      // ) {
      //   if (vm.session.RTMPMUX_detail.data.rtmpPushEndpoint.url) {
      //     vm.RTMPStreamURL =
      //       vm.session.RTMPMUX_detail.data.rtmpPushEndpoint.url;
      //   }
      //   if (vm.session.RTMPMUX_detail.data.rtmpPushEndpoint.streamKey) {
      //     vm.RTMPStreamKey =
      //       vm.session.RTMPMUX_detail.data.rtmpPushEndpoint.streamKey;
      //   }
      // }

      if (!(vm.RTMPStreamURL || vm.RTMPStreamKey)) {
        // alert("Invalid RTMPStreamURL or RTMPStreamKey");
        return;
      }
      var rtmpStreamURL = vm.RTMPStreamURL + "/" + vm.RTMPStreamKey;
      //var playbackURL = "https://stream.mux.com/dwAGZxSlCJU4TAEfvheM69LFP1B02bzAD29rVmAZsQp4.m3u8";
      //if (!vm.AgoraRTMPStarted) {
      await vm.client
        .startLiveStreaming(rtmpStreamURL, true)
        .then(() => {
          vm.AgoraRTMPInProcess = false;
          vm.AgoraRTMPStarted = true;
          //alert("start live streaming success");
          vm.$emit("StartRTMPStreaming", vm.sessionId);
        })
        .catch(function (error) {
          vm.AgoraRTMPInProcess = false;
          console.log("startLiveStreaming Error : " + error);
        });
      //}
      // else
      // {
      //   await vm.client.updateLiveTranscoding();
      // }
      // client.stopLiveStreaming(rtmpStreamURL).then(() => {
      //   console.log("stop live streaming success");
      // }).catch(function (error) {
      //   alert("Error : " + error);
      // });
    },
    async StopAgoraRTMP(tempHost) {
      vm.AgoraRTMPInProcess = true;
      var rtmpStreamURL = vm.RTMPStreamURL + "/" + vm.RTMPStreamKey;
      await vm.client
        .stopLiveStreaming(rtmpStreamURL)
        .then(() => {
          vm.AgoraRTMPInProcess = false;
          vm.AgoraRTMPStarted = false;
          console.log("stop live streaming success");
          if (tempHost) {
            vm.$emit("StopRTMPStreaming", vm.sessionId, tempHost);
          } else {
            vm.$emit("StopRTMPStreaming", vm.sessionId);
          }
        })
        .catch(function (error) {
          vm.AgoraRTMPInProcess = false;
          console.log("stopLiveStreaming Error : " + error);
        });
    },
    async ToggleAgoraRTMP() {
      if (!vm.AgoraRTMPInProcess) {
        if (vm.AgoraRTMPStarted) {
          await vm.StopAgoraRTMP();
        } else {
          await vm.StartAgoraRTMP();
        }
      }
    },
    async RestartAgoraRTMP() {
      //alert("RestartAgoraRTMP: ");
      //if (vm.AgoraRTMPStarted && vm.AgoraRTMPStartedBy == vm.uid) {
      //if (vm.AgoraRTMPStarted && (vm.userType == 1 || vm.isCurrentUserCoHost)) {
      // await vm.StopAgoraRTMP();
      // if (!vm.AgoraRTMPStarted) {
      //   setTimeout(async () => {
      //     await vm.StartAgoraRTMP();
      //   }, 1000);
      // }
      //await vm.client.updateLiveTranscoding();
      await vm.StartAgoraRTMP();
      //}
    },
    async JoinAgoraRTMP() {
      // const config = AgoraRTC.createChannelMediaRelayConfiguration();
      // debugger;
      // config.setSrcChannelInfo({ channelName: vm.channelName, token: vm.token, uid: 42001 });
      // debugger
      // config.addDestChannelInfo({ channelName: vm.channelName, token: vm.token, uid: parseInt(vm.uid) });
      // debugger;
      // //config.addDestChannelInfo({ channelName: vm.channelName, token: "xxx", uid: 23457 });
      //var rtmpStreamURL = vm.RTMPStreamURL + "/" + vm.RTMPStreamKey;
      // await vm.client
      //   .stopLiveStreaming(rtmpStreamURL)
      //   .then(() => {
      //     vm.AgoraRTMPStarted = false;
      //     console.log("stop live streaming success");
      //   })
      //   .catch(function (error) {
      //     alert("stopLiveStreaming Error : " + error);
      //   });
      // await vm.StartAgoraRTMP();
    },

    async handleCamera() {
      //console.log(e);
      //vm.localStream.setVideoProfile("720p_1");
      //vm.shareStream.setScreenProfile("720p_1");
      // if(e) {
      //   e.currentTarget.classList.toggle("off");
      // }
      // // else {
      // //   $("#btnCamera").toggleClass("off");
      // // }
      //var enable = !e.currentTarget.classList.value.includes("off");
      vm.isVideoOn = !vm.isVideoOn;
      await vm.handleVideoNG(vm.uid, vm.isVideoOn);
      //vm.handleVideo();
      //this.localStream.isVideoOn()
      //  ? this.localStream.disableVideo()
      //  : this.localStream.enableVideo();
    },

    handleVideo() {
      if ($(".videoControlBtn").hasClass("off")) {
        if (this.localStream.hasVideo() && this.localStream.isVideoOn()) {
          this.localStream.muteVideo();
        }
        vm.isVideoOn = false;
        let uid = this.localStream.getId();
        $("#profileImage_" + uid).removeClass("d-none");
      } else {
        if (this.localStream.hasVideo() && !this.localStream.isVideoOn()) {
          this.localStream.unmuteVideo();
        }
        vm.isVideoOn = true;
        vm.allowCam = true;
        let uid = this.localStream.getId();
        $("#profileImage_" + uid).addClass("d-none");
      }
    },

    async handleVideoNG(id, enable) {
      if (enable && !vm.remoteUsers[id].stream.videoTrack) {
        vm.remoteUsers[id].stream.videoTrack =
          await AgoraRTC.createCameraVideoTrack();
        var publishStream = {};
        if (
          vm.remoteUsers[id].stream.audioTrack &&
          vm.remoteUsers[id].stream.audioTrack.enabled
        ) {
          publishStream.audioTrack = vm.remoteUsers[id].stream.audioTrack;
        }
        if (
          vm.remoteUsers[id].stream.videoTrack &&
          vm.remoteUsers[id].stream.videoTrack.enabled
        ) {
          publishStream.videoTrack = vm.remoteUsers[id].stream.videoTrack;
        }
        await vm.client.publish(Object.values(publishStream));
      }
      if (vm.remoteUsers[id].stream.videoTrack) {
        if (enable) {
          if (id == vm.uid) {
            await vm.remoteUsers[id].stream.videoTrack.setEnabled(true);
          }
          $("#profileImage_" + id).addClass("d-none");
          vm.playVideo(id, vm.remoteUsers[id].stream);
        } else {
          if (id == vm.uid) {
            await vm.remoteUsers[id].stream.videoTrack.setEnabled(false);
          }
          $("#profileImage_" + id).removeClass("d-none");
        }
      }
    },

    async handleMic() {
      // e.currentTarget.classList.toggle("off");
      // var enable = !e.currentTarget.classList.value.includes("off");
      vm.isMicOn = !vm.isMicOn;
      await vm.handleAudioNG(vm.uid, vm.isMicOn);

      //vm.handleAudio();
      //this.localStream.isAudioOn()
      //  ? this.localStream.muteAudio()
      //  : this.localStream.unmuteAudio();
    },

    async handleAudioNG(id, enable) {
      if (enable && !vm.remoteUsers[id].stream.audioTrack) {
        vm.remoteUsers[id].stream.audioTrack =
          await AgoraRTC.createMicrophoneAudioTrack();
        var publishStream = [];
        if (
          vm.remoteUsers[id].stream.audioTrack &&
          vm.remoteUsers[id].stream.audioTrack.enabled
        ) {
          publishStream.push(vm.remoteUsers[id].stream.audioTrack);
        }
        if (
          vm.remoteUsers[id].stream.videoTrack &&
          vm.remoteUsers[id].stream.videoTrack.enabled
        ) {
          publishStream.push(vm.remoteUsers[id].stream.videoTrack);
        }
        await vm.client.publish(Object.values(publishStream));
      }

      if (vm.remoteUsers[id].stream.audioTrack) {
        if (enable) {
          await vm.remoteUsers[id].stream.audioTrack.setEnabled(true);
          if (id == vm.uid) {
            vm.isMicOn = true;
          }
          $("#audio-indicator-" + id)
            .removeClass("sound-muted")
            .removeClass("sound-talking")
            .addClass("sound-unmuted");
        } else {
          await vm.remoteUsers[id].stream.audioTrack.setEnabled(false);
          if (id == vm.uid) {
            vm.isMicOn = false;
          }
          $("#audio-indicator-" + id)
            .removeClass("sound-unmuted")
            .removeClass("sound-talking")
            .addClass("sound-muted");
        }
      }
    },

    handleRH(status) {
      vm.isRHOn = status;
      vm.$emit("applyRaiseHandAction", vm.uid, vm.isRHOn);
    },

    getUnmuteRequester(requesterId) {
      let result = "Host";
      //if (vm.sessionTypeId == 3) {
      //  if (vm.session) {
      //  }
      //}
      let attendees = vm.allAttendees.filter(function (item) {
        return item.AttendeeId == requesterId;
      });
      if (attendees.length > 0) {
        result = attendees[0].FirstName;
      }
      return result;
    },
    forceMuteSpeaker(requesterId, type, forceMute) {
      vm.unmuteRequester = vm.getUnmuteRequester(requesterId);
      vm.unmuteRequester = "[" + vm.unmuteRequester.trim() + "]";
      if (vm.userType < 4) {
        if (type == 0) {
          if (!$(".audioControlBtn").hasClass("off")) {
            if (forceMute) {
              //$(".audioControlBtn").addClass("off");
              //vm.handleAudio();
              vm.handleAudioNG(vm.uid, false);
              // var enable = !e.currentTarget.classList.value.includes("off");
              // await vm.handleAudioNG(vm.uid, enable);
            } else {
              alert("You have requested to Mute");
            }
          }
        } else {
          if ($(".audioControlBtn").hasClass("off")) {
            $("#popupUnmute").modal({ backdrop: "static" }, "show");
            //alert("You have requested to Unmute");
          }
        }
      }
    },
    forceSpotlight(uid) {
      //alert("forceSpotlight" + uid);
      if (uid > 0) {
        //let speakers = vm.allSpeakers.filter(function (item) {
        //  return item.AttendeeId == uid;
        //});
        let speakers = vm.streamList.filter(function (item) {
          return item.getId() == uid;
        });
        if (speakers.length > 0) {
          //alert("forceSpotlight");
          vm.pinVideoTile(uid);
          $(".ag-spotlight .ag-option-icon")
            .removeClass("ag-spotlight-on")
            .addClass("ag-spotlight-off");
          $("#ag-option-spotlight-" + uid + " .ag-option-icon")
            .removeClass("ag-spotlight-off")
            .addClass("ag-spotlight-on");

          $(".ag-option-pin").removeClass("disabled");
          $(".ag-option-pin  .ag-option-icon")
            .removeClass("ag-unpin-user")
            .addClass("ag-pin-user");

          $("#ag-option-pin-" + uid).addClass("disabled");
          $("#ag-option-pin-" + uid + " .ag-option-icon")
            .removeClass("ag-pin-user")
            .addClass("ag-unpin-user");
        }
      } else {
        vm.switchToTileView();
        $(".ag-spotlight .ag-option-icon")
          .removeClass("ag-spotlight-on")
          .addClass("ag-spotlight-off");
      }
      //vm.activeScreenUID = uid;
      //vm.displayMode = "pip";
      //vm.pinSelected = true;
    },
    onUnmute(option) {
      //alert(option);
      //alert($(".audioControlBtn").hasClass("off"));
      if (option == 1) {
        if ($(".audioControlBtn").hasClass("off")) {
          //$(".audioControlBtn").removeClass("off");
          //vm.handleAudio();
          vm.handleAudioNG(vm.uid, true);
        }
      }
      $("#popupUnmute").modal("hide");
    },
    handleAudio() {
      if ($(".audioControlBtn").hasClass("off")) {
        if (this.localStream.hasAudio() && this.localStream.isAudioOn()) {
          this.localStream.muteAudio();
        }
      } else {
        if (this.localStream.hasAudio() && !this.localStream.isAudioOn()) {
          this.localStream.unmuteAudio();
        }
      }

      let id = this.localStream.getId();
      if (this.localStream.hasAudio() && this.localStream.isAudioOn()) {
        vm.isMicOn = true;
        $("#audio-indicator-" + id)
          .removeClass("sound-muted")
          .removeClass("sound-talking")
          .addClass("sound-unmuted");
      } else {
        vm.isMicOn = false;
        $("#audio-indicator-" + id)
          .removeClass("sound-unmuted")
          .removeClass("sound-talking")
          .addClass("sound-muted");
      }
    },

    toggleHideMoreOption(e) {
      if (!vm.moreOptionVisibility) {
        vm.hidePopup();
      }
      vm.moreOptionVisibility = !vm.moreOptionVisibility;
      if (e) {
        e.stopPropagation();
      }
    },
    toggleHideSpeaker(e) {
      vm.hiddenSpeakerListVisibility = !vm.hiddenSpeakerListVisibility;
      if (e) {
        e.stopPropagation();
      }
    },
    unhideSpeaker(e) {
      //let id = $(e.currentTarget).attr("data-val");
      //alert(id);
      if (e) {
        e.stopPropagation();
      }
    },
    unhideAllSpeakers(e) {
      //vm.hiddenSpeakerList.forEach(function (item) {
      //  let id = item.AttendeeId;
      //  alert(id);
      //});
      vm.hiddenSpeakerListVisibility = !vm.hiddenSpeakerListVisibility;
      if (e) {
        this.stopPropagation();
      }
    },
    switchToPIPView() {
      bus.$emit("switchToPIPView");
    },
    switchToTileView(e) {
      if (e != undefined) {
        if (e.currentTarget.classList.contains("disabled")) {
          //alert("disabled");
          return;
        }
      }
      for (let key in vm.remoteUsers) {
        let user = vm.remoteUsers[key];
        $("#ag-user-" + user.uid)
          .detach()
          .appendTo("#ag-canvas");
      }
      if (vm.userCount > 1 && vm.displayMode === "pip") {
        $(".ag-user-pin a").removeClass("ag-unpin").addClass("ag-pin");
        $(".ag-option-pin").removeClass("disabled");
        $(".ag-option-pin .ag-unpin-user")
          .removeClass("ag-unpin-user")
          .addClass("ag-pin-user");
        $(".ag-option-pin .ag-option-label").html("Pin");

        $(".ag-spotlight .ag-option-icon")
          .removeClass("ag-spotlight-on")
          .addClass("ag-spotlight-off");

        vm.pinSelected = false;
        vm.displayMode = "tile";
        let leftPanel = document.querySelector("#ag-left-panel");
        let parentPanel = document.querySelector("#ag-parent-canvas");
        leftPanel.setAttribute("class", "d-none");

        if (vm.displayMode === "pip") {
          if (parentPanel) {
            if (vm.userCount > 1) {
              parentPanel.setAttribute("class", "ag-2col");
            } else {
              parentPanel.setAttribute("class", "");
            }
          }
          if (leftPanel) {
            leftPanel.setAttribute("class", "");
          }
        } else if (vm.displayMode === "tile") {
          if (parentPanel) {
            parentPanel.setAttribute("class", "");
          }
          if (leftPanel) {
            leftPanel.setAttribute("class", "d-none");
          }
        }
        vm.setLeftCanvasRowColumn();
        vm.setCanvasRowColumn();
        //vm.activeScreenUID = 0;
        ////let canvas = document.querySelector("#ag-canvas");
        //let parentPanel = document.querySelector("#ag-parent-canvas");
        //let leftPanel = document.querySelector("#ag-left-panel");
        //let rightPanel = document.querySelector("#ag-right-panel");
        //if (parentPanel) {
        //  parentPanel.setAttribute("class", "ag-2col");
        //}
        //if (leftPanel) {
        //  leftPanel.setAttribute("class", "");
        //}
        //if (rightPanel) {
        //  rightPanel.setAttribute("class", "d-none");
        //}
        //vm.setCanvasRowColumn();
        //vm.setLeftCanvasRowColumn();
        //vm.setRightCanvasRowColumn();
      }
    },
    switchToTileView1(e) {
      if (e != undefined) {
        if (e.currentTarget.classList.contains("disabled")) {
          //alert("disabled");
          return;
        }
      }
      if (vm.streamList.length > 1 && vm.displayMode === "pip") {
        $(".ag-user-pin a").removeClass("ag-unpin").addClass("ag-pin");
        $(".ag-option-pin").removeClass("disabled");
        $(".ag-option-pin .ag-unpin-user")
          .removeClass("ag-unpin-user")
          .addClass("ag-pin-user");
        $(".ag-option-pin .ag-option-label").html("Pin");

        $(".ag-spotlight .ag-option-icon")
          .removeClass("ag-spotlight-on")
          .addClass("ag-spotlight-off");

        vm.pinSelected = false;
        vm.displayMode = "tile";
        //vm.activeScreenUID = 0;
        ////let canvas = document.querySelector("#ag-canvas");
        //let parentPanel = document.querySelector("#ag-parent-canvas");
        //let leftPanel = document.querySelector("#ag-left-panel");
        //let rightPanel = document.querySelector("#ag-right-panel");
        //if (parentPanel) {
        //  parentPanel.setAttribute("class", "ag-2col");
        //}
        //if (leftPanel) {
        //  leftPanel.setAttribute("class", "");
        //}
        //if (rightPanel) {
        //  rightPanel.setAttribute("class", "d-none");
        //}
        //vm.setCanvasRowColumn();
        //vm.setLeftCanvasRowColumn();
        //vm.setRightCanvasRowColumn();
      }
    },

    pinVideoTile(elId) {
      //alert(elId);
      //if (vm.streamList.length > 1 && vm.activeScreenUID != elId) {
      //if (vm.streamList.length > 1) {
      if (vm.userCount > 1) {
        // if(vm.uid == 221000){
        // alert("pinVideoTile: " + vm.activeScreenUID)
        // debugger;
        // }
        vm.activeScreenUID = elId;
        vm.displayMode = "tile";
        vm.displayMode = "pip";
      }
      //
      //var hasLeftPanel = false;
      for (let key in vm.remoteUsers) {
        let user = vm.remoteUsers[key];
        $("#ag-user-" + user.uid)
          .detach()
          .appendTo("#ag-canvas");
      }
      if (vm.displayMode == "pip") {
        for (let key in vm.remoteUsers) {
          let user = vm.remoteUsers[key];
          if (user && user.uid != vm.activeScreenUID) {
            //hasLeftPanel  = true;
            $("#ag-user-" + user.uid)
              .detach()
              .appendTo("#ag-left-panel");
          }
        }
      }
      vm.setLeftCanvasRowColumn();
      vm.setCanvasRowColumn();

      //let canvas = document.querySelector("#ag-canvas");
      let parentPanel = document.querySelector("#ag-parent-canvas");
      let leftPanel = document.querySelector("#ag-left-panel");
      //let rightPanel = document.querySelector("#ag-right-panel");

      if (vm.displayMode === "pip") {
        if (parentPanel) {
          if (vm.userCount > 1) {
            parentPanel.setAttribute("class", "ag-2col");
          } else {
            parentPanel.setAttribute("class", "");
          }
        }
        if (leftPanel) {
          leftPanel.setAttribute("class", "");
        }
      } else if (vm.displayMode === "tile") {
        if (parentPanel) {
          parentPanel.setAttribute("class", "");
        }
        if (leftPanel) {
          leftPanel.setAttribute("class", "d-none");
        }
      }
    },

    pinVideoTileStatusUpdate(uid, isPinned) {
      if (uid > 0) {
        if (isPinned) {
          // let speakers = vm.streamList.filter(function (item) {
          //   return item.getId() == uid;
          // });
          // if (speakers.length > 0) {
          $(".ag-spotlight .ag-option-icon")
            .removeClass("ag-spotlight-on")
            .addClass("ag-spotlight-off");

          $(".ag-option-pin").removeClass("disabled");
          $(".ag-option-pin  .ag-option-icon")
            .removeClass("ag-unpin-user")
            .addClass("ag-pin-user");

          $("#ag-option-pin-" + uid).addClass("disabled");
          $("#ag-option-pin-" + uid + " .ag-option-icon")
            .removeClass("ag-pin-user")
            .addClass("ag-unpin-user");
          // }
        }
      } else {
        vm.switchToTileView();
      }
    },
    hideRemote(e) {
      console.log(e);
      //alert("hideRemote");
      if (this.readyShareState) {
        this.stopShareScreenNG();
      } else {
        vm.startShareScreenNG();
      }
      //if (
      //  e.currentTarget.classList.contains("disabled") ||
      //  this.streamList.length <= 1
      //) {
      //  return;
      //}
      //let list;
      //let id = this.streamList[this.streamList.length - 1].getId();
      //list = Array.from(
      //  document.querySelectorAll(`.ag-item:not(#ag-item-${id})`)
      //);
      //list.map((item) => {
      //  if (item.style.display !== "none") {
      //    item.style.display = "none";
      //  } else {
      //    item.style.display = "block";
      //  }
      //});
    },

    onConfirmEndCall() {
      $("#popupLeaveConfirm").modal("show");
    },

    onCanceEndCall() {
      $("#popupLeaveConfirm").modal("hide");
    },
    ReConnectCall() {
      //vm.onEndCall();
      // alert("ReConnectCall")
      // alert(vm.inProcess)
      // alert(vm.readyState)
      //alert(vm.readyState);
      if (!vm.inProcess) {
        vm.readyState = false;
        vm.StartCall(
          vm.tempValues.clientId,
          vm.tempValues.eventId,
          vm.tempValues.channelName,
          vm.tempValues.sessionTypeId,
          vm.tempValues.session,
          vm.tempValues.roundTable,
          vm.tempValues.o2oMeeting,
          vm.tempValues.attendeeType,
          vm.tempValues.callSettings,
          vm.tempValues.exMeetingId,
          vm.tempValues.meetingHostId,
          1
        );
      }
    },
    ReStartCall() {
      //alert("ReStartCall");
      $("#popupLeaveConfirm").modal("hide");
      //if (!vm.inProcess && !vm.readyState) {
      vm.inProcess = true;
      //$(".exitBtn").removeClass("start-call-btn");
      vm.StartCall(
        vm.tempValues.clientId,
        vm.tempValues.eventId,
        vm.tempValues.channelName,
        vm.tempValues.sessionTypeId,
        vm.tempValues.session,
        vm.tempValues.roundTable,
        vm.tempValues.o2oMeeting,
        vm.tempValues.attendeeType,
        vm.tempValues.callSettings,
        vm.tempValues.exMeetingId,
        vm.tempValues.meetingHostId,
        1
      );
      //}
    },
    onEndSession() {
      $("#popupLeaveConfirm").modal("hide");
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      if (obj) {
        //alert("Not Implemented");
        if (vm.sessionTypeId == vm.LivePanelTypeID && vm.sessionId != "") {
          if ($("#divLoading")) {
            $("#divLoading").show();
          }
          db.collection(vm.event_collectionName)
            .doc("SessionList")
            .collection("Sessions")
            .doc(vm.sessionId)
            .get()
            .then((doc) => {
              if (doc.exists) {
                vm.BroadCastStopRecording();
                setTimeout(() => {
                  ////////////////////
                  let headers = {
                    "content-type": "application/json",
                    Authorization: "Bearer " + vm.getSessionToken(),
                  };
                  let requestData = {
                    key: {
                      instanceId: "OA_UAT",
                      clientId: vm.clientId,
                      eventId: vm.eventId,
                    },
                    data: {
                      Sessions: { SessionId: [vm.sessionId] },
                      Tables: { TableId: [], TopicId: [] },
                    },
                  };
                  axios
                    .post(APIs.EndCall, requestData, {
                      headers: headers,
                    })
                    .then((responseData) => {
                      //alert("Ended By Host");
                      console.log(responseData);
                    })
                    .catch(function (error) {
                      console.log("Error : " + error);
                    });

                  //let headers = {
                  //  "content-type": "application/json",
                  //  Authorization: "Bearer " + vm.getSessionToken(),
                  //};
                  //let requestData = {
                  //  collection: "SessionList/Sessions",
                  //  instance: obj.eventcollectionname,
                  //  data: {
                  //    //EndedByHost: true,
                  //    EndRequest: new Date().getTime(),
                  //    EndedBy: vm.uid,
                  //    id: vm.sessionId,
                  //  },
                  //};
                  //axios
                  //  .put(APIs.WriteObject, requestData, {
                  //    headers: headers,
                  //  })
                  //  .then((responseData) => {
                  //    //alert("Ended By Host");
                  //    console.log(responseData);
                  //  })
                  //  .catch(function (error) {
                  //    console.log("Error : " + error);
                  //  });
                }, 1000);
              }
            });
        } else if (
          vm.sessionTypeId == vm.RoundTableTypeID &&
          vm.roundTableId != ""
        ) {
          if ($("#divLoading")) {
            $("#divLoading").show();
          }
          db.collection(vm.event_collectionName)
            .doc("RoundTableList")
            .collection("RoundTables")
            .doc(vm.roundTableId)
            .get()
            .then((doc) => {
              if (doc.exists) {
                vm.BroadCastStopRecording();
                setTimeout(() => {
                  let headers = {
                    "content-type": "application/json",
                    Authorization: "Bearer " + vm.getSessionToken(),
                  };
                  let requestData = {
                    key: {
                      instanceId: "OA_UAT",
                      clientId: vm.clientId,
                      eventId: vm.eventId,
                    },
                    data: {
                      Sessions: { SessionId: [] },
                      Tables: { TableId: [vm.roundTableId], TopicId: [] },
                    },
                  };
                  axios
                    .post(APIs.EndCall, requestData, {
                      headers: headers,
                    })
                    .then((responseData) => {
                      //alert("Ended By Host");
                      console.log(responseData);
                    })
                    .catch(function (error) {
                      console.log("Error : " + error);
                    });
                  //let headers = {
                  //  "content-type": "application/json",
                  //  Authorization: "Bearer " + vm.getSessionToken(),
                  //};
                  //let requestData = {
                  //  collection: "RoundTableList/RoundTables",
                  //  instance: obj.eventcollectionname,
                  //  data: {
                  //    //EndedByHost: true,
                  //    EndRequest: new Date().getTime(),
                  //    EndedBy: vm.uid,
                  //    id: vm.roundTableId,
                  //  },
                  //};
                  //axios
                  //  .put(APIs.WriteObject, requestData, {
                  //    headers: headers,
                  //  })
                  //  .then((responseData) => {
                  //    console.log(responseData);
                  //  });
                }, 1000);
              }
            });
        }
      }
    },

    onCallEndedByHost() {
      vm.playerWaitText = "This meeting has been ended by host";
    },
    async onEndCall(e, internalEnd, kickOut) {
      if (vm.userCount > 1 && vm.displayMode == "pip") {
        vm.switchToTileView();
      }
      $("#popupLeaveConfirm").modal("hide");
      vm.displayInviteToStage = false;
      // alert("onEndCall");
      $("#enableModalCenter").modal("hide");
      vm.showMicCamPermission = false;
      //alert("vm.entryType: "+vm.entryType);
      if (vm.entryType == 1) {
        vm.InviteAttendeeToStage(vm.uid);
        //return;
      } else if (vm.entryType == 2 && vm.isRHOn) {
        vm.InviteAttendeeToStage(vm.uid);
        //return;
      }
      if (!vm.inProcess) {
        if (e) {
          if (e.currentTarget.classList.contains("disabled")) {
            //alert("disabled");
            return;
          } else {
            vm.isRHOn = false;
          }
        }
        //if ($(".exitBtn").hasClass("start-call-btn")) {
        if (!vm.readyState) {
          if (e) {
            $(".exitBtn").removeClass("start-call-btn");
            //vm.StartCall(
            //  vm.clientId,
            //  vm.eventId,
            //  vm.channelName,
            //  vm.sessionTypeId,
            //  vm.session,
            //  vm.roundTable,
            //  vm.o2oMeeting,
            //  vm.attendeeType
            //);
            if (vm.tempValues) {
              //alert("tempValues");
              vm.StartCall(
                vm.tempValues.clientId,
                vm.tempValues.eventId,
                vm.tempValues.channelName,
                vm.tempValues.sessionTypeId,
                vm.tempValues.session,
                vm.tempValues.roundTable,
                vm.tempValues.o2oMeeting,
                vm.tempValues.attendeeType,
                vm.tempValues.callSettings,
                vm.tempValues.exMeetingId,
                vm.tempValues.meetingHostId
              );
            }
          }
        } else {
          if ((!vm.IsLive && !vm.IsGoLive) || vm.IsGoLive) {
            vm.playerWaitText = "You are in back stage, Please click on Join.";
          } else {
            vm.playerWaitText = "Session is live, Please click on Join.";
          }
          $(".exitBtn").addClass("start-call-btn");
          if (!vm.roomId && !vm.callSwitchingInProcess) {
            router.push(vm.stageUrl);
          }
          if (e) {
            //alert("DIRECT");
            await vm.EndCall(true);
          } else {
            //alert("INDIRECT");
            await vm.EndCall(false, internalEnd, kickOut);
          }
        }
      }
    },

    async EndCall(forceEnd, internalEnd, kickOut) {
      vm.inProcess = true;
      // alert("EndCall readyState: " + vm.readyState);
      if (!internalEnd && !kickOut) {
        vm.$emit("livePanelOnEnd", vm.roundTableId, forceEnd);
      } else if (kickOut) {
        vm.$emit("livePanelOnEnd", vm.roundTableId, kickOut);
      }
      if (vm.readyState) {
        //$(".single-call-handle-butn").hide();
        //var waitTime = 100;
        //if(vm.uid == vm.shareUid && vm.remoteUsers[vm.shareUid]){
        //waitTime = 5000;
        await vm.stopShareScreenNG(true);
        //}
        //setTimeout(async () => {
        try {
          for (var key in vm.remoteUsers) {
            var user = vm.remoteUsers[key];
            if (user && user.stream) {
              if (user.uid == vm.uid || user.uid == vm.shareUid) {
                if (user.stream.videoTrack) {
                  await user.stream.videoTrack.setEnabled(false);
                }
                if (user.stream.audioTrack) {
                  await user.stream.audioTrack.setEnabled(false);
                }
              }
              if (user.stream.audioTrack) {
                user.stream.audioTrack.stop();
                user.stream.audioTrack.close();
              }
              if (user.stream.videoTrack) {
                user.stream.videoTrack.stop();
                user.stream.videoTrack.close();
              }
            }
            let element = document.querySelector("#ag-user-" + user.uid);
            if (element) {
              element.parentNode.removeChild(element);
            }
            delete vm.remoteUsers[key];
          }
          vm.activeScreenUID = 0;
          //vm.shareUid = 1000000000;
          vm.displayMode = "tile";
          let parentPanel = document.querySelector("#ag-parent-canvas");
          if (parentPanel) {
            parentPanel.setAttribute("class", "");
          }
          if (vm.client) {
            //alert("client.leave")
            await vm.client.leave();
          }
          // if (vm.client && vm.EnableAgoraProxy) {
          //   vm.client.stopProxyServer();
          // }
          if (vm.processor) {
            vm.processor = null;
          }
        } catch (ex) {
          //alert(ex);
          await vm.client.leave();
          vm.remoteUsers = {};
          vm.activeScreenUID = 0;
          vm.displayMode = "tile";
          let parentPanel = document.querySelector("#ag-parent-canvas");
          if (parentPanel) {
            parentPanel.setAttribute("class", "");
          }
          $("#ag-canvas").html("");
          $("#ag-left-panel").html("");
        } finally {
          if (vm.processor) {
            vm.processor = null;
          }
          if (ProfileRepairTimer) {
            clearInterval(ProfileRepairTimer);
          }
          vm.outgoungBandwidth = vm.minOutgoungBandwidth;
          vm.incomingBandwidth = vm.minIncomingBandwidth;
          vm.readyState = false;
          vm.client = null;
          vm.localStream = null;
          vm.recordingStarted = false;
          vm.streamList.map((item) => {
            let id = item.getId();
            vm.removeStream(id);
          });
          vm.changePlayerStatus(0);
          //vm.$router.push("/sessions");
        }
        //}, waitTime);
      } else {
        vm.inProcess = false;
      }
    },
    leaveBreakoutRoom() {
      this.$emit("leaveBreakoutRoom");
    },
    startMeeting(meetingId) {
      if (meetingId) {
        vm.$emit("startMeeting", meetingId);
      }
    },
    async startShareScreenNG() {
      //alert();
      if (
        vm.shareClient == {} ||
        vm.shareClient == undefined ||
        vm.shareClient == null
      ) {
        vm.shareClient = AgoraRTC.createClient({
          mode: vm.transcode,
          codec: "vp8",
        });
        //vm.shareClient = AgoraRTC.createClient({ mode: vm.transcode, codec: "vp8" });
      }
      if (vm.shareClient && vm.EnableAgoraProxy) {
        //vm.shareClient.startProxyServer(3);
      }

      var screenStream = {};
      //screenShare.videoTrack = await AgoraRTC.createScreenVideoTrack({}, "enable");
      var screenShare;
      try {
        //screenShare = await AgoraRTC.createScreenVideoTrack({}, "auto");
        //ScreenSourceType: "screen" | "window" | "application"
        screenShare = await AgoraRTC.createScreenVideoTrack(
          { screenSourceType: "window" },
          "auto"
        );
      } catch (e) {
        console.log(e);
      }
      //alert(screenShare);
      if (!screenShare) {
        vm.stopShareScreenNG();
        return;
      }
      vm.shareClient.setClientRole(
        "host",
        function () {
          //console.log('Client role set to audience');
        },
        function (e) {
          console.log("setClientRole failed", e);
        }
      );
      await vm.shareClient.join(
        vm.liveVideoApiDetails.AppID,
        vm.channelName,
        vm.token || null,
        vm.shareUid || null
      );
      vm.readyShareState = true;

      //vm.shareClient.on("track-ended", vm.stopShareScreenNG);
      // vm.shareClient.on("user-joined", vm.handleShareUserJoined);
      // vm.shareClient.on("user-left", vm.handleShareUserLeft);
      // vm.shareClient.on("user-published", vm.handleShareUserPublished);
      // vm.shareClient.on("user-unpublished", vm.handleShareUserUnpublished);
      // alert("screenShare: " + screenShare.length);
      if (screenShare.length == undefined) {
        screenStream.videoTrack = screenShare;
      } else if (screenShare.length == 2) {
        if (screenShare[0].trackMediaType == "video") {
          screenStream.videoTrack = screenShare[0];
          screenStream.audioTrack = screenShare[1];
        } else {
          screenStream.videoTrack = screenShare[1];
          screenStream.audioTrack = screenShare[0];
        }
      }
      if (screenStream.videoTrack) {
        //alert("track-ended");
        screenStream.videoTrack.on("track-ended", vm.stopShareScreenNG);
        //screenShare.on("track-ended", vm.stopShareScreenNG);
      }
      //console.log(screenShare.videoTrack);

      // join a channel and create local tracks, we can use Promise.all to run them concurrently
      // [vm.shareUid, vm.shareTracks.audioTrack, vm.shareTracks.videoTrack] =
      //   await Promise.all([
      //     // join the channel
      //     vm.client.join(
      //       vm.liveVideoApiDetails.AppID,
      //       vm.channelName,
      //       vm.token || null,
      //       vm.shareUid || null
      //     ),
      //     // ** create local tracks, using microphone and screen
      //     AgoraRTC.createMicrophoneAudioTrack(),
      //     AgoraRTC.createScreenVideoTrack(),
      //   ]);

      // play local video track
      await vm.addUser(vm.shareUid, screenStream);
      //await vm.addUser(vm.shareUid, screenShare);
      // debugger;
      await vm.bindUser(vm.shareUid);
      // debugger;
      await vm.shareClient.publish(
        Object.values(vm.remoteUsers[vm.shareUid].stream)
      );
      vm.playVideo(vm.shareUid, vm.remoteUsers[vm.shareUid].stream);
      // localTracks.videoTrack.play("local-player");
      // $("#local-player-name").text(`localVideo(${vm.shareUid})`);

      setTimeout(() => {
        vm.updateRecordingLayout(true);
      }, 1000);

      // publish local tracks to channel
      //await vm.client.publish(Object.values(vm.shareUid));
      vm.pinVideoTile(vm.shareUid);
      if (vm.AgoraRTMPStarted && vm.AgoraRTMPStartedBy == vm.uid) {
        vm.RestartAgoraRTMP();
      }
    },
    handleShareUserJoined() {
      alert("handleShareUserJoined");
    },
    handleShareUserLeft() {
      alert("handleShareUserLeft");
    },
    handleShareUserPublished() {
      alert("handleShareUserPublished");
    },
    handleShareUserUnpublished() {
      alert("handleShareUserUnpublished");
    },
    async stopShareScreenNG(skipLayoutUpdate) {
      //alert("stopShareScreenNG")
      if (!skipLayoutUpdate) {
        vm.switchToTileView();
      }
      try {
        if (vm.remoteUsers[vm.shareUid] && vm.remoteUsers[vm.shareUid].stream) {
          if (
            !vm.remoteUsers[vm.shareUid].stream.videoTrack &&
            !vm.remoteUsers[vm.shareUid].stream.audioTrack
          ) {
            await vm.remoteUsers[vm.shareUid].stream.setEnabled(false);
          } else {
            if (vm.remoteUsers[vm.shareUid].stream.videoTrack) {
              await vm.remoteUsers[vm.shareUid].stream.videoTrack.setEnabled(
                false
              );
            }
            if (vm.remoteUsers[vm.shareUid].stream.audioTrack) {
              await vm.remoteUsers[vm.shareUid].stream.audioTrack.setEnabled(
                false
              );
            }
          }
          if (vm.remoteUsers[vm.shareUid].stream.audioTrack) {
            vm.remoteUsers[vm.shareUid].stream.audioTrack.stop();
            vm.remoteUsers[vm.shareUid].stream.audioTrack.close();
          }
          if (vm.remoteUsers[vm.shareUid].stream.videoTrack) {
            vm.remoteUsers[vm.shareUid].stream.videoTrack.stop();
            vm.remoteUsers[vm.shareUid].stream.videoTrack.close();
          }
          delete vm.remoteUsers[vm.shareUid];
        }
        //if (vm.shareClient && vm.EnableAgoraProxy) {
        //  vm.shareClient.stopProxyServer();
        //}
        vm.shareClient &&
          vm.shareClient.leave(
            () => {
              console.log("shareClient succeed to leave.");
            },
            () => {
              console.log("shareClient failed to leave.");
            }
          );
      } finally {
        vm.readyShareState = false;
        vm.shareClient = null;
        vm.shareStream = null;
        // redirect to index
        //this.$router.push("/");
        if (!skipLayoutUpdate && vm.shareScreenCount() == 0) {
          //alert("stop rec layout:" + vm.shareScreenCount());
          vm.updateRecordingLayout(false);
        }
      }
      //alert("stopShareScreenNG");
      if (vm.AgoraRTMPStarted && vm.AgoraRTMPStartedBy == vm.uid) {
        vm.RestartAgoraRTMP();
      }
    },

    updateRecordingLayout(hasScreenShare) {
      if (vm.recordingStarted) {
        let headers = {
          "Content-Type": "application/json",
          Authorization: "Bearer " + vm.getSessionToken(),
        };
        var requestData;
        if (hasScreenShare) {
          //alert("start layout");
          requestData = {
            channel: vm.channelName.replace("_gr", ""),
            resourceId: vm.RecResourceId,
            sId: vm.RecSid,
            primeUserId: vm.shareUid,
          };
        } else {
          //alert("stop layout");
          requestData = {
            channel: vm.channelName.replace("_gr", ""),
            resourceId: vm.RecResourceId,
            sId: vm.RecSid,
          };
        }

        axios
          .post(vm.PlayerAPIConfig.UpdateRecordingLayout, requestData, {
            headers: headers,
          })
          .then((responseData) => {
            let data = responseData.data;
            console.log(data);
          })
          .catch(function (e) {
            console.log(e);
          });
      }
    },

    readAllAttendees() {
      this.allAttendees = [];
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      if (obj) {
        db.collection(vm.event_collectionName)
          .doc("AttendeeList")
          .collection("Attendees")
          .where("IsPublished", "==", true)
          .get()
          .then((querySnapshot) => {
            querySnapshot.forEach((doc) => {
              let objA = {};
              objA.AttendeeId = doc.data().AttendeeId;
              objA.Name = doc.data().Name;
              objA.FirstName = doc.data().FirstName;
              objA.LastName = doc.data().LastName;
              objA.Email = doc.data().Email;
              objA.ProfilePictureURL = vm.getCDNUrl(
                doc.data().ProfilePictureURL
              );
              objA.Designation = doc.data().Designation;
              objA.Company = doc.data().Company;
              vm.allAttendees.push(objA);
            });
            //vm.addAllUserProfile();
          });
      }
    },
    onRequestAllSpeakersToMute() {
      if (!$(".ag-option-mute-all").hasClass("disabled")) {
        //$(".more-action-notification").html("Request sent");
        //$(".more-action-notification").removeClass("hidden");
        //setTimeout(() => {
        //  $(".more-action-notification").addClass("hidden");
        //}, 5000);
        $(".ag-option-mute-all").addClass("disabled");
        vm.requestAllSpeakersToMute(0, true);
      }
    },
    requestAllSpeakersToMute(type, forceMute) {
      vm.$emit("requestAllSpeakersToMute", {
        type: type,
        forceMute: forceMute,
      });
    },
    requestAllSpeakersToMuteResult(success) {
      if (success) {
        alert("Success");
      }
    },
    requestSpeakerToMute(uid, type, forceMute) {
      vm.$emit("requestSpeakerToMute", {
        uid: uid,
        type: type,
        forceMute: forceMute,
      });
    },
    //requestSpeakerToUnmute(uid) {
    //  vm.$emit("requestSpeakerToUnmute", { uid: uid, type: 1 });
    //},
    requestSpotlight(uid, type) {
      //vm.activeScreenUID = uid;
      //vm.displayMode = "pip";
      //vm.pinSelected = true;
      vm.$emit("requestSpotlight", {
        uid: uid,
        type: type,
      });
    },
    addAllUserProfile() {
      vm.streamList.map(() => {
        //let id = item.getId();
        //vm.addUserProfile(id);
      });
    },
    openSpeakerPanel(uid) {
      vm.$emit("openSpeakerPanel", uid);
    },
    openAttendeePanel(e) {
      vm.$emit("openAttendeePanel");
      e.stopPropagation();
    },
    addUserProfileNG(uid, waitingProfile, ring) {
      let isVideoOn = false;
      let isUserInvited = false;
      // if (uid == vm.uid) {
      //   //isVideoOn = vm.remoteUsers[uid].isVideoOn();
      // } else {
      //   if (vm.remoteUsers[uid] && vm.remoteUsers[uid].stream && vm.remoteUsers[uid].stream.videoTrack) {
      //     isVideoOn = vm.remoteUsers[uid].stream.videoTrack.hasVideo;
      //   }
      // }
      if (
        vm.remoteUsers[uid] &&
        vm.remoteUsers[uid].stream &&
        vm.remoteUsers[uid].stream.videoTrack
      ) {
        isVideoOn = vm.remoteUsers[uid].stream.videoTrack.hasVideo;
      }

      let name = "";
      let fName = "";
      let nameInitial = "";
      let profileImage = "";
      let title = "";
      let company = "";
      let userFound = false;
      let UserTypeName = ""; //"ATTENDEE";
      let user = null;
      //let canvas = document.querySelector("#ag-canvas");
      //let leftPanel = document.querySelector("#ag-left-panel");
      //let rightPanel = document.querySelector("#ag-right-panel");
      let hosts = [];
      let coHosts = [];
      if (vm.session && vm.session.MappedHosts && vm.sessionTypeId != 4) {
        hosts = vm.session.MappedHosts.filter(function (item) {
          return item.AttendeeId == uid;
        });
      } else {
        hosts = vm.allHosts.filter(function (item) {
          return item.AttendeeId == uid;
        });
      }
      if (vm.session && vm.session.MappedCoHosts) {
        coHosts = vm.session.MappedCoHosts.filter(function (item) {
          return item.AttendeeId == uid;
        });
      } else {
        coHosts = vm.allCoHosts.filter(function (item) {
          return item.AttendeeId == uid;
        });
      }

      //let hosts = [];
      //if (vm.allHosts.length > 0) {
      //  if (vm.allHosts[0].AttendeeId == uid) {
      //    hosts.push(vm.allHosts[0]);
      //  }
      //}
      if (hosts.length > 0) {
        if (
          location.host == "campus.edulife.sg" ||
          vm.LocalhostDomain() == "campus.edulife.sg"
        ) {
          UserTypeName = "TEACHER";
        } else {
          UserTypeName = "HOST";
        }
        userFound = true;
        user = hosts[0];
      } else if (coHosts.length > 0) {
        UserTypeName = "CO-HOST";
        userFound = true;
        user = coHosts[0];
      } else {
        let speakers = vm.allSpeakers.filter(function (item) {
          return item.AttendeeId == uid;
        });
        if (speakers.length > 0) {
          user = speakers[0];
          if (vm.sessionTypeId == vm.LivePanelTypeID) {
            if (
              location.host == "campus.edulife.sg" ||
              vm.LocalhostDomain() == "campus.edulife.sg"
            ) {
              UserTypeName = "STUDENT";
            } else {
              UserTypeName = "SPEAKER";
            }
            userFound = true;
          } else if (vm.sessionTypeId == vm.RoundTableTypeID) {
            if (
              location.host == "campus.edulife.sg" ||
              vm.LocalhostDomain() == "campus.edulife.sg"
            ) {
              UserTypeName = "STUDENT";
            } else {
              UserTypeName = "GUEST";
            }
            userFound = true;
          }
        } else {
          //if (vm.sessionTypeId == vm.O2OTypeID) {
          //  if (vm.attendeeType == 1) {
          //    UserTypeName = "HOST";
          //    userFound = true;
          //  } else {
          //    UserTypeName = "GUEST";
          //    userFound = true;
          //  }
          //} else if (vm.sessionTypeId == vm.E2OTypeID) {
          //  UserTypeName = "GUEST";
          //  userFound = true;
          //}
        }
      }
      if (user == null) {
        //alert(vm.sessionTypeId);
        //alert(uid);
        let attendees = vm.allAttendees.filter(function (item) {
          return item.AttendeeId == uid;
        });
        if (attendees.length > 0) {
          user = attendees[0];
          userFound = true;
        }
        if (vm.sessionTypeId == vm.LivePanelTypeID) {
          if (user) {
            if (
              location.host == "campus.edulife.sg" ||
              vm.LocalhostDomain() == "campus.edulife.sg"
            ) {
              UserTypeName = "STUDENT";
            } else {
              UserTypeName = "GUEST";
            }
            isUserInvited = true;
          }
        } else if (vm.sessionTypeId == vm.RoundTableTypeID) {
          if (user) {
            if (
              location.host == "campus.edulife.sg" ||
              vm.LocalhostDomain() == "campus.edulife.sg"
            ) {
              UserTypeName = "STUDENT";
            } else {
              UserTypeName = "GUEST";
            }
          }
        } else if (vm.sessionTypeId == vm.O2OTypeID) {
          if (user) {
            UserTypeName = "";
          }
        } else if (vm.sessionTypeId == vm.E2OTypeID) {
          if (user) {
            UserTypeName = "VISITOR";
            if (vm.meetingHostId && vm.meetingHostId == uid) {
              UserTypeName = "BOOTH REP.";
            }
          }
        } else if (vm.sessionTypeId == 100) {
          if (user) {
            UserTypeName = "";
            if (vm.meetingHostId && vm.meetingHostId == uid) {
              UserTypeName = "";
            }
          }
        }
      }
      //alert("share");
      //if (UserTypeName == "") {
      //  //if (UserTypeName == "" && uid.toString().indexOf("share") == -1) {
      //  if (vm.sessionTypeId == vm.LivePanelTypeID) {
      //    UserTypeName = "SPEAKER";
      //    userFound = true;
      //  } else if (vm.sessionTypeId == vm.RoundTableTypeID) {
      //    UserTypeName = "GUEST";
      //    userFound = true;
      //  }
      //}
      //alert(uid);
      if (UserTypeName == "" && uid < vm.shareIdStartsAfter) {
        //if (UserTypeName == "" && uid.toString().indexOf("share") == -1) {
        if (vm.sessionTypeId == vm.LivePanelTypeID) {
          if (
            location.host == "campus.edulife.sg" ||
            vm.LocalhostDomain() == "campus.edulife.sg"
          ) {
            UserTypeName = "STUDENT";
          } else {
            UserTypeName = "SPEAKER";
          }
          userFound = true;
        } else if (vm.sessionTypeId == vm.RoundTableTypeID) {
          if (
            location.host == "campus.edulife.sg" ||
            vm.LocalhostDomain() == "campus.edulife.sg"
          ) {
            UserTypeName = "STUDENT";
          } else {
            UserTypeName = "GUEST";
          }
          userFound = true;
        }
      }
      if (user != null) {
        name = user.Name == undefined ? "" : user.Name;
        fName = user.FirstName == undefined ? "" : user.FirstName;
        nameInitial = common.getInitials(name);
        profileImage =
          user.ProfilePictureURL == undefined ? "" : user.ProfilePictureURL;
        title = user.Designation == undefined ? "" : user.Designation;
        company = user.Company == undefined ? "" : user.Company;
      }
      //if (
      //  canvas.childNodes.length +
      //    leftPanel.childNodes.length +
      //    rightPanel.childNodes.length ==
      //  1
      //) {
      //  UserTypeName = "HOST";
      //} else {
      //  UserTypeName = "SPEAKER";
      //}
      //if (obj.user[0].id == uid) {
      //  name = obj.user[0].name;
      //  fName = obj.user[0].fname;
      //  profileImage = obj.user[0].profilepic;
      //  title = obj.user[0].title;
      //  company = obj.user[0].company;
      //  userFound = true;
      //} else {
      //  var attendees = vm.allAttendees.filter(function (value) {
      //    return value.AttendeeId == uid;
      //  });
      //  if (attendees.length > 0) {
      //    name = attendees[0].name;
      //    fName = attendees[0].fname;
      //    profileImage = attendees[0].profilepic;
      //    title = attendees[0].title;
      //    company = attendees[0].company;
      //    userFound = true;
      //  }
      //}

      if (userFound) {
        let domPlayer = document.querySelector("#ag-user-" + uid);

        //domFrame.addEventListener("click", function () {
        //  vm.replay(uid);
        //});
        let domPlayer1 = document.querySelector("#player_" + uid);
        if (domPlayer) {
          domPlayer.setAttribute("firstName", fName);
          domPlayer.setAttribute("asrank", "0");
          if (domPlayer1) {
            domPlayer1.setAttribute("class", "ag-player player-share");
          }
          //HOST OR SPEAKER
          let domUserType = document.querySelector("#utype-" + uid);
          if (!domUserType) {
            if (UserTypeName != "") {
              domUserType = document.createElement("div");
              domUserType.setAttribute("id", "utype-" + uid);
              domUserType.setAttribute("class", "ag-user-type");

              let elp = document.createElement("a");
              elp.setAttribute("class", "ag-h4");
              let nodep = document.createTextNode(UserTypeName);
              elp.appendChild(nodep);
              domUserType.appendChild(elp);

              domPlayer.appendChild(domUserType);
            }
          }

          let optionMenu = document.querySelector("#ag-option-menu-" + uid);
          if (!optionMenu) {
            optionMenu = document.createElement("div");
            optionMenu.setAttribute("id", "ag-option-menu-" + uid);
            optionMenu.setAttribute("class", "ag-option-menu d-none");
            let el = document.createElement("span");
            optionMenu.appendChild(el);
            el = document.createElement("span");
            optionMenu.appendChild(el);
            el = document.createElement("span");
            optionMenu.appendChild(el);
            domPlayer.appendChild(optionMenu);

            optionMenu.addEventListener("click", function (e) {
              if (
                $("#ag-option-group-" + uid + ".ag-option-group").hasClass(
                  "hidden"
                )
              ) {
                vm.hidePopup();
                $("#ag-option-group-" + uid + ".ag-option-group").removeClass(
                  "hidden"
                );
              } else {
                $("#ag-option-group-" + uid + ".ag-option-group").addClass(
                  "hidden"
                );
              }
              e.stopPropagation();
            });
          }

          //////PIN
          //if (vm.AllowPinVideoTile) {
          //  let domUserPin = document.querySelector("#upin-" + uid);
          //  if (!domUserPin) {
          //    domUserPin = document.createElement("div");
          //    domUserPin.setAttribute("id", "upin-" + uid);
          //    domUserPin.setAttribute("class", "ag-user-pin hidden");

          //    let elp = document.createElement("a");
          //    elp.setAttribute("class", "ag-pin");
          //    elp.setAttribute("id", "pin-" + uid);
          //    elp.addEventListener("click", function () {
          //      if ($("#pin-" + uid).hasClass("ag-pin")) {
          //        $(".ag-user-pin a")
          //          .removeClass("ag-unpin")
          //          .addClass("ag-pin");
          //        $("#pin-" + uid).removeClass("ag-pin");
          //        $("#pin-" + uid).addClass("ag-unpin");
          //        vm.pinSelected = true;
          //      } else {
          //        $("#pin-" + uid).removeClass("ag-unpin");
          //        $("#pin-" + uid).addClass("ag-pin");
          //        vm.pinSelected = false;
          //      }
          //      //vm.pinSelected = !vm.pinSelected;
          //      if (vm.pinSelected) {
          //        vm.pinVideoTile(uid);
          //      }
          //    });
          //    domUserPin.appendChild(elp);

          //    domPlayer.appendChild(domUserPin);
          //  }
          //}

          //OPTIONS
          let domUserOptionGroup = document.querySelector(
            "#ag-option-group-" + uid
          );
          if (!domUserOptionGroup) {
            domUserOptionGroup = document.createElement("div");
            domUserOptionGroup.setAttribute("id", "ag-option-group-" + uid);
            domUserOptionGroup.setAttribute("class", "ag-option-group hidden");

            let notification = document.createElement("div");
            notification.setAttribute("id", "ag-action-notification-" + uid);
            notification.setAttribute("class", "action-notification hidden");

            domUserOptionGroup.appendChild(notification);
            domUserOptionGroup.addEventListener("click", function (e) {
              e.stopPropagation();
            });

            //PIN
            if (vm.AllowPinVideoTile) {
              let domUserOption = document.querySelector(
                "#ag-option-pin-" + uid
              );
              if (!domUserOption) {
                domUserOption = document.createElement("div");
                domUserOption.setAttribute("id", "ag-option-pin-" + uid);
                domUserOption.setAttribute("class", "ag-option ag-option-pin");

                let elp = document.createElement("a");
                elp.setAttribute("class", "ag-option-icon ag-pin-user");
                domUserOption.appendChild(elp);

                elp = document.createElement("span");
                elp.setAttribute("class", "ag-option-label");
                let nodep = document.createTextNode("Pin");
                elp.appendChild(nodep);
                domUserOption.appendChild(elp);

                domUserOption.addEventListener("click", function () {
                  if (
                    $("#ag-option-pin-" + uid + " .ag-option-icon").hasClass(
                      "ag-pin-user"
                    )
                  ) {
                    $(".ag-option-pin").removeClass("disabled");
                    $("#ag-option-pin-" + uid).addClass("disabled");
                    $(".ag-option-pin .ag-option-icon")
                      .removeClass("ag-unpin-user")
                      .addClass("ag-pin-user");
                    $("#ag-option-pin-" + uid + " .ag-option-icon").addClass(
                      "ag-unpin-user"
                    );
                    //$(
                    //  "#ag-option-pin-" + uid + " .ag-option-label"
                    //).html("Unpin");

                    $(".ag-spotlight .ag-spotlight-on")
                      .removeClass("ag-spotlight-on")
                      .addClass("ag-spotlight-off");
                    vm.pinSelected = true;
                    vm.pinVideoTile(uid);
                  } else {
                    //$("#ag-option-pin-" + uid + " .ag-option-icon")
                    //  .removeClass("ag-unpin-user")
                    //  .addClass("ag-pin-user");
                    //$(
                    //  "#ag-option-pin-" + uid + " .ag-option-label"
                    //).html("Pin");
                    //vm.pinSelected = false;
                  }
                });

                domUserOptionGroup.appendChild(domUserOption);
              }
            }

            if (
              vm.hostOptionsEnabled &&
              [3, 4].includes(vm.sessionTypeId) &&
              (vm.hostCanMuteSpeaker ||
                vm.hostCanHideSpeaker ||
                vm.hostCanSpotlightSpeaker ||
                vm.hostCanInviteAttendeeToStage)
            ) {
              if (vm.userType == 1 || vm.isCurrentUserCoHost) {
                //Mute
                if (vm.hostCanMuteSpeaker && vm.uid != uid) {
                  let domUserOption = document.querySelector(
                    "#ag-option-mute-" + uid
                  );
                  if (!domUserOption) {
                    domUserOption = document.createElement("div");
                    domUserOption.setAttribute("id", "ag-option-mute-" + uid);
                    domUserOption.setAttribute("class", "ag-option");

                    let elp = document.createElement("a");
                    elp.setAttribute("class", "ag-option-icon ag-mute");
                    domUserOption.appendChild(elp);

                    elp = document.createElement("span");
                    elp.setAttribute("class", "ag-option-label");
                    let nodep = document.createTextNode("Mute");
                    elp.appendChild(nodep);
                    domUserOption.appendChild(elp);

                    domUserOption.addEventListener("click", function () {
                      if (
                        $(
                          "#ag-option-mute-" + uid + " .ag-option-icon"
                        ).hasClass("ag-mute")
                      ) {
                        $("#ag-option-mute-" + uid + " .ag-option-icon")
                          .removeClass("ag-mute")
                          .addClass("ag-unmute");
                        $("#ag-option-mute-" + uid + " .ag-option-label").html(
                          "Request to unmute"
                        );
                        vm.requestSpeakerToMute(uid, 0, true);
                        //$("#ag-action-notification-" + uid).html(
                        //  "Request sent"
                        //);
                        //$("#ag-action-notification-" + uid).removeClass(
                        //  "hidden"
                        //);
                        //setTimeout(() => {
                        //  $("#ag-action-notification-" + uid).addClass(
                        //    "hidden"
                        //  );
                        //}, 5000);
                      } else {
                        //$("#ag-option-mute-" + uid + " .ag-option-icon")
                        //  .removeClass("ag-unmute")
                        //  .addClass("ag-mute");
                        //$(
                        //  "#ag-option-mute-" + uid + " .ag-option-label"
                        //).html("Mute");
                        vm.requestSpeakerToMute(uid, 1);
                        $("#ag-action-notification-" + uid).html(
                          "Request sent"
                        );
                        $("#ag-action-notification-" + uid).removeClass(
                          "hidden"
                        );
                        setTimeout(() => {
                          $("#ag-action-notification-" + uid).addClass(
                            "hidden"
                          );
                        }, 5000);
                      }
                    });

                    domUserOptionGroup.appendChild(domUserOption);
                  }

                  //Mute All
                  //domUserOption = document.querySelector(
                  //  "#ag-option-muteall-" + uid
                  //);
                  //if (!domUserOption) {
                  //  domUserOption = document.createElement("div");
                  //  domUserOption.setAttribute(
                  //    "id",
                  //    "ag-option-muteall-" + uid
                  //  );
                  //  domUserOption.setAttribute(
                  //    "class",
                  //    "ag-option-muteall ag-option"
                  //  );

                  //  let elp = document.createElement("a");
                  //  elp.setAttribute("class", "ag-option-icon ag-muteall");
                  //  domUserOption.appendChild(elp);

                  //  elp = document.createElement("span");
                  //  elp.setAttribute("class", "ag-option-label");
                  //  let nodep = document.createTextNode("Mute All");
                  //  elp.appendChild(nodep);
                  //  domUserOption.appendChild(elp);

                  //  domUserOption.addEventListener("click", function () {
                  //    if (
                  //      !$("#ag-option-muteall-" + uid).hasClass("disabled")
                  //    ) {
                  //      vm.requestAllSpeakersToMute(0, true);

                  //      //$("#ag-action-notification-" + uid).html(
                  //      //  "Request sent to mute all"
                  //      //);
                  //      //$("#ag-action-notification-" + uid).removeClass(
                  //      //  "hidden"
                  //      //);
                  //      //setTimeout(() => {
                  //      //  $("#ag-action-notification-" + uid).addClass(
                  //      //    "hidden"
                  //      //  );
                  //      //}, 5000);
                  //    }
                  //  });

                  //  domUserOptionGroup.appendChild(domUserOption);
                  //}

                  ////Unmute All
                  //domUserOption = document.querySelector(
                  //  "#ag-option-unmuteall-" + uid
                  //);
                  //if (!domUserOption) {
                  //  domUserOption = document.createElement("div");
                  //  domUserOption.setAttribute(
                  //    "id",
                  //    "ag-option-unmuteall-" + uid
                  //  );
                  //  domUserOption.setAttribute(
                  //    "class",
                  //    "ag-option-unmuteall ag-option"
                  //  );

                  //  let elp = document.createElement("a");
                  //  elp.setAttribute(
                  //    "class",
                  //    "ag-option-icon ag-unmuteall"
                  //  );
                  //  domUserOption.appendChild(elp);

                  //  elp = document.createElement("span");
                  //  elp.setAttribute("class", "ag-option-label");
                  //  let nodep = document.createTextNode("Unmute All");
                  //  elp.appendChild(nodep);
                  //  domUserOption.appendChild(elp);

                  //  domUserOption.addEventListener("click", function () {
                  //    if (
                  //      !$("#ag-option-unmuteall-" + uid).hasClass(
                  //        "disabled"
                  //      )
                  //    ) {
                  //      vm.requestAllSpeakersToMute(1);

                  //      $("#ag-action-notification-" + uid).html(
                  //        "Request sent to unmute all"
                  //      );
                  //      $("#ag-action-notification-" + uid).removeClass(
                  //        "hidden"
                  //      );
                  //      setTimeout(() => {
                  //        $("#ag-action-notification-" + uid).addClass(
                  //          "hidden"
                  //        );
                  //      }, 5000);
                  //    }
                  //  });

                  //  domUserOptionGroup.appendChild(domUserOption);
                  //}
                }

                //Visibility
                if (vm.hostCanHideSpeaker) {
                  let domUserOption = document.querySelector(
                    "#ag-option-hide-" + uid
                  );
                  if (!domUserOption) {
                    domUserOption = document.createElement("div");
                    domUserOption.setAttribute("id", "ag-option-hide-" + uid);
                    domUserOption.setAttribute("class", "ag-option");

                    let elp = document.createElement("a");
                    elp.setAttribute("class", "ag-option-icon ag-hide");
                    domUserOption.appendChild(elp);

                    elp = document.createElement("span");
                    elp.setAttribute("class", "ag-option-label");
                    let nodep = document.createTextNode("Hide");
                    elp.appendChild(nodep);
                    domUserOption.appendChild(elp);

                    domUserOptionGroup.appendChild(domUserOption);
                  }
                }

                //Spotlight
                if (vm.hostCanSpotlightSpeaker) {
                  let domUserOption = document.querySelector(
                    "#ag-option-spotlight-" + uid
                  );
                  if (!domUserOption) {
                    domUserOption = document.createElement("div");
                    domUserOption.setAttribute(
                      "id",
                      "ag-option-spotlight-" + uid
                    );
                    domUserOption.setAttribute(
                      "class",
                      "ag-option ag-spotlight"
                    );

                    let elp = document.createElement("a");
                    elp.setAttribute(
                      "class",
                      "ag-option-icon ag-spotlight-off"
                    );
                    domUserOption.appendChild(elp);

                    elp = document.createElement("span");
                    elp.setAttribute("class", "ag-option-label");
                    let nodep = document.createTextNode("Spotlight");
                    elp.appendChild(nodep);
                    domUserOption.appendChild(elp);

                    domUserOption.addEventListener("click", function () {
                      //vm.requestSpotlight(uid);
                      if (
                        $(
                          "#ag-option-spotlight-" + uid + " .ag-option-icon"
                        ).hasClass("ag-spotlight-off")
                      ) {
                        vm.requestSpotlight(uid, 1);
                        $("#ag-option-spotlight-" + uid + " .ag-option-icon")
                          .removeClass("ag-spotlight-off")
                          .addClass("ag-spotlight-on");
                        //$("#ag-option-spotlight-" + uid + " .ag-option-label").html(
                        //  "Spotlight"
                        //);

                        //$("#ag-action-notification-" + uid).html(
                        //  "Request sent to Spotlight"
                        //);
                        //$("#ag-action-notification-" + uid).removeClass(
                        //  "hidden"
                        //);
                        //setTimeout(() => {
                        //  $("#ag-action-notification-" + uid).addClass(
                        //    "hidden"
                        //  );
                        //}, 5000);
                      } else {
                        vm.requestSpotlight(uid, 0);
                        $("#ag-option-spotlight-" + uid + " .ag-option-icon")
                          .removeClass("ag-spotlight-on")
                          .addClass("ag-spotlight-off");
                        //$("#ag-option-spotlight-" + uid + " .ag-option-label").html(
                        //  "Spotlight"
                        //);

                        //$("#ag-action-notification-" + uid).html(
                        //  "Request sent to Remove Spotlight"
                        //);
                        //$("#ag-action-notification-" + uid).removeClass(
                        //  "hidden"
                        //);
                        //setTimeout(() => {
                        //  $("#ag-action-notification-" + uid).addClass(
                        //    "hidden"
                        //  );
                        //}, 5000);
                      }
                    });

                    domUserOptionGroup.appendChild(domUserOption);
                  }
                }

                //Remove Invited Attendee from Stage
                // && vm.isInvited
                if (vm.hostCanInviteAttendeeToStage && isUserInvited) {
                  let domUserOption = document.querySelector(
                    "#ag-option-remove-" + uid
                  );
                  if (!domUserOption) {
                    domUserOption = document.createElement("div");
                    domUserOption.setAttribute("id", "ag-option-remove-" + uid);
                    domUserOption.setAttribute("class", "ag-option ag-remove");

                    let elp = document.createElement("a");
                    elp.setAttribute("class", "ag-option-icon ag-remove-user");
                    domUserOption.appendChild(elp);

                    elp = document.createElement("span");
                    elp.setAttribute("class", "ag-option-label");
                    let nodep = document.createTextNode("Remove from stage");
                    elp.appendChild(nodep);
                    domUserOption.appendChild(elp);

                    domUserOption.addEventListener("click", function () {
                      //alert("addEventListener: "+uid);
                      $("#ag-option-group-" + uid).addClass("hidden");
                      vm.InviteAttendeeToStage(uid);
                    });

                    domUserOptionGroup.appendChild(domUserOption);
                  }
                }
              }
            }
            domPlayer.appendChild(domUserOptionGroup);
          }
          //$('.ag-option-group:empty').remove();

          let domProfile = document.querySelector("#profile-" + uid);
          if (!domProfile) {
            domProfile = document.createElement("div");
            domProfile.setAttribute("id", "profile-" + uid);
            domProfile.setAttribute("class", "ag-profile");

            let profileDesc = document.createElement("div");
            profileDesc.setAttribute("class", "profile-desc");

            profileDesc.addEventListener("click", function (e) {
              vm.openSpeakerPanel(uid);
              e.stopPropagation();
            });
            //alert("profileDesc");
            //profileDesc.addEventListener("click", function (event) {
            //  //alert("profileDesc");
            //  vm.MakeVideoFullscreen(uid);
            //  event.stopPropagation();
            //});
            domProfile.appendChild(profileDesc);

            let el = document.createElement("div");
            el.setAttribute("class", "ag-profile-name");
            let node = document.createTextNode(name);
            el.appendChild(node);
            profileDesc.appendChild(el);

            if (vm.ShowAudioVolume) {
              //el = document.createElement("div");
              //el.setAttribute("class", "ag-asr");
              //node = document.createTextNode("0");
              //el.appendChild(node);
              //profileDesc.appendChild(el);
            }

            if (vm.DisplayCompanyAndTitleInVideoTile) {
              el = document.createElement("div");
              el.setAttribute("class", "ag-profile-title");
              node = document.createTextNode(title);
              el.appendChild(node);
              profileDesc.appendChild(el);

              el = document.createElement("div");
              el.setAttribute("class", "ag-profile-company");
              node = document.createTextNode(company);
              el.appendChild(node);
              profileDesc.appendChild(el);
            }

            let profileVolumeControl = document.createElement("div");
            profileVolumeControl.setAttribute("class", "sound-gif");

            domProfile.appendChild(profileVolumeControl);

            let imgS = document.createElement("a");
            //imgS.setAttribute(
            //  "src",
            //  "../../../assets/Player/images/icon-muted.png"
            //);
            //imgS.setAttribute("src", "../assets/Player/images/ag-logo.png");
            imgS.setAttribute("class", "sound-unmuted");
            //imgS.setAttribute("height", "132px");
            //imgS.setAttribute("width", "132px");
            imgS.setAttribute("id", "audio-indicator-" + uid);

            //if (vm.attendeeType == 1 && vm.uid != uid) {
            //  imgS.addEventListener("click", function (e) {
            //    if (!e.target.classList.contains("sound-muted")) {
            //      vm.requestSpeakerToMute(uid, true);
            //    }
            //    e.stopPropagation();
            //  });
            //}
            profileVolumeControl.appendChild(imgS);

            domPlayer.appendChild(domProfile);

            if (vm.DebugMode) {
              if (uid == vm.uid) {
                el = document.createElement("div");
                el.setAttribute("class", "ag-ul");
                profileDesc.appendChild(el);
              } else {
                el = document.createElement("div");
                el.setAttribute("class", "ag-dl");
                profileDesc.appendChild(el);
              }
            }
          }

          let networkProfile = document.querySelector(
            "#player-network-error-" + uid
          );
          if (!networkProfile) {
            networkProfile = document.createElement("div");
            networkProfile.setAttribute("id", "player-network-error-" + uid);
            networkProfile.setAttribute("class", "ag-network-error d-none");
            let el = document.createElement("div");
            el.setAttribute("class", "network-error-loader");
            networkProfile.appendChild(el);

            el = document.createElement("span");
            el.setAttribute("class", "ag-err-msg");
            let node = document.createTextNode("Trying to reconnect");
            el.appendChild(node);
            networkProfile.appendChild(el);
            domPlayer.appendChild(networkProfile);
          }

          //if (isVideoOn==true) {
          //Display Profile Pecture
          let el1 = document.querySelector("#profileImage_" + uid);
          if (!el1) {
            el1 = document.createElement("div");
            el1.setAttribute("id", "profileImage_" + uid);
            el1.setAttribute("class", "ag-profile-image name-initial d-none");
            el1.setAttribute("style", "animation-delay: 0s");
            if (profileImage == avatarImageUrl) {
              profileImage = "";
            }
            if (profileImage == "") {
              let h4 = document.createElement("h4");
              let nameInit = document.createTextNode(nameInitial);
              h4.appendChild(nameInit);
              el1.appendChild(h4);
            } else {
              let img = document.createElement("img");
              img.setAttribute("src", profileImage);
              img.setAttribute("height", "132px");
              img.setAttribute("width", "132px");
              el1.appendChild(img);
            }
            domPlayer.appendChild(el1);
            //console.log(profileImage);
          }
          //}
          if (isVideoOn) {
            el1.setAttribute("class", "ag-profile-image name-initial d-none");
          } else {
            el1.setAttribute("class", "ag-profile-image name-initial");
          }

          //Display Waiting User
          if (waitingProfile) {
            let elw = document.querySelector("#waiting_" + uid);
            if (!elw) {
              elw = document.createElement("div");
              elw.setAttribute("id", "waiting_" + uid);
              elw.setAttribute("class", "ag-waiting");

              // let img = document.createElement("img");
              // img.setAttribute("src", profileImage);
              // //img.setAttribute("height", "132px");
              // img.setAttribute("width", "50px");
              // elw.appendChild(img);

              let div = document.createElement("h2");
              div.setAttribute("class", "msg-top");
              elw.appendChild(div);

              if (ring) {
                let ring = document.createElement("div");
                ring.setAttribute("class", "ag-ring");
                elw.appendChild(ring);

                let audio = document.createElement("audio");
                audio.setAttribute("id", "ringAudio");
                audio.setAttribute("class", "ag-audio");
                audio.setAttribute("loop", "");
                audio.setAttribute("autoplay", "");
                audio.setAttribute(
                  "src",
                  "https://firebasestorage.googleapis.com/v0/b/e2monair.firebasestorage.app/o/OA_UAT%2FAudio%2Fring.mp3?alt=media"
                );
                ring.appendChild(audio);

                // roomId: notification.MeetingId,
                // sender: notification.Sender,
                // actionType: 1,
                setTimeout(() => {
                  let elw = document.querySelector("#waiting_" + uid);
                  if (elw) {
                    var data = {};
                    data.actionType = 2;
                    data.roomId = vm.roomId;
                    data.sender = {
                      AttendeeId: uid,
                      Name: name,
                      ProfilePictureURL: profileImage,
                      Tags: nameInitial,
                    };
                    bus.$emit("videoChatNoAnswer", data);
                    if (!location.host.includes("localhost")) {
                      vm.showSnackbar(
                        fName +
                          " is not available right now, please try again later.",
                        "info",
                        "top"
                      );
                      vm.onEndCall();
                    }
                  }
                }, vm.dialTime * 1000);
              }

              div = document.createElement("div");
              div.setAttribute(
                "class",
                "msg d-flex align-items-center justify-content-center"
              );
              let nameInit = document.createTextNode(
                ring
                  ? "Waiting for " + fName + " to accept the Video Call..."
                  : fName + " has left the Video Call"
              );
              div.appendChild(nameInit);
              elw.appendChild(div);

              domPlayer.prepend(elw);
            }
          }
        }
      } else {
        //alert("");
        let domPlayer = document.querySelector("#ag-user-" + uid);
        let domPlayer1 = document.querySelector("#player_" + uid);
        if (domPlayer) {
          domPlayer.setAttribute("firstName", fName);
          domPlayer.setAttribute("asrank", "0");
          //domPlayer.setAttribute("class", "ag-player");
          //if (uid.indexOf("share_" >= 0)) {
          if (domPlayer1) {
            if (uid > vm.shareIdStartsAfter) {
              domPlayer1.setAttribute("class", "ag-player player-share");
            } else {
              domPlayer1.setAttribute("class", "ag-player");
            }
          }

          let isShareScreen = false;
          name = uid.toString();
          //if (uid.indexOf("share") >= 0) {
          if (uid > vm.shareIdStartsAfter) {
            isShareScreen = true;
            //var shareUserId = uid.replace("share_", "");
            //alert(uid);
            var shareUserId = uid - vm.shareIdStartsAfter;
            //alert(shareUserId);
            //attendees = vm.allAttendees.filter(function (value) {
            //  return value.id == shareUserId;
            //});
            //if (attendees.length > 0) {
            //  name = attendees[0].name;
            //  fName = attendees[0].fname;
            //  profileImage = attendees[0].profilepic;
            //  title = attendees[0].title;
            //  company = attendees[0].company;
            //}
            //name = name + " is presenting";

            let hosts = vm.allHosts.filter(function (item) {
              return item.AttendeeId == shareUserId;
            });
            if (hosts.length > 0) {
              name = hosts[0].Name;
            } else {
              let speakers = vm.allSpeakers.filter(function (item) {
                return item.AttendeeId == shareUserId;
              });
              if (speakers.length > 0) {
                name = speakers[0].Name;
              }
            }
          }
          if (name == uid) {
            let attendees = vm.allAttendees.filter(function (item) {
              return item.AttendeeId == shareUserId;
            });
            if (attendees.length > 0) {
              name = attendees[0].Name;
            }
          }
          name = name + " is presenting";

          //SCREEN
          if (isShareScreen) {
            UserTypeName = "SCREEN";
          }
          let domUserType = document.querySelector("#utype-" + uid);
          if (!domUserType) {
            let domUserType = document.createElement("div");
            domUserType.setAttribute("id", "utype-" + uid);
            domUserType.setAttribute("class", "ag-user-type");

            let elp = document.createElement("a");
            elp.setAttribute("class", "ag-h4");
            let nodep = document.createTextNode(UserTypeName);
            elp.appendChild(nodep);
            domUserType.appendChild(elp);

            domPlayer.appendChild(domUserType);
          }

          let optionMenu = document.querySelector("#ag-option-menu-" + uid);
          if (!optionMenu) {
            optionMenu = document.createElement("div");
            optionMenu.setAttribute("id", "ag-option-menu-" + uid);
            optionMenu.setAttribute("class", "ag-option-menu d-none");
            let el = document.createElement("span");
            optionMenu.appendChild(el);
            el = document.createElement("span");
            optionMenu.appendChild(el);
            el = document.createElement("span");
            optionMenu.appendChild(el);
            domPlayer.appendChild(optionMenu);

            optionMenu.addEventListener("click", function (e) {
              if (
                $("#ag-option-group-" + uid + ".ag-option-group").hasClass(
                  "hidden"
                )
              ) {
                vm.hidePopup();
                $("#ag-option-group-" + uid + ".ag-option-group").removeClass(
                  "hidden"
                );
              } else {
                $("#ag-option-group-" + uid + ".ag-option-group").addClass(
                  "hidden"
                );
              }
              e.stopPropagation();
            });
          }
          //PIN
          //let domUserPin = document.querySelector("#upin-" + uid);
          //if (!domUserPin) {
          //  let domUserPin = document.createElement("div");
          //  domUserPin.setAttribute("id", "upin-" + uid);
          //  domUserPin.setAttribute("class", "ag-user-pin hidden");

          //  let elp = document.createElement("a");
          //  elp.setAttribute("class", "ag-pin");
          //  elp.setAttribute("id", "pin-" + uid);
          //  elp.addEventListener("click", function (event) {
          //    if ($("#pin-" + uid).hasClass("ag-pin")) {
          //      $(".ag-user-pin a")
          //        .removeClass("ag-unpin")
          //        .addClass("ag-pin");
          //      $("#pin-" + uid).removeClass("ag-pin");
          //      $("#pin-" + uid).addClass("ag-unpin");
          //      vm.pinSelected = true;
          //    } else {
          //      $("#pin-" + uid).removeClass("ag-unpin");
          //      $("#pin-" + uid).addClass("ag-pin");
          //      vm.pinSelected = false;
          //    }
          //    //vm.pinSelected = !vm.pinSelected;
          //    if (vm.pinSelected) {
          //      vm.pinVideoTile(uid);
          //    }
          //    event.stopPropagation();
          //  });
          //  domUserPin.appendChild(elp);

          //  domPlayer.appendChild(domUserPin);
          //}

          //OPTIONS
          let domUserOptionGroup = document.querySelector(
            "#ag-option-group-" + uid
          );
          if (!domUserOptionGroup) {
            domUserOptionGroup = document.createElement("div");
            domUserOptionGroup.setAttribute("id", "ag-option-group-" + uid);
            domUserOptionGroup.setAttribute("class", "ag-option-group hidden");

            let notification = document.createElement("div");
            notification.setAttribute("id", "ag-action-notification-" + uid);
            notification.setAttribute("class", "action-notification hidden");

            domUserOptionGroup.appendChild(notification);
            domUserOptionGroup.addEventListener("click", function (e) {
              e.stopPropagation();
            });

            //PIN
            if (vm.AllowPinVideoTile) {
              let domUserOption = document.querySelector(
                "#ag-option-pin-" + uid
              );
              if (!domUserOption) {
                domUserOption = document.createElement("div");
                domUserOption.setAttribute("id", "ag-option-pin-" + uid);
                domUserOption.setAttribute("class", "ag-option ag-option-pin");

                let elp = document.createElement("a");
                elp.setAttribute("class", "ag-option-icon ag-pin-user");
                domUserOption.appendChild(elp);

                elp = document.createElement("span");
                elp.setAttribute("class", "ag-option-label");
                let nodep = document.createTextNode("Pin");
                elp.appendChild(nodep);
                domUserOption.appendChild(elp);

                domUserOption.addEventListener("click", function () {
                  if (
                    $("#ag-option-pin-" + uid + " .ag-option-icon").hasClass(
                      "ag-pin-user"
                    )
                  ) {
                    $("#ag-option-pin-" + uid + " .ag-option-icon")
                      .removeClass("ag-pin-user")
                      .addClass("ag-unpin-user");
                    $("#ag-option-pin-" + uid).addClass("disabled");
                    //$(
                    //  "#ag-option-pin-" + uid + " .ag-option-label"
                    //).html("Unpin");
                    vm.pinSelected = true;
                    vm.pinVideoTile(uid);
                  } else {
                    //$("#ag-option-pin-" + uid + " .ag-option-icon")
                    //  .removeClass("ag-unpin-user")
                    //  .addClass("ag-pin-user");
                    //$(
                    //  "#ag-option-pin-" + uid + " .ag-option-label"
                    //).html("Pin");
                    //vm.pinSelected = false;
                  }
                });

                domUserOptionGroup.appendChild(domUserOption);
              }
            }
            if (
              vm.hostOptionsEnabled &&
              [3, 4].includes(vm.sessionTypeId) &&
              (vm.hostCanMuteSpeaker ||
                vm.hostCanHideSpeaker ||
                vm.hostCanSpotlightSpeaker)
            ) {
              if (vm.userType == 1 || vm.isCurrentUserCoHost) {
                //Mute
                //if (vm.hostCanMuteSpeaker && vm.uid != uid) {
                //  let domUserOption = document.querySelector(
                //    "#ag-option-mute-" + uid
                //  );
                //  if (!domUserOption) {
                //    domUserOption = document.createElement("div");
                //    domUserOption.setAttribute(
                //      "id",
                //      "ag-option-mute-" + uid
                //    );
                //    domUserOption.setAttribute("class", "ag-option");

                //    let elp = document.createElement("a");
                //    elp.setAttribute("class", "ag-option-icon ag-mute");
                //    domUserOption.appendChild(elp);

                //    elp = document.createElement("span");
                //    elp.setAttribute("class", "ag-option-label");
                //    let nodep = document.createTextNode("Mute");
                //    elp.appendChild(nodep);
                //    domUserOption.appendChild(elp);

                //    domUserOption.addEventListener("click", function () {
                //      if (
                //        $(
                //          "#ag-option-mute-" + uid + " .ag-option-icon"
                //        ).hasClass("ag-mute")
                //      ) {
                //        $("#ag-option-mute-" + uid + " .ag-option-icon")
                //          .removeClass("ag-mute")
                //          .addClass("ag-unmute");
                //        $(
                //          "#ag-option-mute-" + uid + " .ag-option-label"
                //        ).html("Request to unmute");
                //        vm.requestSpeakerToMute(uid, 0, true);
                //        //$("#ag-action-notification-" + uid).html(
                //        //  "Request sent to mute"
                //        //);
                //        //$("#ag-action-notification-" + uid).removeClass(
                //        //  "hidden"
                //        //);
                //        //setTimeout(() => {
                //        //  $("#ag-action-notification-" + uid).addClass(
                //        //    "hidden"
                //        //  );
                //        //}, 5000);
                //      } else {
                //        //$("#ag-option-mute-" + uid + " .ag-option-icon")
                //        //  .removeClass("ag-unmute")
                //        //  .addClass("ag-mute");
                //        //$(
                //        //  "#ag-option-mute-" + uid + " .ag-option-label"
                //        //).html("Mute");
                //        vm.requestSpeakerToMute(uid, 1);
                //        //$("#ag-action-notification-" + uid).html(
                //        //  "Request sent to unmute"
                //        //);
                //        //$("#ag-action-notification-" + uid).removeClass(
                //        //  "hidden"
                //        //);
                //        //setTimeout(() => {
                //        //  $("#ag-action-notification-" + uid).addClass(
                //        //    "hidden"
                //        //  );
                //        //}, 5000);
                //      }
                //    });

                //    domUserOptionGroup.appendChild(domUserOption);
                //  }

                //  //Mute All
                //  //domUserOption = document.querySelector(
                //  //  "#ag-option-muteall-" + uid
                //  //);
                //  //if (!domUserOption) {
                //  //  domUserOption = document.createElement("div");
                //  //  domUserOption.setAttribute(
                //  //    "id",
                //  //    "ag-option-muteall-" + uid
                //  //  );
                //  //  domUserOption.setAttribute(
                //  //    "class",
                //  //    "ag-option-muteall ag-option"
                //  //  );

                //  //  let elp = document.createElement("a");
                //  //  elp.setAttribute("class", "ag-option-icon ag-muteall");
                //  //  domUserOption.appendChild(elp);

                //  //  elp = document.createElement("span");
                //  //  elp.setAttribute("class", "ag-option-label");
                //  //  let nodep = document.createTextNode("Mute All");
                //  //  elp.appendChild(nodep);
                //  //  domUserOption.appendChild(elp);

                //  //  domUserOption.addEventListener("click", function () {
                //  //    if (
                //  //      !$("#ag-option-muteall-" + uid).hasClass("disabled")
                //  //    ) {
                //  //      vm.requestAllSpeakersToMute(0, true);

                //  //      //$("#ag-action-notification-" + uid).html(
                //  //      //  "Request sent to mute all"
                //  //      //);
                //  //      //$("#ag-action-notification-" + uid).removeClass(
                //  //      //  "hidden"
                //  //      //);
                //  //      //setTimeout(() => {
                //  //      //  $("#ag-action-notification-" + uid).addClass(
                //  //      //    "hidden"
                //  //      //  );
                //  //      //}, 5000);
                //  //    }
                //  //  });

                //  //  domUserOptionGroup.appendChild(domUserOption);
                //  //}

                //  ////Unmute All
                //  //domUserOption = document.querySelector(
                //  //  "#ag-option-unmuteall-" + uid
                //  //);
                //  //if (!domUserOption) {
                //  //  domUserOption = document.createElement("div");
                //  //  domUserOption.setAttribute(
                //  //    "id",
                //  //    "ag-option-unmuteall-" + uid
                //  //  );
                //  //  domUserOption.setAttribute(
                //  //    "class",
                //  //    "ag-option-unmuteall ag-option"
                //  //  );

                //  //  let elp = document.createElement("a");
                //  //  elp.setAttribute(
                //  //    "class",
                //  //    "ag-option-icon ag-unmuteall"
                //  //  );
                //  //  domUserOption.appendChild(elp);

                //  //  elp = document.createElement("span");
                //  //  elp.setAttribute("class", "ag-option-label");
                //  //  let nodep = document.createTextNode("Unmute All");
                //  //  elp.appendChild(nodep);
                //  //  domUserOption.appendChild(elp);

                //  //  domUserOption.addEventListener("click", function () {
                //  //    if (
                //  //      !$("#ag-option-unmuteall-" + uid).hasClass(
                //  //        "disabled"
                //  //      )
                //  //    ) {
                //  //      vm.requestAllSpeakersToMute(1);

                //  //      $("#ag-action-notification-" + uid).html(
                //  //        "Request sent to unmute all"
                //  //      );
                //  //      $("#ag-action-notification-" + uid).removeClass(
                //  //        "hidden"
                //  //      );
                //  //      setTimeout(() => {
                //  //        $("#ag-action-notification-" + uid).addClass(
                //  //          "hidden"
                //  //        );
                //  //      }, 5000);
                //  //    }
                //  //  });

                //  //  domUserOptionGroup.appendChild(domUserOption);
                //  //}
                //}

                //Visibility
                if (vm.hostCanHideSpeaker) {
                  let domUserOption = document.querySelector(
                    "#ag-option-hide-" + uid
                  );
                  if (!domUserOption) {
                    domUserOption = document.createElement("div");
                    domUserOption.setAttribute("id", "ag-option-hide-" + uid);
                    domUserOption.setAttribute("class", "ag-option");

                    let elp = document.createElement("a");
                    elp.setAttribute("class", "ag-option-icon ag-hide");
                    domUserOption.appendChild(elp);

                    elp = document.createElement("span");
                    elp.setAttribute("class", "ag-option-label");
                    let nodep = document.createTextNode("Hide");
                    elp.appendChild(nodep);
                    domUserOption.appendChild(elp);

                    domUserOptionGroup.appendChild(domUserOption);
                  }
                }

                //Spotlight
                if (vm.hostCanSpotlightSpeaker) {
                  let domUserOption = document.querySelector(
                    "#ag-option-spotlight-" + uid
                  );
                  if (!domUserOption) {
                    domUserOption = document.createElement("div");
                    domUserOption.setAttribute(
                      "id",
                      "ag-option-spotlight-" + uid
                    );
                    domUserOption.setAttribute(
                      "class",
                      "ag-option ag-spotlight"
                    );

                    let elp = document.createElement("a");
                    elp.setAttribute(
                      "class",
                      "ag-option-icon ag-spotlight-off"
                    );
                    domUserOption.appendChild(elp);

                    elp = document.createElement("span");
                    elp.setAttribute("class", "ag-option-label");
                    let nodep = document.createTextNode("Spotlight");
                    elp.appendChild(nodep);
                    domUserOption.appendChild(elp);

                    domUserOption.addEventListener("click", function () {
                      //vm.requestSpotlight(uid);
                      if (
                        $(
                          "#ag-option-spotlight-" + uid + " .ag-option-icon"
                        ).hasClass("ag-spotlight-off")
                      ) {
                        vm.requestSpotlight(uid, 1);
                        $("#ag-option-spotlight-" + uid + " .ag-option-icon")
                          .removeClass("ag-spotlight-off")
                          .addClass("ag-spotlight-on");
                        //$("#ag-option-spotlight-" + uid + " .ag-option-label").html(
                        //  "Spotlight"
                        //);

                        //$("#ag-action-notification-" + uid).html(
                        //  "Request sent to Spotlight"
                        //);
                        //$("#ag-action-notification-" + uid).removeClass(
                        //  "hidden"
                        //);
                        //setTimeout(() => {
                        //  $("#ag-action-notification-" + uid).addClass(
                        //    "hidden"
                        //  );
                        //}, 5000);
                      } else {
                        vm.requestSpotlight(uid, 0);
                        $("#ag-option-spotlight-" + uid + " .ag-option-icon")
                          .removeClass("ag-spotlight-on")
                          .addClass("ag-spotlight-off");
                        //$("#ag-option-spotlight-" + uid + " .ag-option-label").html(
                        //  "Spotlight"
                        //);

                        //$("#ag-action-notification-" + uid).html(
                        //  "Request sent to Remove Spotlight"
                        //);
                        //$("#ag-action-notification-" + uid).removeClass(
                        //  "hidden"
                        //);
                        //setTimeout(() => {
                        //  $("#ag-action-notification-" + uid).addClass(
                        //    "hidden"
                        //  );
                        //}, 5000);
                      }
                    });

                    domUserOptionGroup.appendChild(domUserOption);
                  }
                }
              }
            }
            domPlayer.appendChild(domUserOptionGroup);
          }
          let domProfile = document.querySelector("#profile-" + uid);
          if (!domProfile) {
            domProfile = document.createElement("div");
            domProfile.setAttribute("id", "profile-" + uid);
            domProfile.setAttribute("class", "ag-profile");

            let profileDesc = document.createElement("div");
            profileDesc.setAttribute("class", "profile-desc");
            domProfile.appendChild(profileDesc);

            let el = document.createElement("div");
            el.setAttribute("class", "ag-profile-name");
            let node = document.createTextNode(name);
            el.appendChild(node);
            profileDesc.appendChild(el);

            if (vm.ShowAudioVolume) {
              //el = document.createElement("div");
              //el.setAttribute("class", "ag-asr");
              //node = document.createTextNode("0");
              //el.appendChild(node);
              //profileDesc.appendChild(el);
            }

            if (name == uid) {
              let profileControl = document.createElement("div");
              profileControl.setAttribute("class", "sound-gif");
              domProfile.appendChild(profileControl);

              let imgS = document.createElement("a");
              imgS.setAttribute("class", "sound-unmuted");
              imgS.setAttribute("id", "audio-indicator-" + uid);
              profileControl.appendChild(imgS);

              //imgS = document.createElement("a");
              //imgS.setAttribute("class", "sound-muted d-none");
              //profileControl.appendChild(imgS);

              //imgS = document.createElement("a");
              //imgS.setAttribute("class", "sound-talking d-none");
              //profileControl.appendChild(imgS);
            }
            domPlayer.appendChild(domProfile);

            vm.pinVideoTileStatusUpdate(uid, true);
          }
        }
      }
    },
    MakeVideoFullscreen(id) {
      console.log(id);
      //alert(id); //ag-item-" + id
      if ($("#app").hasClass("full-screen-video")) {
        $("#app").removeClass("full-screen-video");
        vm.closeFullscreen();
      } else {
        $("#app").addClass("full-screen-video");
        vm.openFullscreen();
      }
    },
    openFullscreen() {
      let elem = document.getElementById("vueplayer");
      ///let elem = document.getElementById("LiveStage");
      if (elem.requestFullscreen) {
        elem.requestFullscreen();
      } else if (elem.mozRequestFullScreen) {
        /* Firefox */
        elem.mozRequestFullScreen();
      } else if (elem.webkitRequestFullscreen) {
        /* Chrome, Safari and Opera */
        elem.webkitRequestFullscreen();
      } else if (elem.msRequestFullscreen) {
        /* IE/Edge */
        elem.msRequestFullscreen();
      }
    },
    closeFullscreen() {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.mozCancelFullScreen) {
        /* Firefox */
        document.mozCancelFullScreen();
      } else if (document.webkitExitFullscreen) {
        /* Chrome, Safari and Opera */
        document.webkitExitFullscreen();
      } else if (document.msExitFullscreen) {
        /* IE/Edge */
        document.msExitFullscreen();
      }
    },
    IsFullScreenCurrently() {
      var full_screen_element =
        document.fullscreenElement ||
        document.webkitFullscreenElement ||
        document.mozFullScreenElement ||
        document.msFullscreenElement ||
        null;

      // If no element is in full-screen
      if (full_screen_element === null) {
        //alert("FULL SCREEN");
        return false;
      } else {
        //alert("SCREEN");
        return true;
      }
    },
    applyMic() {
      let microphone = "";
      if (vm.microphone) {
        microphone = vm.microphone.deviceId;
      }
      if (microphone) {
        vm.localStream.switchDevice(
          "audio",
          microphone,
          function () {
            //vm.addUserProfile(vm.uid.toString());
            console.log("Microphone applied successfully");
            if (vm.rememberSettings) {
              vm.saveCallSettings("microphone", microphone);
            }
          },
          function () {
            console.log("Microphone apply faild");
          }
        );
      }
    },
    onSpeakerChange(e) {
      let speaker = "";
      console.log(e.target.value);
      console.log(vm.speaker);
      if (e.target.value) {
        speaker = vm.speaker.deviceId;
        //alert(speaker);
        if (speaker != "") {
          vm.localStream.setAudioOutput(
            speaker,
            function () {
              //vm.addUserProfile(vm.uid.toString());
              console.log("Speaker applied successfully");
              if (vm.rememberSettings) {
                vm.saveCallSettings("speaker", speaker);
              }
            },
            function () {
              console.log("Microphone apply failed");
            }
          );
        }
      }
    },
    onCameraChange(e) {
      //let camera = "";
      console.log(e.target.value);
      console.log(vm.camera);
      if (e.target.value) {
        //camera = vm.camera.deviceId;
        //alert(camera);
        vm.applyCamera();
      }
    },
    applyCamera() {
      let camera = "";
      if (vm.camera) {
        camera = vm.camera.deviceId;
      }
      if (camera) {
        vm.localStream.switchDevice(
          "video",
          camera,
          function () {
            //vm.addUserProfile(vm.uid.toString());
            console.log("Camera applied successfully");
            if (vm.rememberSettings) {
              vm.saveCallSettings("camera", camera);
            }
          },
          function () {
            console.log("Camera apply failed");
          }
        );
      }
    },
    onVideoResolutionChange(e) {
      let videoResolution = "";
      console.log(e.target.value);
      console.log(vm.videoResolution);
      if (e.target.value) {
        videoResolution = vm.videoResolution;
        //alert(videoResolution);
        if (videoResolution != "") {
          vm.localStream.setVideoProfile(videoResolution);
          //vm.addUserProfile(vm.uid.toString());
          vm.videoResolution = videoResolution;
          if (vm.rememberSettings) {
            vm.saveCallSettings("videoProfile", videoResolution);
          }
        }
      }
    },
    async getMicrophones(apply) {
      var micList = [];
      var mics = await AgoraRTC.getMicrophones();
      for (var i = 0; i < mics.length; i++) {
        micList.push({ deviceId: mics[i].deviceId, label: mics[i].label });
      }
      vm.mics = micList;
      if (vm.mics.length > 0) {
        vm.IsMicExist = true;
        if (!vm.currentMic.deviceId || apply) {
          var needPrompt = false;
          if (!vm.currentMic.deviceId) {
            needPrompt = true;
          }
          var deviceId = vm.getCallSettings("mic");
          var currentMic = vm.mics.find((mic) => mic.deviceId === deviceId);
          if (currentMic) {
            vm.currentMic = currentMic;
          } else {
            vm.currentMic = vm.mics[0];
          }
          if (needPrompt) {
            vm.promptToAllowMicAccess();
          }
          //alert(vm.currentMic.deviceId);
          vm.switchMicrophone(vm.currentMic.deviceId);
        }
      } else {
        vm.IsMicExist = false;
        vm.hasMicccess = false;
        //vm.micAccessChecked = false;
        vm.isMicOn = false;
        if (
          vm.remoteUsers[vm.uid] &&
          vm.remoteUsers[vm.uid].stream &&
          vm.remoteUsers[vm.uid].stream.audioTrack
        ) {
          vm.remoteUsers[vm.uid].stream.audioTrack.setEnabled(false);
        }
        vm.currentMic = {};
      }
    },
    async getCameras(apply) {
      var camList = [];
      var cams = await AgoraRTC.getCameras();
      for (var i = 0; i < cams.length; i++) {
        camList.push({ deviceId: cams[i].deviceId, label: cams[i].label });
      }
      vm.cams = camList;
      if (vm.cams.length > 0) {
        vm.IsCameraExist = true;
        debugger;
        if (!vm.currentCam.deviceId || apply) {
          var needPrompt = false;
          if (!vm.currentCam.deviceId) {
            needPrompt = true;
          }
          var deviceId = vm.getCallSettings("cam");
          var currentCam = vm.cams.find((cam) => cam.deviceId === deviceId);
          if (currentCam) {
            vm.currentCam = currentCam;
          } else {
            vm.currentCam = vm.cams[0];
          }
          if (needPrompt) {
            vm.promptToAllowCamAccess();
          }
          vm.switchCamera(vm.currentCam.deviceId);
        }
      } else {
        vm.IsCameraExist = false;
        vm.hasCamAccess = false;
        //vm.camAccessChecked = false;
        vm.isVideoOn = false;
        if ($("#profileImage_" + vm.uid)) {
          $("#profileImage_" + vm.uid).removeClass("d-none");
        }
        if (
          vm.remoteUsers[vm.uid] &&
          vm.remoteUsers[vm.uid].stream &&
          vm.remoteUsers[vm.uid].stream.videoTrack
        ) {
          vm.remoteUsers[vm.uid].stream.videoTrack.setEnabled(false);
        }
        vm.currentCam = {};
      }
    },
    async getVideoProfile() {
      if (vm.videoProfiles.length > 0) {
        var profile = vm.getCallSettings("videoProfile");
        var videoProfile = vm.videoProfiles.find(
          (cam) => cam.value === profile
        );
        if (videoProfile) {
          vm.currentVideoProfile = videoProfile;
        } else {
          vm.currentVideoProfile = vm.videoProfiles[0];
        }
      }
    },
    async getPlaybackDevices(apply) {
      var playbackDeviceList = [];
      var playbackDevices = await AgoraRTC.getPlaybackDevices();
      for (var i = 0; i < playbackDevices.length; i++) {
        playbackDeviceList.push({
          deviceId: playbackDevices[i].deviceId,
          label: playbackDevices[i].label,
        });
      }
      vm.playbackDevices = playbackDeviceList;
      if (vm.playbackDevices.length > 0) {
        if (!vm.currentPlaybackDevice.deviceId || apply) {
          var deviceId = vm.getCallSettings("playbackDevice");
          var currentPlaybackDevice = vm.playbackDevices.find(
            (device) => device.deviceId === deviceId
          );
          if (currentPlaybackDevice) {
            vm.currentPlaybackDevice = currentPlaybackDevice;
          } else {
            vm.currentPlaybackDevice = vm.playbackDevices[0];
          }
          vm.switchPlaybackDevice(vm.currentPlaybackDevice.deviceId);
        }
      }
    },
    async switchMicrophone(deviceId) {
      var currentMic = vm.mics.find((mic) => mic.deviceId === deviceId);
      if (currentMic) {
        vm.saveCallSettings("mic", deviceId);
        //alert("switchMicrophone" + currentMic.label);
        console.log("switchMicrophone" + vm.remoteUsers[vm.uid]);
        if (
          vm.remoteUsers[vm.uid] &&
          vm.remoteUsers[vm.uid].stream &&
          vm.remoteUsers[vm.uid].stream.audioTrack
        ) {
          vm.remoteUsers[vm.uid].stream.audioTrack.setDevice(
            currentMic.deviceId
          );
        }
      }
    },
    async switchCamera(deviceId) {
      var currentCam = vm.cams.find((cam) => cam.deviceId === deviceId);
      if (currentCam) {
        //alert("switchCamera" + currentCam.label);
        vm.saveCallSettings("cam", deviceId);
        console.log("switchCamera" + vm.remoteUsers[vm.uid]);
        if (
          vm.remoteUsers[vm.uid] &&
          vm.remoteUsers[vm.uid].stream &&
          vm.remoteUsers[vm.uid].stream.videoTrack
        ) {
          vm.remoteUsers[vm.uid].stream.videoTrack.setDevice(
            currentCam.deviceId
          );
        }
      }
    },
    async switchVideoProfile(profile) {
      var videoProfile = vm.videoProfiles.find((v) => v.value === profile);
      if (videoProfile) {
        //alert("switchVideoProfile" + videoProfile.label);
        vm.saveCallSettings("videoProfile", videoProfile);
        //console.log("switchVideoProfile" + vm.remoteUsers[vm.uid]);
        if (
          vm.remoteUsers[vm.uid] &&
          vm.remoteUsers[vm.uid].stream &&
          vm.remoteUsers[vm.uid].stream.videoTrack
        ) {
          vm.remoteUsers[vm.uid].stream.videoTrack.setEncoderConfiguration(
            videoProfile.value
          );
        }
      }
    },
    async switchPlaybackDevice(deviceId) {
      var currentPlaybackDevice = vm.playbackDevices.find(
        (mic) => mic.deviceId === deviceId
      );
      if (currentPlaybackDevice) {
        //alert("switchPlaybackDevice" + currentplaybackDevice.label);
        vm.saveCallSettings("playbackDevice", deviceId);
        console.log("switchPlaybackDevice" + vm.remoteUsers[vm.uid]);

        for (var key in vm.remoteUsers) {
          if (key != vm.uid) {
            if (
              vm.remoteUsers[key] &&
              vm.remoteUsers[key].stream &&
              vm.remoteUsers[key].stream.audioTrack
            ) {
              vm.remoteUsers[key].stream.audioTrack.setPlaybackDevice(
                currentPlaybackDevice.deviceId
              );
            }
          }
        }
        // if (
        //   vm.remoteUsers[vm.uid] &&
        //   vm.remoteUsers[vm.uid].stream &&
        //   vm.remoteUsers[vm.uid].stream.audioTrack
        // ) {
        //   vm.remoteUsers[vm.uid].stream.audioTrack.setPlaybackDevice(
        //     currentPlaybackDevice.deviceId
        //   );
        // }
      }
    },
    getAudioSettings() {
      AgoraRTC.getDevices(function (devices) {
        let savedMicrophone = vm.getCallSettings("microphone");
        let savedSpeaker = vm.getCallSettings("speaker");
        vm.microphoneOptions = [];
        vm.speakerOptions = [];
        devices.forEach(function (item) {
          let device = {
            deviceId: item.deviceId,
            groupId: item.groupId,
            kind: item.kind,
            label: item.label,
          };
          if (item.kind == "audioinput") {
            if (!vm.microphone.deviceId) {
              vm.microphone = device;
            }
            vm.microphoneOptions.push(device);
          } else if (item.kind == "audiooutput") {
            if (!vm.speaker.deviceId) {
              vm.speaker = device;
            }
            vm.speakerOptions.push(device);
          }
        });
        console.log(vm.microphoneOptions);
        console.log(vm.speakerOptions);

        if (vm.rememberSettings) {
          if (savedMicrophone != "") {
            let microphones = vm.microphoneOptions.find(function (item) {
              return item.deviceId == savedMicrophone;
            });
            if (microphones) {
              vm.microphone = microphones;
            }
          }
          if (savedSpeaker != "") {
            let speakers = vm.speakerOptions.find(function (item) {
              return item.deviceId == savedSpeaker;
            });
            if (speakers) {
              vm.speaker = speakers;
            }
          }
        }
      });
    },
    getVideoSettings() {
      AgoraRTC.getDevices(function (devices) {
        //var devCount = devices.length;
        let savedCamera = vm.getCallSettings("camera");
        let savedVideoProfile = vm.getCallSettings("videoProfile");
        //alert(savedVideoProfile);
        //alert(vm.videoResolution);
        vm.cameraOptions = [];
        devices.forEach(function (item) {
          let device = {
            deviceId: item.deviceId,
            groupId: item.groupId,
            kind: item.kind,
            label: item.label,
          };
          if (item.kind == "videoinput") {
            if (!vm.camera.deviceId || vm.camera.deviceId == "undefiled") {
              if (device.label == vm.localStream.videoName) {
                vm.camera = device;
              }
            }
            vm.cameraOptions.push(device);
          }
        });
        console.log(vm.cameraOptions);
        if (vm.rememberSettings) {
          if (savedCamera != "") {
            let cameras = vm.cameraOptions.find(function (item) {
              return item.deviceId == savedCamera;
            });
            if (cameras) {
              vm.camera = cameras;
            }
          }
          if (savedVideoProfile != "") {
            vm.videoResolution = savedVideoProfile;
          }
        }
      });
    },
    getPlayerSettings() {
      //vm.client.getCameras(function (cameraList) {
      //  vm.cameraList = [];
      //  if (cameraList && cameraList.length > 0) {
      //    cameraList.forEach(function (item) {
      //      vm.cameraList.push({
      //        deviceId: item.deviceId,
      //        groupId: item.groupId,
      //        kind: item.kind,
      //        label: item.label,
      //      });
      //    });
      //    console.log("cameraList: " + vm.cameraList);

      //    vm.$emit("setPlayerSettings", { cameraOptions: vm.cameraList });
      //  }
      //});
      //.catch(function () {});
      AgoraRTC.getDevices(function (devices) {
        //var devCount = devices.length;
        vm.playerSettings.cameraOptions = [];
        vm.playerSettings.microphoneOptions = [];
        vm.playerSettings.speakerOptions = [];
        let savedMicrophone = vm.getCallSettings("microphone");
        let savedCamera = vm.getCallSettings("camera");
        let savedSpeaker = vm.getCallSettings("speaker");
        let savedVideoProfile = vm.getCallSettings("videoProfile");
        devices.forEach(function (item) {
          //alert(item.kind);
          //console.log(item);
          let device = {
            deviceId: item.deviceId,
            groupId: item.groupId,
            kind: item.kind,
            label: item.label,
          };
          if (item.kind == "audioinput") {
            if (!vm.playerSettings.microphone.deviceId) {
              vm.playerSettings.microphone = device;
            }
            vm.playerSettings.microphoneOptions.push(device);
          } else if (item.kind == "audiooutput") {
            if (!vm.playerSettings.speaker.deviceId) {
              vm.playerSettings.speaker = device;
            }
            //alert(device);
            vm.playerSettings.speakerOptions.push(device);
            // vm.playerSettings.speakerOptions.push(item);
          } else if (item.kind == "videoinput") {
            //alert()
            if (
              !vm.playerSettings.camera.deviceId ||
              vm.playerSettings.camera.deviceId == "undefiled"
            ) {
              if (device.label == vm.localStream.videoName) {
                vm.playerSettings.camera = device;
              }
            }
            vm.playerSettings.cameraOptions.push(device);
          }
        });

        if (vm.rememberSettings) {
          if (savedMicrophone != "") {
            let microphones = vm.playerSettings.microphoneOptions.find(
              function (item) {
                return item.deviceId == savedMicrophone;
              }
            );
            if (microphones) {
              vm.playerSettings.microphone = microphones;
            }
          }
          if (savedCamera != "") {
            let cameras = vm.playerSettings.cameraOptions.find(function (item) {
              return item.deviceId == savedCamera;
            });
            if (cameras) {
              vm.playerSettings.camera = cameras;
            }
          }
          //alert("savedSpeaker:" + savedSpeaker);
          if (savedSpeaker != "") {
            let speakers = vm.playerSettings.speakerOptions.find(function (
              item
            ) {
              return item.deviceId == savedSpeaker;
            });
            if (speakers) {
              vm.playerSettings.speaker = speakers;
              //alert(speakers.deviceId);
            }
          }
          //alert("getPlayerSettings:" + vm.videoProfile);
          if (savedVideoProfile != "") {
            vm.videoProfile = savedVideoProfile;
            vm.videoResolution = savedVideoProfile;
          }
        }
        if (vm.videoProfile != "") {
          vm.playerSettings.videoProfile = vm.videoProfile;
        }
        //alert("vm.playerSettings");
        console.log(vm.playerSettings);
        vm.$emit("setPlayerSettings", vm.playerSettings);
      });
    },

    togglRecording() {
      //
      //$("#btnRecording").toggleClass("start-record");
      if (!$("#btnRecording").hasClass("start-record")) {
        //$("#lblRecording").text(vm.$t("agoracall.stoprecording"));
        //alert("BroadCastStartRecording");
        //alert(vm.eventId);
        //alert(vm.eventId.substring(1));
        vm.BroadCastStartRecording();
      } else {
        //$("#lblRecording").text(vm.$t("agoracall.startrecording"));
        //alert("BroadCastStopRecording");
        vm.BroadCastStopRecording();
      }
    },
    tryAutoStartRecording() {
      var hostUrl = location.host.toLowerCase();
      if (!hostUrl.includes("localhost")) {
        //if (!vm.recordingStarted) {
        vm.BroadCastStartRecording();
        //}
      }
    },
    BroadCastStartRecording() {
      let SessionIdForRec = vm.sessionId;
      if (vm.sessionTypeId == vm.RoundTableTypeID) {
        SessionIdForRec = vm.roundTableId;
      }
      let headers = {
        "Content-Type": "application/json",
        Authorization: "Bearer " + vm.getSessionToken(),
      };
      var requestData = {
        key: {
          instanceId: vm.PlayerAPIConfig.EnvPrefix,
          clientId: vm.clientId,
          eventId: vm.eventId.substring(1),
          sessionId: SessionIdForRec,
          channel: vm.channelName.replace("_gr", ""),
        },
      };
      vm.recordingStartStopInProcess = true;
      axios
        .post(vm.PlayerAPIConfig.StartRecording, requestData, {
          headers: headers,
        })
        .then((responseData) => {
          let data = responseData.data;
          vm.recordingStartStopInProcess = false;
          //alert(data);
          //alert("Recording Started 1");
          let lStatusCode = -1;
          if (typeof data != "undefined") {
            //alert("Recording Started 2");
            lStatusCode = data.status;
            //alert("Start rec data.status: " + data.status);
          }
          //alert("BroadCastStartRecording:" + lStatusCode);
          if (lStatusCode == 0) {
            //alert("Recording Started 3");
            if (typeof data.result.resourceId != "undefined") {
              vm.RecResourceId = data.result.resourceId;
              //alert("data.result.resourceId:" + data.result.resourceId);
            }
            if (typeof data.result.sid != "undefined") {
              vm.RecSid = data.result.sid;
              //alert("data.result.sid:" + data.result.sid);
            }
            $("#btnRecording").addClass("start-record");
            $("#lblRecording").text(vm.$t("agoracall.stoprecording"));
            vm.recordingStarted = true;
            vm.setRecordingParamToFirebase(1);
          } else {
            $("#btnRecording").addClass("start-record");
            if ($("#btnRecording").hasClass("start-record")) {
              $("#lblRecording").text(vm.$t("agoracall.stoprecording"));
            } else {
              $("#lblRecording").text(vm.$t("agoracall.startrecording"));
            }
            vm.recordingStarted = true;
            vm.setRecordingParamToFirebase(1);
          }
        })
        .catch((e) => {
          vm.recordingStartStopInProcess = false;
          console.log(e);
          //console.log("Error in Start Recording: " + attendeeID);
          //alert("Error : Recording Started");
          $("#btnRecording").removeClass("start-record");
          //$("#btnRecording").toggleClass("start-record");
          if ($("#btnRecording").hasClass("start-record")) {
            $("#lblRecording").text(vm.$t("agoracall.stoprecording"));
          } else {
            $("#lblRecording").text(vm.$t("agoracall.startrecording"));
          }
        });
    },

    BroadCastStopRecording() {
      let headers = {
        "Content-Type": "application/json",
        Authorization: "Bearer " + vm.getSessionToken(),
      };
      var requestData = {
        key: {
          appId: vm.liveVideoApiDetails.AppID,
          channel: vm.channelName.replace("_gr", ""),
        },
        rec: { resourceId: vm.RecResourceId, sId: vm.RecSid },
      };
      vm.recordingStartStopInProcess = true;

      axios
        .post(vm.PlayerAPIConfig.StopRecording, requestData, {
          headers: headers,
        })
        .then((responseData) => {
          vm.recordingStartStopInProcess = false;
          let data = responseData.data;
          //alert(data);
          //alert("Recording Ended 1");
          let lStatusCode = -1;
          if (typeof data != "undefined") {
            //alert("Recording Ended 2");
            lStatusCode = data.status;
            //alert("Stop Rec data.status: " + data.status);
          }
          //alert("BroadCastStartRecording:" + lStatusCode);
          if (lStatusCode == 0) {
            $("#btnRecording").removeClass("start-record");
            $("#lblRecording").text(vm.$t("agoracall.startrecording"));
            vm.recordingStarted = false;
            vm.setRecordingParamToFirebase(0);
            //alert("Recording Ended 3");
            //CreateBroadcastSettings("recording", 0);
            //$("#lblRecording").text("Start Recording");
            //alert("Recording Ended 4");
          } else {
            $("#btnRecording").removeClass("start-record");
            if ($("#btnRecording").hasClass("start-record")) {
              $("#lblRecording").text(vm.$t("agoracall.stoprecording"));
            } else {
              $("#lblRecording").text(vm.$t("agoracall.startrecording"));
            }
            vm.recordingStarted = false;
            vm.setRecordingParamToFirebase(0);
          }
        })
        .catch((e) => {
          vm.recordingStartStopInProcess = false;
          console.log(e);
          //console.log("Error in Stop Recording: " + attendeeID);
          //alert("Error : Recording Ended");
          $("#btnRecording").addClass("start-record");
          //$("#btnRecording").toggleClass("start-record");
          if ($("#btnRecording").hasClass("start-record")) {
            $("#lblRecording").text(vm.$t("agoracall.stoprecording"));
          } else {
            $("#lblRecording").text(vm.$t("agoracall.startrecording"));
          }
        });
    },
  },
};
</script>